var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __esm = (fn, res) => function __init() {
  return fn && (res = (0, fn[__getOwnPropNames(fn)[0]])(fn = 0)), res;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// font-preview/font-previews.css
var init_font_previews = __esm({
  "font-preview/font-previews.css"() {
  }
});

// src/components/FontPreviews.tsx
var FontPreviews_exports = {};
__export(FontPreviews_exports, {
  default: () => FontPreviews_default
});
import { Fragment, jsx } from "react/jsx-runtime";
var FontPreviews, FontPreviews_default;
var init_FontPreviews = __esm({
  "src/components/FontPreviews.tsx"() {
    "use strict";
    init_font_previews();
    FontPreviews = ({ children }) => /* @__PURE__ */ jsx(Fragment, { children });
    FontPreviews_default = FontPreviews;
  }
});

// src/components/FontPicker.tsx
import { lazy, Suspense, useCallback, useEffect, useMemo, useRef, useState } from "react";

// font-preview/fontInfo.json
var fontInfo_default = [
  {
    category: "sans-serif",
    name: "42dot Sans",
    sane: "42dot_sans",
    variants: [
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800"
    ],
    subsets: [
      "korean",
      "latin"
    ]
  },
  {
    category: "sans-serif",
    name: "ABeeZee",
    sane: "abeezee",
    variants: [
      "0,400",
      "1,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Abel",
    sane: "abel",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "serif",
    name: "Abhaya Libre",
    sane: "abhaya_libre",
    variants: [
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "sinhala"
    ]
  },
  {
    category: "display",
    name: "Aboreto",
    sane: "aboreto",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Abril Fatface",
    sane: "abril_fatface",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Abyssinica SIL",
    sane: "abyssinica_sil",
    variants: [
      "0,400"
    ],
    subsets: [
      "ethiopic",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Aclonica",
    sane: "aclonica",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Acme",
    sane: "acme",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "sans-serif",
    name: "Actor",
    sane: "actor",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "serif",
    name: "Adamina",
    sane: "adamina",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "display",
    name: "ADLaM Display",
    sane: "adlam_display",
    variants: [
      "0,400"
    ],
    subsets: [
      "adlam",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Advent Pro",
    sane: "advent_pro",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900",
      "1,100",
      "1,200",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700",
      "1,800",
      "1,900"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "greek",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Afacad",
    sane: "afacad",
    variants: [
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "1,400",
      "1,500",
      "1,600",
      "1,700"
    ],
    subsets: [
      "cyrillic-ext",
      "latin",
      "latin-ext",
      "math",
      "symbols",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Afacad Flux",
    sane: "afacad_flux",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "Agbalumo",
    sane: "agbalumo",
    variants: [
      "0,400"
    ],
    subsets: [
      "cyrillic-ext",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Agdasima",
    sane: "agdasima",
    variants: [
      "0,400",
      "0,700"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Agu Display",
    sane: "agu_display",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "handwriting",
    name: "Aguafina Script",
    sane: "aguafina_script",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Akatab",
    sane: "akatab",
    variants: [
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "tifinagh"
    ]
  },
  {
    category: "display",
    name: "Akaya Kanadaka",
    sane: "akaya_kanadaka",
    variants: [
      "0,400"
    ],
    subsets: [
      "kannada",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Akaya Telivigala",
    sane: "akaya_telivigala",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "telugu"
    ]
  },
  {
    category: "display",
    name: "Akronim",
    sane: "akronim",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Akshar",
    sane: "akshar",
    variants: [
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    subsets: [
      "devanagari",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Aladin",
    sane: "aladin",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Alata",
    sane: "alata",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Alatsi",
    sane: "alatsi",
    variants: [
      "0,400"
    ],
    subsets: [
      "cyrillic-ext",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Albert Sans",
    sane: "albert_sans",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900",
      "1,100",
      "1,200",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700",
      "1,800",
      "1,900"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Aldrich",
    sane: "aldrich",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "sans-serif",
    name: "Alef",
    sane: "alef",
    variants: [
      "0,400",
      "0,700"
    ],
    subsets: [
      "hebrew",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Alegreya",
    sane: "alegreya",
    variants: [
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900",
      "1,400",
      "1,500",
      "1,600",
      "1,700",
      "1,800",
      "1,900"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "greek",
      "greek-ext",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Alegreya Sans",
    sane: "alegreya_sans",
    variants: [
      "0,100",
      "1,100",
      "0,300",
      "1,300",
      "0,400",
      "1,400",
      "0,500",
      "1,500",
      "0,700",
      "1,700",
      "0,800",
      "1,800",
      "0,900",
      "1,900"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "greek",
      "greek-ext",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Alegreya Sans SC",
    sane: "alegreya_sans_sc",
    variants: [
      "0,100",
      "1,100",
      "0,300",
      "1,300",
      "0,400",
      "1,400",
      "0,500",
      "1,500",
      "0,700",
      "1,700",
      "0,800",
      "1,800",
      "0,900",
      "1,900"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "greek",
      "greek-ext",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "serif",
    name: "Alegreya SC",
    sane: "alegreya_sc",
    variants: [
      "0,400",
      "1,400",
      "0,500",
      "1,500",
      "0,700",
      "1,700",
      "0,800",
      "1,800",
      "0,900",
      "1,900"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "greek",
      "greek-ext",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "serif",
    name: "Aleo",
    sane: "aleo",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900",
      "1,100",
      "1,200",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700",
      "1,800",
      "1,900"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "handwriting",
    name: "Alex Brush",
    sane: "alex_brush",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Alexandria",
    sane: "alexandria",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "arabic",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "Alfa Slab One",
    sane: "alfa_slab_one",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "serif",
    name: "Alice",
    sane: "alice",
    variants: [
      "0,400"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Alike",
    sane: "alike",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "math",
      "symbols"
    ]
  },
  {
    category: "serif",
    name: "Alike Angular",
    sane: "alike_angular",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "math",
      "symbols"
    ]
  },
  {
    category: "serif",
    name: "Alkalami",
    sane: "alkalami",
    variants: [
      "0,400"
    ],
    subsets: [
      "arabic",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Alkatra",
    sane: "alkatra",
    variants: [
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    subsets: [
      "bengali",
      "devanagari",
      "latin",
      "latin-ext",
      "oriya"
    ]
  },
  {
    category: "display",
    name: "Allan",
    sane: "allan",
    variants: [
      "0,400",
      "0,700"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Allerta",
    sane: "allerta",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "sans-serif",
    name: "Allerta Stencil",
    sane: "allerta_stencil",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Allison",
    sane: "allison",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "handwriting",
    name: "Allura",
    sane: "allura",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Almarai",
    sane: "almarai",
    variants: [
      "0,300",
      "0,400",
      "0,700",
      "0,800"
    ],
    subsets: [
      "arabic",
      "latin"
    ]
  },
  {
    category: "serif",
    name: "Almendra",
    sane: "almendra",
    variants: [
      "0,400",
      "1,400",
      "0,700",
      "1,700"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Almendra Display",
    sane: "almendra_display",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Almendra SC",
    sane: "almendra_sc",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "sans-serif",
    name: "Alumni Sans",
    sane: "alumni_sans",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900",
      "1,100",
      "1,200",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700",
      "1,800",
      "1,900"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Alumni Sans Collegiate One",
    sane: "alumni_sans_collegiate_one",
    variants: [
      "0,400",
      "1,400"
    ],
    subsets: [
      "cyrillic",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "Alumni Sans Inline One",
    sane: "alumni_sans_inline_one",
    variants: [
      "0,400",
      "1,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Alumni Sans Pinstripe",
    sane: "alumni_sans_pinstripe",
    variants: [
      "0,400",
      "1,400"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "Amarante",
    sane: "amarante",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Amaranth",
    sane: "amaranth",
    variants: [
      "0,400",
      "1,400",
      "0,700",
      "1,700"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Amatic SC",
    sane: "amatic_sc",
    variants: [
      "0,400",
      "0,700"
    ],
    subsets: [
      "cyrillic",
      "hebrew",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "serif",
    name: "Amethysta",
    sane: "amethysta",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "sans-serif",
    name: "Amiko",
    sane: "amiko",
    variants: [
      "0,400",
      "0,600",
      "0,700"
    ],
    subsets: [
      "devanagari",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Amiri",
    sane: "amiri",
    variants: [
      "0,400",
      "1,400",
      "0,700",
      "1,700"
    ],
    subsets: [
      "arabic",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Amiri Quran",
    sane: "amiri_quran",
    variants: [
      "0,400"
    ],
    subsets: [
      "arabic",
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Amita",
    sane: "amita",
    variants: [
      "0,400",
      "0,700"
    ],
    subsets: [
      "devanagari",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Anaheim",
    sane: "anaheim",
    variants: [
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "serif",
    name: "Andada Pro",
    sane: "andada_pro",
    variants: [
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "1,400",
      "1,500",
      "1,600",
      "1,700",
      "1,800"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Andika",
    sane: "andika",
    variants: [
      "0,400",
      "1,400",
      "0,700",
      "1,700"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Anek Bangla",
    sane: "anek_bangla",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800"
    ],
    subsets: [
      "bengali",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Anek Devanagari",
    sane: "anek_devanagari",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800"
    ],
    subsets: [
      "devanagari",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Anek Gujarati",
    sane: "anek_gujarati",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800"
    ],
    subsets: [
      "gujarati",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Anek Gurmukhi",
    sane: "anek_gurmukhi",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800"
    ],
    subsets: [
      "gurmukhi",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Anek Kannada",
    sane: "anek_kannada",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800"
    ],
    subsets: [
      "kannada",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Anek Latin",
    sane: "anek_latin",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Anek Malayalam",
    sane: "anek_malayalam",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "malayalam"
    ]
  },
  {
    category: "sans-serif",
    name: "Anek Odia",
    sane: "anek_odia",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "oriya"
    ]
  },
  {
    category: "sans-serif",
    name: "Anek Tamil",
    sane: "anek_tamil",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "tamil"
    ]
  },
  {
    category: "sans-serif",
    name: "Anek Telugu",
    sane: "anek_telugu",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "telugu"
    ]
  },
  {
    category: "display",
    name: "Angkor",
    sane: "angkor",
    variants: [
      "0,400"
    ],
    subsets: [
      "khmer",
      "latin"
    ]
  },
  {
    category: "serif",
    name: "Annapurna SIL",
    sane: "annapurna_sil",
    variants: [
      "0,400",
      "0,700"
    ],
    subsets: [
      "devanagari",
      "latin",
      "latin-ext",
      "math",
      "symbols"
    ]
  },
  {
    category: "handwriting",
    name: "Annie Use Your Telescope",
    sane: "annie_use_your_telescope",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "monospace",
    name: "Anonymous Pro",
    sane: "anonymous_pro",
    variants: [
      "0,400",
      "1,400",
      "0,700",
      "1,700"
    ],
    subsets: [
      "cyrillic",
      "greek",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Anta",
    sane: "anta",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "math",
      "symbols"
    ]
  },
  {
    category: "sans-serif",
    name: "Antic",
    sane: "antic",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "serif",
    name: "Antic Didone",
    sane: "antic_didone",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "serif",
    name: "Antic Slab",
    sane: "antic_slab",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "sans-serif",
    name: "Anton",
    sane: "anton",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Anton SC",
    sane: "anton_sc",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Antonio",
    sane: "antonio",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Anuphan",
    sane: "anuphan",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "thai",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "Anybody",
    sane: "anybody",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900",
      "1,100",
      "1,200",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700",
      "1,800",
      "1,900"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "serif",
    name: "Aoboshi One",
    sane: "aoboshi_one",
    variants: [
      "0,400"
    ],
    subsets: [
      "japanese",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "AR One Sans",
    sane: "ar_one_sans",
    variants: [
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "serif",
    name: "Arapey",
    sane: "arapey",
    variants: [
      "0,400",
      "1,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "serif",
    name: "Arbutus",
    sane: "arbutus",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Arbutus Slab",
    sane: "arbutus_slab",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "handwriting",
    name: "Architects Daughter",
    sane: "architects_daughter",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Archivo",
    sane: "archivo",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900",
      "1,100",
      "1,200",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700",
      "1,800",
      "1,900"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Archivo Black",
    sane: "archivo_black",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Archivo Narrow",
    sane: "archivo_narrow",
    variants: [
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "1,400",
      "1,500",
      "1,600",
      "1,700"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "handwriting",
    name: "Are You Serious",
    sane: "are_you_serious",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "serif",
    name: "Aref Ruqaa",
    sane: "aref_ruqaa",
    variants: [
      "0,400",
      "0,700"
    ],
    subsets: [
      "arabic",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Aref Ruqaa Ink",
    sane: "aref_ruqaa_ink",
    variants: [
      "0,400",
      "0,700"
    ],
    subsets: [
      "arabic",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Arima",
    sane: "arima",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    subsets: [
      "greek",
      "greek-ext",
      "latin",
      "latin-ext",
      "malayalam",
      "tamil",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Arimo",
    sane: "arimo",
    variants: [
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "1,400",
      "1,500",
      "1,600",
      "1,700"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "greek",
      "greek-ext",
      "hebrew",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "handwriting",
    name: "Arizonia",
    sane: "arizonia",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Armata",
    sane: "armata",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Arsenal",
    sane: "arsenal",
    variants: [
      "0,400",
      "1,400",
      "0,700",
      "1,700"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Arsenal SC",
    sane: "arsenal_sc",
    variants: [
      "0,400",
      "1,400",
      "0,700",
      "1,700"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "serif",
    name: "Artifika",
    sane: "artifika",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "serif",
    name: "Arvo",
    sane: "arvo",
    variants: [
      "0,400",
      "1,400",
      "0,700",
      "1,700"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "sans-serif",
    name: "Arya",
    sane: "arya",
    variants: [
      "0,400",
      "0,700"
    ],
    subsets: [
      "devanagari",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Asap",
    sane: "asap",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900",
      "1,100",
      "1,200",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700",
      "1,800",
      "1,900"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Asap Condensed",
    sane: "asap_condensed",
    variants: [
      "0,200",
      "1,200",
      "0,300",
      "1,300",
      "0,400",
      "1,400",
      "0,500",
      "1,500",
      "0,600",
      "1,600",
      "0,700",
      "1,700",
      "0,800",
      "1,800",
      "0,900",
      "1,900"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "serif",
    name: "Asar",
    sane: "asar",
    variants: [
      "0,400"
    ],
    subsets: [
      "devanagari",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Asset",
    sane: "asset",
    variants: [
      "0,400"
    ],
    subsets: [
      "cyrillic-ext",
      "latin",
      "latin-ext",
      "math",
      "symbols"
    ]
  },
  {
    category: "sans-serif",
    name: "Assistant",
    sane: "assistant",
    variants: [
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800"
    ],
    subsets: [
      "hebrew",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Astloch",
    sane: "astloch",
    variants: [
      "0,400",
      "0,700"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "sans-serif",
    name: "Asul",
    sane: "asul",
    variants: [
      "0,400",
      "0,700"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "sans-serif",
    name: "Athiti",
    sane: "athiti",
    variants: [
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "thai",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Atkinson Hyperlegible",
    sane: "atkinson_hyperlegible",
    variants: [
      "0,400",
      "1,400",
      "0,700",
      "1,700"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Atma",
    sane: "atma",
    variants: [
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    subsets: [
      "bengali",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Atomic Age",
    sane: "atomic_age",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Aubrey",
    sane: "aubrey",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "display",
    name: "Audiowide",
    sane: "audiowide",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Autour One",
    sane: "autour_one",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Average",
    sane: "average",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Average Sans",
    sane: "average_sans",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Averia Gruesa Libre",
    sane: "averia_gruesa_libre",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Averia Libre",
    sane: "averia_libre",
    variants: [
      "0,300",
      "1,300",
      "0,400",
      "1,400",
      "0,700",
      "1,700"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "display",
    name: "Averia Sans Libre",
    sane: "averia_sans_libre",
    variants: [
      "0,300",
      "1,300",
      "0,400",
      "1,400",
      "0,700",
      "1,700"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "display",
    name: "Averia Serif Libre",
    sane: "averia_serif_libre",
    variants: [
      "0,300",
      "1,300",
      "0,400",
      "1,400",
      "0,700",
      "1,700"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "monospace",
    name: "Azeret Mono",
    sane: "azeret_mono",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900",
      "1,100",
      "1,200",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700",
      "1,800",
      "1,900"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "B612",
    sane: "b612",
    variants: [
      "0,400",
      "1,400",
      "0,700",
      "1,700"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "monospace",
    name: "B612 Mono",
    sane: "b612_mono",
    variants: [
      "0,400",
      "1,400",
      "0,700",
      "1,700"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Babylonica",
    sane: "babylonica",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "serif",
    name: "Bacasime Antique",
    sane: "bacasime_antique",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "handwriting",
    name: "Bad Script",
    sane: "bad_script",
    variants: [
      "0,400"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "Badeen Display",
    sane: "badeen_display",
    variants: [
      "0,400"
    ],
    subsets: [
      "arabic",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Bagel Fat One",
    sane: "bagel_fat_one",
    variants: [
      "0,400"
    ],
    subsets: [
      "korean",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Bahiana",
    sane: "bahiana",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Bahianita",
    sane: "bahianita",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Bai Jamjuree",
    sane: "bai_jamjuree",
    variants: [
      "0,200",
      "1,200",
      "0,300",
      "1,300",
      "0,400",
      "1,400",
      "0,500",
      "1,500",
      "0,600",
      "1,600",
      "0,700",
      "1,700"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "thai",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "Bakbak One",
    sane: "bakbak_one",
    variants: [
      "0,400"
    ],
    subsets: [
      "devanagari",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "handwriting",
    name: "Ballet",
    sane: "ballet",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "Baloo 2",
    sane: "baloo_2",
    variants: [
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800"
    ],
    subsets: [
      "devanagari",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "Baloo Bhai 2",
    sane: "baloo_bhai_2",
    variants: [
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800"
    ],
    subsets: [
      "gujarati",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "Baloo Bhaijaan 2",
    sane: "baloo_bhaijaan_2",
    variants: [
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800"
    ],
    subsets: [
      "arabic",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "Baloo Bhaina 2",
    sane: "baloo_bhaina_2",
    variants: [
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "oriya",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "Baloo Chettan 2",
    sane: "baloo_chettan_2",
    variants: [
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "malayalam",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "Baloo Da 2",
    sane: "baloo_da_2",
    variants: [
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800"
    ],
    subsets: [
      "bengali",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "Baloo Paaji 2",
    sane: "baloo_paaji_2",
    variants: [
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800"
    ],
    subsets: [
      "gurmukhi",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "Baloo Tamma 2",
    sane: "baloo_tamma_2",
    variants: [
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800"
    ],
    subsets: [
      "kannada",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "Baloo Tammudu 2",
    sane: "baloo_tammudu_2",
    variants: [
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "telugu",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "Baloo Thambi 2",
    sane: "baloo_thambi_2",
    variants: [
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "tamil",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "Balsamiq Sans",
    sane: "balsamiq_sans",
    variants: [
      "0,400",
      "1,400",
      "0,700",
      "1,700"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Balthazar",
    sane: "balthazar",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "display",
    name: "Bangers",
    sane: "bangers",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Barlow",
    sane: "barlow",
    variants: [
      "0,100",
      "1,100",
      "0,200",
      "1,200",
      "0,300",
      "1,300",
      "0,400",
      "1,400",
      "0,500",
      "1,500",
      "0,600",
      "1,600",
      "0,700",
      "1,700",
      "0,800",
      "1,800",
      "0,900",
      "1,900"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Barlow Condensed",
    sane: "barlow_condensed",
    variants: [
      "0,100",
      "1,100",
      "0,200",
      "1,200",
      "0,300",
      "1,300",
      "0,400",
      "1,400",
      "0,500",
      "1,500",
      "0,600",
      "1,600",
      "0,700",
      "1,700",
      "0,800",
      "1,800",
      "0,900",
      "1,900"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Barlow Semi Condensed",
    sane: "barlow_semi_condensed",
    variants: [
      "0,100",
      "1,100",
      "0,200",
      "1,200",
      "0,300",
      "1,300",
      "0,400",
      "1,400",
      "0,500",
      "1,500",
      "0,600",
      "1,600",
      "0,700",
      "1,700",
      "0,800",
      "1,800",
      "0,900",
      "1,900"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "Barriecito",
    sane: "barriecito",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "Barrio",
    sane: "barrio",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Basic",
    sane: "basic",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Baskervville",
    sane: "baskervville",
    variants: [
      "0,400",
      "1,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Baskervville SC",
    sane: "baskervville_sc",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Battambang",
    sane: "battambang",
    variants: [
      "0,100",
      "0,300",
      "0,400",
      "0,700",
      "0,900"
    ],
    subsets: [
      "khmer",
      "latin"
    ]
  },
  {
    category: "display",
    name: "Baumans",
    sane: "baumans",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "sans-serif",
    name: "Bayon",
    sane: "bayon",
    variants: [
      "0,400"
    ],
    subsets: [
      "khmer",
      "latin"
    ]
  },
  {
    category: "sans-serif",
    name: "Be Vietnam Pro",
    sane: "be_vietnam_pro",
    variants: [
      "0,100",
      "1,100",
      "0,200",
      "1,200",
      "0,300",
      "1,300",
      "0,400",
      "1,400",
      "0,500",
      "1,500",
      "0,600",
      "1,600",
      "0,700",
      "1,700",
      "0,800",
      "1,800",
      "0,900",
      "1,900"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "handwriting",
    name: "Beau Rivage",
    sane: "beau_rivage",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Bebas Neue",
    sane: "bebas_neue",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Beiruti",
    sane: "beiruti",
    variants: [
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "arabic",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Belanosima",
    sane: "belanosima",
    variants: [
      "0,400",
      "0,600",
      "0,700"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Belgrano",
    sane: "belgrano",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "serif",
    name: "Bellefair",
    sane: "bellefair",
    variants: [
      "0,400"
    ],
    subsets: [
      "hebrew",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Belleza",
    sane: "belleza",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Bellota",
    sane: "bellota",
    variants: [
      "0,300",
      "1,300",
      "0,400",
      "1,400",
      "0,700",
      "1,700"
    ],
    subsets: [
      "cyrillic",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "Bellota Text",
    sane: "bellota_text",
    variants: [
      "0,300",
      "1,300",
      "0,400",
      "1,400",
      "0,700",
      "1,700"
    ],
    subsets: [
      "cyrillic",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "BenchNine",
    sane: "benchnine",
    variants: [
      "0,300",
      "0,400",
      "0,700"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Benne",
    sane: "benne",
    variants: [
      "0,400"
    ],
    subsets: [
      "kannada",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Bentham",
    sane: "bentham",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "handwriting",
    name: "Berkshire Swash",
    sane: "berkshire_swash",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Besley",
    sane: "besley",
    variants: [
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900",
      "1,400",
      "1,500",
      "1,600",
      "1,700",
      "1,800",
      "1,900"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "handwriting",
    name: "Beth Ellen",
    sane: "beth_ellen",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "serif",
    name: "Bevan",
    sane: "bevan",
    variants: [
      "0,400",
      "1,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "serif",
    name: "BhuTuka Expanded One",
    sane: "bhutuka_expanded_one",
    variants: [
      "0,400"
    ],
    subsets: [
      "gurmukhi",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Big Shoulders Display",
    sane: "big_shoulders_display",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "Big Shoulders Inline Display",
    sane: "big_shoulders_inline_display",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "Big Shoulders Inline Text",
    sane: "big_shoulders_inline_text",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "Big Shoulders Stencil Display",
    sane: "big_shoulders_stencil_display",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "Big Shoulders Stencil Text",
    sane: "big_shoulders_stencil_text",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "Big Shoulders Text",
    sane: "big_shoulders_text",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "Bigelow Rules",
    sane: "bigelow_rules",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Bigshot One",
    sane: "bigshot_one",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Bilbo",
    sane: "bilbo",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "handwriting",
    name: "Bilbo Swash Caps",
    sane: "bilbo_swash_caps",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "BioRhyme",
    sane: "biorhyme",
    variants: [
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "BioRhyme Expanded",
    sane: "biorhyme_expanded",
    variants: [
      "0,200",
      "0,300",
      "0,400",
      "0,700",
      "0,800"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "handwriting",
    name: "Birthstone",
    sane: "birthstone",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "handwriting",
    name: "Birthstone Bounce",
    sane: "birthstone_bounce",
    variants: [
      "0,400",
      "0,500"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Biryani",
    sane: "biryani",
    variants: [
      "0,200",
      "0,300",
      "0,400",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "devanagari",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Bitter",
    sane: "bitter",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900",
      "1,100",
      "1,200",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700",
      "1,800",
      "1,900"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "BIZ UDGothic",
    sane: "biz_udgothic",
    variants: [
      "0,400",
      "0,700"
    ],
    subsets: [
      "cyrillic",
      "greek-ext",
      "japanese",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "BIZ UDMincho",
    sane: "biz_udmincho",
    variants: [
      "0,400",
      "0,700"
    ],
    subsets: [
      "cyrillic",
      "greek-ext",
      "japanese",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "BIZ UDPGothic",
    sane: "biz_udpgothic",
    variants: [
      "0,400",
      "0,700"
    ],
    subsets: [
      "cyrillic",
      "greek-ext",
      "japanese",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "BIZ UDPMincho",
    sane: "biz_udpmincho",
    variants: [
      "0,400",
      "0,700"
    ],
    subsets: [
      "cyrillic",
      "greek-ext",
      "japanese",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Black And White Picture",
    sane: "black_and_white_picture",
    variants: [
      "0,400"
    ],
    subsets: [
      "korean",
      "latin"
    ]
  },
  {
    category: "sans-serif",
    name: "Black Han Sans",
    sane: "black_han_sans",
    variants: [
      "0,400"
    ],
    subsets: [
      "korean",
      "latin"
    ]
  },
  {
    category: "display",
    name: "Black Ops One",
    sane: "black_ops_one",
    variants: [
      "0,400"
    ],
    subsets: [
      "cyrillic-ext",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "Blaka",
    sane: "blaka",
    variants: [
      "0,400"
    ],
    subsets: [
      "arabic",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Blaka Hollow",
    sane: "blaka_hollow",
    variants: [
      "0,400"
    ],
    subsets: [
      "arabic",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Blaka Ink",
    sane: "blaka_ink",
    variants: [
      "0,400"
    ],
    subsets: [
      "arabic",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Blinker",
    sane: "blinker",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Bodoni Moda",
    sane: "bodoni_moda",
    variants: [
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900",
      "1,400",
      "1,500",
      "1,600",
      "1,700",
      "1,800",
      "1,900"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "math",
      "symbols"
    ]
  },
  {
    category: "serif",
    name: "Bodoni Moda SC",
    sane: "bodoni_moda_sc",
    variants: [
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900",
      "1,400",
      "1,500",
      "1,600",
      "1,700",
      "1,800",
      "1,900"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "math",
      "symbols"
    ]
  },
  {
    category: "display",
    name: "Bokor",
    sane: "bokor",
    variants: [
      "0,400"
    ],
    subsets: [
      "khmer",
      "latin"
    ]
  },
  {
    category: "serif",
    name: "Bona Nova",
    sane: "bona_nova",
    variants: [
      "0,400",
      "1,400",
      "0,700"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "greek",
      "hebrew",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "serif",
    name: "Bona Nova SC",
    sane: "bona_nova_sc",
    variants: [
      "0,400",
      "1,400",
      "0,700"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "greek",
      "hebrew",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "handwriting",
    name: "Bonbon",
    sane: "bonbon",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Bonheur Royale",
    sane: "bonheur_royale",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "Boogaloo",
    sane: "boogaloo",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Borel",
    sane: "borel",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "math",
      "symbols",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "Bowlby One",
    sane: "bowlby_one",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "display",
    name: "Bowlby One SC",
    sane: "bowlby_one_sc",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Braah One",
    sane: "braah_one",
    variants: [
      "0,400"
    ],
    subsets: [
      "gurmukhi",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "serif",
    name: "Brawler",
    sane: "brawler",
    variants: [
      "0,400",
      "0,700"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "serif",
    name: "Bree Serif",
    sane: "bree_serif",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Bricolage Grotesque",
    sane: "bricolage_grotesque",
    variants: [
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "Bruno Ace",
    sane: "bruno_ace",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Bruno Ace SC",
    sane: "bruno_ace_sc",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Brygada 1918",
    sane: "brygada_1918",
    variants: [
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "1,400",
      "1,500",
      "1,600",
      "1,700"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "greek",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "Bubblegum Sans",
    sane: "bubblegum_sans",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Bubbler One",
    sane: "bubbler_one",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Buda",
    sane: "buda",
    variants: [
      "0,300"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "serif",
    name: "Buenard",
    sane: "buenard",
    variants: [
      "0,400",
      "0,700"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Bungee",
    sane: "bungee",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "Bungee Hairline",
    sane: "bungee_hairline",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "Bungee Inline",
    sane: "bungee_inline",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "Bungee Outline",
    sane: "bungee_outline",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "Bungee Shade",
    sane: "bungee_shade",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "Bungee Spice",
    sane: "bungee_spice",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "Bungee Tint",
    sane: "bungee_tint",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "Butcherman",
    sane: "butcherman",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "handwriting",
    name: "Butterfly Kids",
    sane: "butterfly_kids",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Cabin",
    sane: "cabin",
    variants: [
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "1,400",
      "1,500",
      "1,600",
      "1,700"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Cabin Condensed",
    sane: "cabin_condensed",
    variants: [
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "Cabin Sketch",
    sane: "cabin_sketch",
    variants: [
      "0,400",
      "0,700"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "serif",
    name: "Cactus Classical Serif",
    sane: "cactus_classical_serif",
    variants: [
      "0,400"
    ],
    subsets: [
      "chinese-hongkong",
      "cyrillic",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "Caesar Dressing",
    sane: "caesar_dressing",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "sans-serif",
    name: "Cagliostro",
    sane: "cagliostro",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "sans-serif",
    name: "Cairo",
    sane: "cairo",
    variants: [
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "arabic",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Cairo Play",
    sane: "cairo_play",
    variants: [
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "arabic",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Caladea",
    sane: "caladea",
    variants: [
      "0,400",
      "1,400",
      "0,700",
      "1,700"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Calistoga",
    sane: "calistoga",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "handwriting",
    name: "Calligraffitti",
    sane: "calligraffitti",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "sans-serif",
    name: "Cambay",
    sane: "cambay",
    variants: [
      "0,400",
      "1,400",
      "0,700",
      "1,700"
    ],
    subsets: [
      "devanagari",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Cambo",
    sane: "cambo",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Candal",
    sane: "candal",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "sans-serif",
    name: "Cantarell",
    sane: "cantarell",
    variants: [
      "0,400",
      "1,400",
      "0,700",
      "1,700"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Cantata One",
    sane: "cantata_one",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Cantora One",
    sane: "cantora_one",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Caprasimo",
    sane: "caprasimo",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Capriola",
    sane: "capriola",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "handwriting",
    name: "Caramel",
    sane: "caramel",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "handwriting",
    name: "Carattere",
    sane: "carattere",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "serif",
    name: "Cardo",
    sane: "cardo",
    variants: [
      "0,400",
      "1,400",
      "0,700"
    ],
    subsets: [
      "greek",
      "greek-ext",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Carlito",
    sane: "carlito",
    variants: [
      "0,400",
      "1,400",
      "0,700",
      "1,700"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "greek",
      "greek-ext",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Carme",
    sane: "carme",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "sans-serif",
    name: "Carrois Gothic",
    sane: "carrois_gothic",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "sans-serif",
    name: "Carrois Gothic SC",
    sane: "carrois_gothic_sc",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "display",
    name: "Carter One",
    sane: "carter_one",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "serif",
    name: "Castoro",
    sane: "castoro",
    variants: [
      "0,400",
      "1,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Castoro Titling",
    sane: "castoro_titling",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Catamaran",
    sane: "catamaran",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "tamil"
    ]
  },
  {
    category: "serif",
    name: "Caudex",
    sane: "caudex",
    variants: [
      "0,400",
      "1,400",
      "0,700",
      "1,700"
    ],
    subsets: [
      "greek",
      "greek-ext",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "handwriting",
    name: "Caveat",
    sane: "caveat",
    variants: [
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "handwriting",
    name: "Caveat Brush",
    sane: "caveat_brush",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "handwriting",
    name: "Cedarville Cursive",
    sane: "cedarville_cursive",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "display",
    name: "Ceviche One",
    sane: "ceviche_one",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Chakra Petch",
    sane: "chakra_petch",
    variants: [
      "0,300",
      "1,300",
      "0,400",
      "1,400",
      "0,500",
      "1,500",
      "0,600",
      "1,600",
      "0,700",
      "1,700"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "thai",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Changa",
    sane: "changa",
    variants: [
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800"
    ],
    subsets: [
      "arabic",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Changa One",
    sane: "changa_one",
    variants: [
      "0,400",
      "1,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "display",
    name: "Chango",
    sane: "chango",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Charis SIL",
    sane: "charis_sil",
    variants: [
      "0,400",
      "1,400",
      "0,700",
      "1,700"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "handwriting",
    name: "Charm",
    sane: "charm",
    variants: [
      "0,400",
      "0,700"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "thai",
      "vietnamese"
    ]
  },
  {
    category: "handwriting",
    name: "Charmonman",
    sane: "charmonman",
    variants: [
      "0,400",
      "0,700"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "thai",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Chathura",
    sane: "chathura",
    variants: [
      "0,100",
      "0,300",
      "0,400",
      "0,700",
      "0,800"
    ],
    subsets: [
      "latin",
      "telugu"
    ]
  },
  {
    category: "sans-serif",
    name: "Chau Philomene One",
    sane: "chau_philomene_one",
    variants: [
      "0,400",
      "1,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Chela One",
    sane: "chela_one",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Chelsea Market",
    sane: "chelsea_market",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "handwriting",
    name: "Cherish",
    sane: "cherish",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "Cherry Bomb One",
    sane: "cherry_bomb_one",
    variants: [
      "0,400"
    ],
    subsets: [
      "japanese",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "Cherry Cream Soda",
    sane: "cherry_cream_soda",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "display",
    name: "Cherry Swash",
    sane: "cherry_swash",
    variants: [
      "0,400",
      "0,700"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Chewy",
    sane: "chewy",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "display",
    name: "Chicle",
    sane: "chicle",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "handwriting",
    name: "Chilanka",
    sane: "chilanka",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "malayalam"
    ]
  },
  {
    category: "sans-serif",
    name: "Chivo",
    sane: "chivo",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900",
      "1,100",
      "1,200",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700",
      "1,800",
      "1,900"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "monospace",
    name: "Chivo Mono",
    sane: "chivo_mono",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900",
      "1,100",
      "1,200",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700",
      "1,800",
      "1,900"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Chocolate Classical Sans",
    sane: "chocolate_classical_sans",
    variants: [
      "0,400"
    ],
    subsets: [
      "chinese-hongkong",
      "cyrillic",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "Chokokutai",
    sane: "chokokutai",
    variants: [
      "0,400"
    ],
    subsets: [
      "japanese",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "Chonburi",
    sane: "chonburi",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "thai",
      "vietnamese"
    ]
  },
  {
    category: "serif",
    name: "Cinzel",
    sane: "cinzel",
    variants: [
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Cinzel Decorative",
    sane: "cinzel_decorative",
    variants: [
      "0,400",
      "0,700",
      "0,900"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "handwriting",
    name: "Clicker Script",
    sane: "clicker_script",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Climate Crisis",
    sane: "climate_crisis",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Coda",
    sane: "coda",
    variants: [
      "0,400",
      "0,800"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Codystar",
    sane: "codystar",
    variants: [
      "0,300",
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Coiny",
    sane: "coiny",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "tamil",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "Combo",
    sane: "combo",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Comfortaa",
    sane: "comfortaa",
    variants: [
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "greek",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "handwriting",
    name: "Comforter",
    sane: "comforter",
    variants: [
      "0,400"
    ],
    subsets: [
      "cyrillic",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "handwriting",
    name: "Comforter Brush",
    sane: "comforter_brush",
    variants: [
      "0,400"
    ],
    subsets: [
      "cyrillic",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "handwriting",
    name: "Comic Neue",
    sane: "comic_neue",
    variants: [
      "0,300",
      "1,300",
      "0,400",
      "1,400",
      "0,700",
      "1,700"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Coming Soon",
    sane: "coming_soon",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "sans-serif",
    name: "Comme",
    sane: "comme",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Commissioner",
    sane: "commissioner",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "greek",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "Concert One",
    sane: "concert_one",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "handwriting",
    name: "Condiment",
    sane: "condiment",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Contrail One",
    sane: "contrail_one",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "sans-serif",
    name: "Convergence",
    sane: "convergence",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "handwriting",
    name: "Cookie",
    sane: "cookie",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "serif",
    name: "Copse",
    sane: "copse",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "display",
    name: "Corben",
    sane: "corben",
    variants: [
      "0,400",
      "0,700"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "handwriting",
    name: "Corinthia",
    sane: "corinthia",
    variants: [
      "0,400",
      "0,700"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "serif",
    name: "Cormorant",
    sane: "cormorant",
    variants: [
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "serif",
    name: "Cormorant Garamond",
    sane: "cormorant_garamond",
    variants: [
      "0,300",
      "1,300",
      "0,400",
      "1,400",
      "0,500",
      "1,500",
      "0,600",
      "1,600",
      "0,700",
      "1,700"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "serif",
    name: "Cormorant Infant",
    sane: "cormorant_infant",
    variants: [
      "0,300",
      "1,300",
      "0,400",
      "1,400",
      "0,500",
      "1,500",
      "0,600",
      "1,600",
      "0,700",
      "1,700"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "serif",
    name: "Cormorant SC",
    sane: "cormorant_sc",
    variants: [
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "serif",
    name: "Cormorant Unicase",
    sane: "cormorant_unicase",
    variants: [
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "serif",
    name: "Cormorant Upright",
    sane: "cormorant_upright",
    variants: [
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "handwriting",
    name: "Courgette",
    sane: "courgette",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "monospace",
    name: "Courier Prime",
    sane: "courier_prime",
    variants: [
      "0,400",
      "1,400",
      "0,700",
      "1,700"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "monospace",
    name: "Cousine",
    sane: "cousine",
    variants: [
      "0,400",
      "1,400",
      "0,700",
      "1,700"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "greek",
      "greek-ext",
      "hebrew",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "serif",
    name: "Coustard",
    sane: "coustard",
    variants: [
      "0,400",
      "0,900"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Covered By Your Grace",
    sane: "covered_by_your_grace",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "handwriting",
    name: "Crafty Girls",
    sane: "crafty_girls",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "display",
    name: "Creepster",
    sane: "creepster",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "serif",
    name: "Crete Round",
    sane: "crete_round",
    variants: [
      "0,400",
      "1,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Crimson Pro",
    sane: "crimson_pro",
    variants: [
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900",
      "1,200",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700",
      "1,800",
      "1,900"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "serif",
    name: "Crimson Text",
    sane: "crimson_text",
    variants: [
      "0,400",
      "1,400",
      "0,600",
      "1,600",
      "0,700",
      "1,700"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "Croissant One",
    sane: "croissant_one",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Crushed",
    sane: "crushed",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Cuprum",
    sane: "cuprum",
    variants: [
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "1,400",
      "1,500",
      "1,600",
      "1,700"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "Cute Font",
    sane: "cute_font",
    variants: [
      "0,400"
    ],
    subsets: [
      "korean",
      "latin"
    ]
  },
  {
    category: "serif",
    name: "Cutive",
    sane: "cutive",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "monospace",
    name: "Cutive Mono",
    sane: "cutive_mono",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Dai Banna SIL",
    sane: "dai_banna_sil",
    variants: [
      "0,300",
      "1,300",
      "0,400",
      "1,400",
      "0,500",
      "1,500",
      "0,600",
      "1,600",
      "0,700",
      "1,700"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "new-tai-lue"
    ]
  },
  {
    category: "handwriting",
    name: "Damion",
    sane: "damion",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "handwriting",
    name: "Dancing Script",
    sane: "dancing_script",
    variants: [
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "serif",
    name: "Danfo",
    sane: "danfo",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "Dangrek",
    sane: "dangrek",
    variants: [
      "0,400"
    ],
    subsets: [
      "khmer",
      "latin"
    ]
  },
  {
    category: "sans-serif",
    name: "Darker Grotesque",
    sane: "darker_grotesque",
    variants: [
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "Darumadrop One",
    sane: "darumadrop_one",
    variants: [
      "0,400"
    ],
    subsets: [
      "japanese",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "David Libre",
    sane: "david_libre",
    variants: [
      "0,400",
      "0,500",
      "0,700"
    ],
    subsets: [
      "hebrew",
      "latin",
      "latin-ext",
      "math",
      "symbols",
      "vietnamese"
    ]
  },
  {
    category: "handwriting",
    name: "Dawning of a New Day",
    sane: "dawning_of_a_new_day",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "sans-serif",
    name: "Days One",
    sane: "days_one",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Dekko",
    sane: "dekko",
    variants: [
      "0,400"
    ],
    subsets: [
      "devanagari",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Dela Gothic One",
    sane: "dela_gothic_one",
    variants: [
      "0,400"
    ],
    subsets: [
      "cyrillic",
      "greek",
      "japanese",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "handwriting",
    name: "Delicious Handrawn",
    sane: "delicious_handrawn",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "handwriting",
    name: "Delius",
    sane: "delius",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Delius Swash Caps",
    sane: "delius_swash_caps",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Delius Unicase",
    sane: "delius_unicase",
    variants: [
      "0,400",
      "0,700"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "serif",
    name: "Della Respira",
    sane: "della_respira",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "sans-serif",
    name: "Denk One",
    sane: "denk_one",
    variants: [
      "0,400"
    ],
    subsets: [
      "cyrillic-ext",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "handwriting",
    name: "Devonshire",
    sane: "devonshire",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Dhurjati",
    sane: "dhurjati",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "telugu"
    ]
  },
  {
    category: "sans-serif",
    name: "Didact Gothic",
    sane: "didact_gothic",
    variants: [
      "0,400"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "greek",
      "greek-ext",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Diphylleia",
    sane: "diphylleia",
    variants: [
      "0,400"
    ],
    subsets: [
      "korean",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Diplomata",
    sane: "diplomata",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Diplomata SC",
    sane: "diplomata_sc",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "monospace",
    name: "DM Mono",
    sane: "dm_mono",
    variants: [
      "0,300",
      "1,300",
      "0,400",
      "1,400",
      "0,500",
      "1,500"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "DM Sans",
    sane: "dm_sans",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900",
      "1,100",
      "1,200",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700",
      "1,800",
      "1,900"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "DM Serif Display",
    sane: "dm_serif_display",
    variants: [
      "0,400",
      "1,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "DM Serif Text",
    sane: "dm_serif_text",
    variants: [
      "0,400",
      "1,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Do Hyeon",
    sane: "do_hyeon",
    variants: [
      "0,400"
    ],
    subsets: [
      "korean",
      "latin"
    ]
  },
  {
    category: "display",
    name: "Dokdo",
    sane: "dokdo",
    variants: [
      "0,400"
    ],
    subsets: [
      "korean",
      "latin"
    ]
  },
  {
    category: "serif",
    name: "Domine",
    sane: "domine",
    variants: [
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Donegal One",
    sane: "donegal_one",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Dongle",
    sane: "dongle",
    variants: [
      "0,300",
      "0,400",
      "0,700"
    ],
    subsets: [
      "korean",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Doppio One",
    sane: "doppio_one",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Dorsa",
    sane: "dorsa",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "sans-serif",
    name: "Dosis",
    sane: "dosis",
    variants: [
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "DotGothic16",
    sane: "dotgothic16",
    variants: [
      "0,400"
    ],
    subsets: [
      "cyrillic",
      "japanese",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Doto",
    sane: "doto",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "handwriting",
    name: "Dr Sugiyama",
    sane: "dr_sugiyama",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Duru Sans",
    sane: "duru_sans",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Dynalight",
    sane: "dynalight",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "DynaPuff",
    sane: "dynapuff",
    variants: [
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    subsets: [
      "cyrillic-ext",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "handwriting",
    name: "Eagle Lake",
    sane: "eagle_lake",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "handwriting",
    name: "East Sea Dokdo",
    sane: "east_sea_dokdo",
    variants: [
      "0,400"
    ],
    subsets: [
      "korean",
      "latin"
    ]
  },
  {
    category: "display",
    name: "Eater",
    sane: "eater",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "EB Garamond",
    sane: "eb_garamond",
    variants: [
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "1,400",
      "1,500",
      "1,600",
      "1,700",
      "1,800"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "greek",
      "greek-ext",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Economica",
    sane: "economica",
    variants: [
      "0,400",
      "1,400",
      "0,700",
      "1,700"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Eczar",
    sane: "eczar",
    variants: [
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800"
    ],
    subsets: [
      "devanagari",
      "greek",
      "greek-ext",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "handwriting",
    name: "Edu AU VIC WA NT Arrows",
    sane: "edu_au_vic_wa_nt_arrows",
    variants: [
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "handwriting",
    name: "Edu AU VIC WA NT Dots",
    sane: "edu_au_vic_wa_nt_dots",
    variants: [
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "handwriting",
    name: "Edu AU VIC WA NT Guides",
    sane: "edu_au_vic_wa_nt_guides",
    variants: [
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "handwriting",
    name: "Edu AU VIC WA NT Hand",
    sane: "edu_au_vic_wa_nt_hand",
    variants: [
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "handwriting",
    name: "Edu AU VIC WA NT Pre",
    sane: "edu_au_vic_wa_nt_pre",
    variants: [
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "handwriting",
    name: "Edu NSW ACT Foundation",
    sane: "edu_nsw_act_foundation",
    variants: [
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Edu QLD Beginner",
    sane: "edu_qld_beginner",
    variants: [
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Edu SA Beginner",
    sane: "edu_sa_beginner",
    variants: [
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Edu TAS Beginner",
    sane: "edu_tas_beginner",
    variants: [
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Edu VIC WA NT Beginner",
    sane: "edu_vic_wa_nt_beginner",
    variants: [
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "sans-serif",
    name: "El Messiri",
    sane: "el_messiri",
    variants: [
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    subsets: [
      "arabic",
      "cyrillic",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Electrolize",
    sane: "electrolize",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "display",
    name: "Elsie",
    sane: "elsie",
    variants: [
      "0,400",
      "0,900"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Elsie Swash Caps",
    sane: "elsie_swash_caps",
    variants: [
      "0,400",
      "0,900"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Emblema One",
    sane: "emblema_one",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Emilys Candy",
    sane: "emilys_candy",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Encode Sans",
    sane: "encode_sans",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Encode Sans Condensed",
    sane: "encode_sans_condensed",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Encode Sans Expanded",
    sane: "encode_sans_expanded",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Encode Sans SC",
    sane: "encode_sans_sc",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Encode Sans Semi Condensed",
    sane: "encode_sans_semi_condensed",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Encode Sans Semi Expanded",
    sane: "encode_sans_semi_expanded",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "handwriting",
    name: "Engagement",
    sane: "engagement",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Englebert",
    sane: "englebert",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Enriqueta",
    sane: "enriqueta",
    variants: [
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "handwriting",
    name: "Ephesis",
    sane: "ephesis",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Epilogue",
    sane: "epilogue",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900",
      "1,100",
      "1,200",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700",
      "1,800",
      "1,900"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "Erica One",
    sane: "erica_one",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Esteban",
    sane: "esteban",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "handwriting",
    name: "Estonia",
    sane: "estonia",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "handwriting",
    name: "Euphoria Script",
    sane: "euphoria_script",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Ewert",
    sane: "ewert",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Exo",
    sane: "exo",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900",
      "1,100",
      "1,200",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700",
      "1,800",
      "1,900"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Exo 2",
    sane: "exo_2",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900",
      "1,100",
      "1,200",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700",
      "1,800",
      "1,900"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "Expletus Sans",
    sane: "expletus_sans",
    variants: [
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "1,400",
      "1,500",
      "1,600",
      "1,700"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "handwriting",
    name: "Explora",
    sane: "explora",
    variants: [
      "0,400"
    ],
    subsets: [
      "cherokee",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Faculty Glyphic",
    sane: "faculty_glyphic",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Fahkwang",
    sane: "fahkwang",
    variants: [
      "0,200",
      "1,200",
      "0,300",
      "1,300",
      "0,400",
      "1,400",
      "0,500",
      "1,500",
      "0,600",
      "1,600",
      "0,700",
      "1,700"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "thai",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Familjen Grotesk",
    sane: "familjen_grotesk",
    variants: [
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "1,400",
      "1,500",
      "1,600",
      "1,700"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "serif",
    name: "Fanwood Text",
    sane: "fanwood_text",
    variants: [
      "0,400",
      "1,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Farro",
    sane: "farro",
    variants: [
      "0,300",
      "0,400",
      "0,500",
      "0,700"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Farsan",
    sane: "farsan",
    variants: [
      "0,400"
    ],
    subsets: [
      "gujarati",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "Fascinate",
    sane: "fascinate",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Fascinate Inline",
    sane: "fascinate_inline",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Faster One",
    sane: "faster_one",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Fasthand",
    sane: "fasthand",
    variants: [
      "0,400"
    ],
    subsets: [
      "khmer",
      "latin"
    ]
  },
  {
    category: "serif",
    name: "Fauna One",
    sane: "fauna_one",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Faustina",
    sane: "faustina",
    variants: [
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700",
      "1,800"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "Federant",
    sane: "federant",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "sans-serif",
    name: "Federo",
    sane: "federo",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Felipa",
    sane: "felipa",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Fenix",
    sane: "fenix",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "handwriting",
    name: "Festive",
    sane: "festive",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Figtree",
    sane: "figtree",
    variants: [
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700",
      "1,800",
      "1,900"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Finger Paint",
    sane: "finger_paint",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "sans-serif",
    name: "Finlandica",
    sane: "finlandica",
    variants: [
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "1,400",
      "1,500",
      "1,600",
      "1,700"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "monospace",
    name: "Fira Code",
    sane: "fira_code",
    variants: [
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "greek",
      "greek-ext",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "monospace",
    name: "Fira Mono",
    sane: "fira_mono",
    variants: [
      "0,400",
      "0,500",
      "0,700"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "greek",
      "greek-ext",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Fira Sans",
    sane: "fira_sans",
    variants: [
      "0,100",
      "1,100",
      "0,200",
      "1,200",
      "0,300",
      "1,300",
      "0,400",
      "1,400",
      "0,500",
      "1,500",
      "0,600",
      "1,600",
      "0,700",
      "1,700",
      "0,800",
      "1,800",
      "0,900",
      "1,900"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "greek",
      "greek-ext",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Fira Sans Condensed",
    sane: "fira_sans_condensed",
    variants: [
      "0,100",
      "1,100",
      "0,200",
      "1,200",
      "0,300",
      "1,300",
      "0,400",
      "1,400",
      "0,500",
      "1,500",
      "0,600",
      "1,600",
      "0,700",
      "1,700",
      "0,800",
      "1,800",
      "0,900",
      "1,900"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "greek",
      "greek-ext",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Fira Sans Extra Condensed",
    sane: "fira_sans_extra_condensed",
    variants: [
      "0,100",
      "1,100",
      "0,200",
      "1,200",
      "0,300",
      "1,300",
      "0,400",
      "1,400",
      "0,500",
      "1,500",
      "0,600",
      "1,600",
      "0,700",
      "1,700",
      "0,800",
      "1,800",
      "0,900",
      "1,900"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "greek",
      "greek-ext",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Fjalla One",
    sane: "fjalla_one",
    variants: [
      "0,400"
    ],
    subsets: [
      "cyrillic-ext",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "serif",
    name: "Fjord One",
    sane: "fjord_one",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "display",
    name: "Flamenco",
    sane: "flamenco",
    variants: [
      "0,300",
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "display",
    name: "Flavors",
    sane: "flavors",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "handwriting",
    name: "Fleur De Leah",
    sane: "fleur_de_leah",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "Flow Block",
    sane: "flow_block",
    variants: [
      "0,400"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "Flow Circular",
    sane: "flow_circular",
    variants: [
      "0,400"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "Flow Rounded",
    sane: "flow_rounded",
    variants: [
      "0,400"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "Foldit",
    sane: "foldit",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "handwriting",
    name: "Fondamento",
    sane: "fondamento",
    variants: [
      "0,400",
      "1,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Fontdiner Swanky",
    sane: "fontdiner_swanky",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "display",
    name: "Forum",
    sane: "forum",
    variants: [
      "0,400"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "monospace",
    name: "Fragment Mono",
    sane: "fragment_mono",
    variants: [
      "0,400",
      "1,400"
    ],
    subsets: [
      "cyrillic-ext",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Francois One",
    sane: "francois_one",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "serif",
    name: "Frank Ruhl Libre",
    sane: "frank_ruhl_libre",
    variants: [
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "hebrew",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Fraunces",
    sane: "fraunces",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900",
      "1,100",
      "1,200",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700",
      "1,800",
      "1,900"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "Freckle Face",
    sane: "freckle_face",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Fredericka the Great",
    sane: "fredericka_the_great",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Fredoka",
    sane: "fredoka",
    variants: [
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    subsets: [
      "hebrew",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Freehand",
    sane: "freehand",
    variants: [
      "0,400"
    ],
    subsets: [
      "khmer",
      "latin"
    ]
  },
  {
    category: "display",
    name: "Freeman",
    sane: "freeman",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Fresca",
    sane: "fresca",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Frijole",
    sane: "frijole",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "display",
    name: "Fruktur",
    sane: "fruktur",
    variants: [
      "0,400",
      "1,400"
    ],
    subsets: [
      "cyrillic-ext",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "Fugaz One",
    sane: "fugaz_one",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Fuggles",
    sane: "fuggles",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "Funnel Display",
    sane: "funnel_display",
    variants: [
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Funnel Sans",
    sane: "funnel_sans",
    variants: [
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700",
      "1,800"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Fustat",
    sane: "fustat",
    variants: [
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800"
    ],
    subsets: [
      "arabic",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "handwriting",
    name: "Fuzzy Bubbles",
    sane: "fuzzy_bubbles",
    variants: [
      "0,400",
      "0,700"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "Ga Maamli",
    sane: "ga_maamli",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "Gabarito",
    sane: "gabarito",
    variants: [
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Gabriela",
    sane: "gabriela",
    variants: [
      "0,400"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "handwriting",
    name: "Gaegu",
    sane: "gaegu",
    variants: [
      "0,300",
      "0,400",
      "0,700"
    ],
    subsets: [
      "korean",
      "latin"
    ]
  },
  {
    category: "sans-serif",
    name: "Gafata",
    sane: "gafata",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Gajraj One",
    sane: "gajraj_one",
    variants: [
      "0,400"
    ],
    subsets: [
      "devanagari",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Galada",
    sane: "galada",
    variants: [
      "0,400"
    ],
    subsets: [
      "bengali",
      "latin"
    ]
  },
  {
    category: "sans-serif",
    name: "Galdeano",
    sane: "galdeano",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "display",
    name: "Galindo",
    sane: "galindo",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "handwriting",
    name: "Gamja Flower",
    sane: "gamja_flower",
    variants: [
      "0,400"
    ],
    subsets: [
      "korean",
      "latin"
    ]
  },
  {
    category: "sans-serif",
    name: "Gantari",
    sane: "gantari",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900",
      "1,100",
      "1,200",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700",
      "1,800",
      "1,900"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Gasoek One",
    sane: "gasoek_one",
    variants: [
      "0,400"
    ],
    subsets: [
      "korean",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Gayathri",
    sane: "gayathri",
    variants: [
      "0,100",
      "0,400",
      "0,700"
    ],
    subsets: [
      "latin",
      "malayalam"
    ]
  },
  {
    category: "sans-serif",
    name: "Geist",
    sane: "geist",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "monospace",
    name: "Geist Mono",
    sane: "geist_mono",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Gelasio",
    sane: "gelasio",
    variants: [
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "1,400",
      "1,500",
      "1,600",
      "1,700"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Gemunu Libre",
    sane: "gemunu_libre",
    variants: [
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "sinhala"
    ]
  },
  {
    category: "sans-serif",
    name: "Genos",
    sane: "genos",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900",
      "1,100",
      "1,200",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700",
      "1,800",
      "1,900"
    ],
    subsets: [
      "cherokee",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "serif",
    name: "Gentium Book Plus",
    sane: "gentium_book_plus",
    variants: [
      "0,400",
      "1,400",
      "0,700",
      "1,700"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "greek",
      "greek-ext",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "serif",
    name: "Gentium Plus",
    sane: "gentium_plus",
    variants: [
      "0,400",
      "1,400",
      "0,700",
      "1,700"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "greek",
      "greek-ext",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Geo",
    sane: "geo",
    variants: [
      "0,400",
      "1,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "sans-serif",
    name: "Geologica",
    sane: "geologica",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "greek",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Georama",
    sane: "georama",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900",
      "1,100",
      "1,200",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700",
      "1,800",
      "1,900"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "Geostar",
    sane: "geostar",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "display",
    name: "Geostar Fill",
    sane: "geostar_fill",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "display",
    name: "Germania One",
    sane: "germania_one",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "display",
    name: "Gideon Roman",
    sane: "gideon_roman",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Gidugu",
    sane: "gidugu",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "telugu"
    ]
  },
  {
    category: "serif",
    name: "Gilda Display",
    sane: "gilda_display",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Girassol",
    sane: "girassol",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "handwriting",
    name: "Give You Glory",
    sane: "give_you_glory",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Glass Antiqua",
    sane: "glass_antiqua",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Glegoo",
    sane: "glegoo",
    variants: [
      "0,400",
      "0,700"
    ],
    subsets: [
      "devanagari",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Gloock",
    sane: "gloock",
    variants: [
      "0,400"
    ],
    subsets: [
      "cyrillic-ext",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "handwriting",
    name: "Gloria Hallelujah",
    sane: "gloria_hallelujah",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Glory",
    sane: "glory",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "1,100",
      "1,200",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700",
      "1,800"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "Gluten",
    sane: "gluten",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "Goblin One",
    sane: "goblin_one",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Gochi Hand",
    sane: "gochi_hand",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "display",
    name: "Goldman",
    sane: "goldman",
    variants: [
      "0,400",
      "0,700"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Golos Text",
    sane: "golos_text",
    variants: [
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Gorditas",
    sane: "gorditas",
    variants: [
      "0,400",
      "0,700"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "sans-serif",
    name: "Gothic A1",
    sane: "gothic_a1",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "greek",
      "greek-ext",
      "korean",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Gotu",
    sane: "gotu",
    variants: [
      "0,400"
    ],
    subsets: [
      "devanagari",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "serif",
    name: "Goudy Bookletter 1911",
    sane: "goudy_bookletter_1911",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "serif",
    name: "Gowun Batang",
    sane: "gowun_batang",
    variants: [
      "0,400",
      "0,700"
    ],
    subsets: [
      "korean",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Gowun Dodum",
    sane: "gowun_dodum",
    variants: [
      "0,400"
    ],
    subsets: [
      "korean",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "serif",
    name: "Graduate",
    sane: "graduate",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Grand Hotel",
    sane: "grand_hotel",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Grandiflora One",
    sane: "grandiflora_one",
    variants: [
      "0,400"
    ],
    subsets: [
      "korean",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Grandstander",
    sane: "grandstander",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900",
      "1,100",
      "1,200",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700",
      "1,800",
      "1,900"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "handwriting",
    name: "Grape Nuts",
    sane: "grape_nuts",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "Gravitas One",
    sane: "gravitas_one",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Great Vibes",
    sane: "great_vibes",
    variants: [
      "0,400"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "greek-ext",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "handwriting",
    name: "Grechen Fuemen",
    sane: "grechen_fuemen",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "serif",
    name: "Grenze",
    sane: "grenze",
    variants: [
      "0,100",
      "1,100",
      "0,200",
      "1,200",
      "0,300",
      "1,300",
      "0,400",
      "1,400",
      "0,500",
      "1,500",
      "0,600",
      "1,600",
      "0,700",
      "1,700",
      "0,800",
      "1,800",
      "0,900",
      "1,900"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "Grenze Gotisch",
    sane: "grenze_gotisch",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "handwriting",
    name: "Grey Qo",
    sane: "grey_qo",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "Griffy",
    sane: "griffy",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Gruppo",
    sane: "gruppo",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Gudea",
    sane: "gudea",
    variants: [
      "0,400",
      "1,400",
      "0,700"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Gugi",
    sane: "gugi",
    variants: [
      "0,400"
    ],
    subsets: [
      "korean",
      "latin"
    ]
  },
  {
    category: "serif",
    name: "Gulzar",
    sane: "gulzar",
    variants: [
      "0,400"
    ],
    subsets: [
      "arabic",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Gupter",
    sane: "gupter",
    variants: [
      "0,400",
      "0,500",
      "0,700"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "serif",
    name: "Gurajada",
    sane: "gurajada",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "telugu"
    ]
  },
  {
    category: "handwriting",
    name: "Gwendolyn",
    sane: "gwendolyn",
    variants: [
      "0,400",
      "0,700"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "serif",
    name: "Habibi",
    sane: "habibi",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "handwriting",
    name: "Hachi Maru Pop",
    sane: "hachi_maru_pop",
    variants: [
      "0,400"
    ],
    subsets: [
      "cyrillic",
      "japanese",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Hahmlet",
    sane: "hahmlet",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "korean",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "serif",
    name: "Halant",
    sane: "halant",
    variants: [
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    subsets: [
      "devanagari",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Hammersmith One",
    sane: "hammersmith_one",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Hanalei",
    sane: "hanalei",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Hanalei Fill",
    sane: "hanalei_fill",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Handjet",
    sane: "handjet",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "arabic",
      "armenian",
      "cyrillic",
      "cyrillic-ext",
      "greek",
      "hebrew",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "handwriting",
    name: "Handlee",
    sane: "handlee",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "sans-serif",
    name: "Hanken Grotesk",
    sane: "hanken_grotesk",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900",
      "1,100",
      "1,200",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700",
      "1,800",
      "1,900"
    ],
    subsets: [
      "cyrillic-ext",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "serif",
    name: "Hanuman",
    sane: "hanuman",
    variants: [
      "0,100",
      "0,300",
      "0,400",
      "0,700",
      "0,900"
    ],
    subsets: [
      "khmer",
      "latin"
    ]
  },
  {
    category: "display",
    name: "Happy Monkey",
    sane: "happy_monkey",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Harmattan",
    sane: "harmattan",
    variants: [
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    subsets: [
      "arabic",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Headland One",
    sane: "headland_one",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Hedvig Letters Sans",
    sane: "hedvig_letters_sans",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "math",
      "symbols"
    ]
  },
  {
    category: "serif",
    name: "Hedvig Letters Serif",
    sane: "hedvig_letters_serif",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "math",
      "symbols"
    ]
  },
  {
    category: "sans-serif",
    name: "Heebo",
    sane: "heebo",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "hebrew",
      "latin",
      "latin-ext",
      "math",
      "symbols"
    ]
  },
  {
    category: "display",
    name: "Henny Penny",
    sane: "henny_penny",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "serif",
    name: "Hepta Slab",
    sane: "hepta_slab",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "handwriting",
    name: "Herr Von Muellerhoff",
    sane: "herr_von_muellerhoff",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "handwriting",
    name: "Hi Melody",
    sane: "hi_melody",
    variants: [
      "0,400"
    ],
    subsets: [
      "korean",
      "latin"
    ]
  },
  {
    category: "serif",
    name: "Hina Mincho",
    sane: "hina_mincho",
    variants: [
      "0,400"
    ],
    subsets: [
      "cyrillic",
      "japanese",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Hind",
    sane: "hind",
    variants: [
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    subsets: [
      "devanagari",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Hind Guntur",
    sane: "hind_guntur",
    variants: [
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "telugu"
    ]
  },
  {
    category: "sans-serif",
    name: "Hind Madurai",
    sane: "hind_madurai",
    variants: [
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "tamil"
    ]
  },
  {
    category: "sans-serif",
    name: "Hind Mysuru",
    sane: "hind_mysuru",
    variants: [
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    subsets: [
      "kannada",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Hind Siliguri",
    sane: "hind_siliguri",
    variants: [
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    subsets: [
      "bengali",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Hind Vadodara",
    sane: "hind_vadodara",
    variants: [
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    subsets: [
      "gujarati",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Holtwood One SC",
    sane: "holtwood_one_sc",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "handwriting",
    name: "Homemade Apple",
    sane: "homemade_apple",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "sans-serif",
    name: "Homenaje",
    sane: "homenaje",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "display",
    name: "Honk",
    sane: "honk",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "math",
      "symbols",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Host Grotesk",
    sane: "host_grotesk",
    variants: [
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700",
      "1,800"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Hubballi",
    sane: "hubballi",
    variants: [
      "0,400"
    ],
    subsets: [
      "kannada",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Hubot Sans",
    sane: "hubot_sans",
    variants: [
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900",
      "1,200",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700",
      "1,800",
      "1,900"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "handwriting",
    name: "Hurricane",
    sane: "hurricane",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "serif",
    name: "Ibarra Real Nova",
    sane: "ibarra_real_nova",
    variants: [
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "1,400",
      "1,500",
      "1,600",
      "1,700"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "monospace",
    name: "IBM Plex Mono",
    sane: "ibm_plex_mono",
    variants: [
      "0,100",
      "1,100",
      "0,200",
      "1,200",
      "0,300",
      "1,300",
      "0,400",
      "1,400",
      "0,500",
      "1,500",
      "0,600",
      "1,600",
      "0,700",
      "1,700"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "IBM Plex Sans",
    sane: "ibm_plex_sans",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "1,100",
      "1,200",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "greek",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "IBM Plex Sans Arabic",
    sane: "ibm_plex_sans_arabic",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    subsets: [
      "arabic",
      "cyrillic-ext",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "IBM Plex Sans Condensed",
    sane: "ibm_plex_sans_condensed",
    variants: [
      "0,100",
      "1,100",
      "0,200",
      "1,200",
      "0,300",
      "1,300",
      "0,400",
      "1,400",
      "0,500",
      "1,500",
      "0,600",
      "1,600",
      "0,700",
      "1,700"
    ],
    subsets: [
      "cyrillic-ext",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "IBM Plex Sans Devanagari",
    sane: "ibm_plex_sans_devanagari",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    subsets: [
      "cyrillic-ext",
      "devanagari",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "IBM Plex Sans Hebrew",
    sane: "ibm_plex_sans_hebrew",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    subsets: [
      "cyrillic-ext",
      "hebrew",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "IBM Plex Sans JP",
    sane: "ibm_plex_sans_jp",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    subsets: [
      "cyrillic",
      "japanese",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "IBM Plex Sans KR",
    sane: "ibm_plex_sans_kr",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    subsets: [
      "korean",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "IBM Plex Sans Thai",
    sane: "ibm_plex_sans_thai",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    subsets: [
      "cyrillic-ext",
      "latin",
      "latin-ext",
      "thai"
    ]
  },
  {
    category: "sans-serif",
    name: "IBM Plex Sans Thai Looped",
    sane: "ibm_plex_sans_thai_looped",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    subsets: [
      "cyrillic-ext",
      "latin",
      "latin-ext",
      "thai"
    ]
  },
  {
    category: "serif",
    name: "IBM Plex Serif",
    sane: "ibm_plex_serif",
    variants: [
      "0,100",
      "1,100",
      "0,200",
      "1,200",
      "0,300",
      "1,300",
      "0,400",
      "1,400",
      "0,500",
      "1,500",
      "0,600",
      "1,600",
      "0,700",
      "1,700"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "Iceberg",
    sane: "iceberg",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "display",
    name: "Iceland",
    sane: "iceland",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "serif",
    name: "IM Fell Double Pica",
    sane: "im_fell_double_pica",
    variants: [
      "0,400",
      "1,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "serif",
    name: "IM Fell Double Pica SC",
    sane: "im_fell_double_pica_sc",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "serif",
    name: "IM Fell DW Pica",
    sane: "im_fell_dw_pica",
    variants: [
      "0,400",
      "1,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "serif",
    name: "IM Fell DW Pica SC",
    sane: "im_fell_dw_pica_sc",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "serif",
    name: "IM Fell English",
    sane: "im_fell_english",
    variants: [
      "0,400",
      "1,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "serif",
    name: "IM Fell English SC",
    sane: "im_fell_english_sc",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "serif",
    name: "IM Fell French Canon",
    sane: "im_fell_french_canon",
    variants: [
      "0,400",
      "1,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "serif",
    name: "IM Fell French Canon SC",
    sane: "im_fell_french_canon_sc",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "serif",
    name: "IM Fell Great Primer",
    sane: "im_fell_great_primer",
    variants: [
      "0,400",
      "1,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "serif",
    name: "IM Fell Great Primer SC",
    sane: "im_fell_great_primer_sc",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "serif",
    name: "Imbue",
    sane: "imbue",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "handwriting",
    name: "Imperial Script",
    sane: "imperial_script",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Imprima",
    sane: "imprima",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Inclusive Sans",
    sane: "inclusive_sans",
    variants: [
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "monospace",
    name: "Inconsolata",
    sane: "inconsolata",
    variants: [
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Inder",
    sane: "inder",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "handwriting",
    name: "Indie Flower",
    sane: "indie_flower",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "handwriting",
    name: "Ingrid Darling",
    sane: "ingrid_darling",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "serif",
    name: "Inika",
    sane: "inika",
    variants: [
      "0,400",
      "0,700"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Inknut Antiqua",
    sane: "inknut_antiqua",
    variants: [
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "devanagari",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Inria Sans",
    sane: "inria_sans",
    variants: [
      "0,300",
      "1,300",
      "0,400",
      "1,400",
      "0,700",
      "1,700"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Inria Serif",
    sane: "inria_serif",
    variants: [
      "0,300",
      "1,300",
      "0,400",
      "1,400",
      "0,700",
      "1,700"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "handwriting",
    name: "Inspiration",
    sane: "inspiration",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Instrument Sans",
    sane: "instrument_sans",
    variants: [
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "1,400",
      "1,500",
      "1,600",
      "1,700"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Instrument Serif",
    sane: "instrument_serif",
    variants: [
      "0,400",
      "1,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Inter",
    sane: "inter",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900",
      "1,100",
      "1,200",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700",
      "1,800",
      "1,900"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "greek",
      "greek-ext",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Inter Tight",
    sane: "inter_tight",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900",
      "1,100",
      "1,200",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700",
      "1,800",
      "1,900"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "greek",
      "greek-ext",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "Irish Grover",
    sane: "irish_grover",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Island Moments",
    sane: "island_moments",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Istok Web",
    sane: "istok_web",
    variants: [
      "0,400",
      "1,400",
      "0,700",
      "1,700"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Italiana",
    sane: "italiana",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Italianno",
    sane: "italianno",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "handwriting",
    name: "Itim",
    sane: "itim",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "thai",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "Jacquard 12",
    sane: "jacquard_12",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "math",
      "symbols"
    ]
  },
  {
    category: "display",
    name: "Jacquard 12 Charted",
    sane: "jacquard_12_charted",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "math",
      "symbols"
    ]
  },
  {
    category: "display",
    name: "Jacquard 24",
    sane: "jacquard_24",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Jacquard 24 Charted",
    sane: "jacquard_24_charted",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Jacquarda Bastarda 9",
    sane: "jacquarda_bastarda_9",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "math",
      "symbols"
    ]
  },
  {
    category: "display",
    name: "Jacquarda Bastarda 9 Charted",
    sane: "jacquarda_bastarda_9_charted",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "math",
      "symbols"
    ]
  },
  {
    category: "serif",
    name: "Jacques Francois",
    sane: "jacques_francois",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "display",
    name: "Jacques Francois Shadow",
    sane: "jacques_francois_shadow",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "display",
    name: "Jaini",
    sane: "jaini",
    variants: [
      "0,400"
    ],
    subsets: [
      "devanagari",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Jaini Purva",
    sane: "jaini_purva",
    variants: [
      "0,400"
    ],
    subsets: [
      "devanagari",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Jaldi",
    sane: "jaldi",
    variants: [
      "0,400",
      "0,700"
    ],
    subsets: [
      "devanagari",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Jaro",
    sane: "jaro",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "Jersey 10",
    sane: "jersey_10",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Jersey 10 Charted",
    sane: "jersey_10_charted",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Jersey 15",
    sane: "jersey_15",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Jersey 15 Charted",
    sane: "jersey_15_charted",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Jersey 20",
    sane: "jersey_20",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Jersey 20 Charted",
    sane: "jersey_20_charted",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Jersey 25",
    sane: "jersey_25",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Jersey 25 Charted",
    sane: "jersey_25_charted",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "monospace",
    name: "JetBrains Mono",
    sane: "jetbrains_mono",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "1,100",
      "1,200",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700",
      "1,800"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "greek",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "handwriting",
    name: "Jim Nightshade",
    sane: "jim_nightshade",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Joan",
    sane: "joan",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Jockey One",
    sane: "jockey_one",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Jolly Lodger",
    sane: "jolly_lodger",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Jomhuria",
    sane: "jomhuria",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Jomolhari",
    sane: "jomolhari",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "tibetan"
    ]
  },
  {
    category: "sans-serif",
    name: "Josefin Sans",
    sane: "josefin_sans",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "1,100",
      "1,200",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "serif",
    name: "Josefin Slab",
    sane: "josefin_slab",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "1,100",
      "1,200",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "sans-serif",
    name: "Jost",
    sane: "jost",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900",
      "1,100",
      "1,200",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700",
      "1,800",
      "1,900"
    ],
    subsets: [
      "cyrillic",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Joti One",
    sane: "joti_one",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Jua",
    sane: "jua",
    variants: [
      "0,400"
    ],
    subsets: [
      "korean",
      "latin"
    ]
  },
  {
    category: "serif",
    name: "Judson",
    sane: "judson",
    variants: [
      "0,400",
      "1,400",
      "0,700"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "handwriting",
    name: "Julee",
    sane: "julee",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Julius Sans One",
    sane: "julius_sans_one",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Junge",
    sane: "junge",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "sans-serif",
    name: "Jura",
    sane: "jura",
    variants: [
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "greek",
      "greek-ext",
      "kayah-li",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "handwriting",
    name: "Just Another Hand",
    sane: "just_another_hand",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "handwriting",
    name: "Just Me Again Down Here",
    sane: "just_me_again_down_here",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "K2D",
    sane: "k2d",
    variants: [
      "0,100",
      "1,100",
      "0,200",
      "1,200",
      "0,300",
      "1,300",
      "0,400",
      "1,400",
      "0,500",
      "1,500",
      "0,600",
      "1,600",
      "0,700",
      "1,700",
      "0,800",
      "1,800"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "thai",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "Kablammo",
    sane: "kablammo",
    variants: [
      "0,400"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "serif",
    name: "Kadwa",
    sane: "kadwa",
    variants: [
      "0,400",
      "0,700"
    ],
    subsets: [
      "devanagari",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Kaisei Decol",
    sane: "kaisei_decol",
    variants: [
      "0,400",
      "0,500",
      "0,700"
    ],
    subsets: [
      "cyrillic",
      "japanese",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Kaisei HarunoUmi",
    sane: "kaisei_harunoumi",
    variants: [
      "0,400",
      "0,500",
      "0,700"
    ],
    subsets: [
      "cyrillic",
      "japanese",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Kaisei Opti",
    sane: "kaisei_opti",
    variants: [
      "0,400",
      "0,500",
      "0,700"
    ],
    subsets: [
      "cyrillic",
      "japanese",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Kaisei Tokumin",
    sane: "kaisei_tokumin",
    variants: [
      "0,400",
      "0,500",
      "0,700",
      "0,800"
    ],
    subsets: [
      "cyrillic",
      "japanese",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "handwriting",
    name: "Kalam",
    sane: "kalam",
    variants: [
      "0,300",
      "0,400",
      "0,700"
    ],
    subsets: [
      "devanagari",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Kalnia",
    sane: "kalnia",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "math"
    ]
  },
  {
    category: "display",
    name: "Kalnia Glaze",
    sane: "kalnia_glaze",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Kameron",
    sane: "kameron",
    variants: [
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Kanit",
    sane: "kanit",
    variants: [
      "0,100",
      "1,100",
      "0,200",
      "1,200",
      "0,300",
      "1,300",
      "0,400",
      "1,400",
      "0,500",
      "1,500",
      "0,600",
      "1,600",
      "0,700",
      "1,700",
      "0,800",
      "1,800",
      "0,900",
      "1,900"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "thai",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Kantumruy Pro",
    sane: "kantumruy_pro",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "1,100",
      "1,200",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700"
    ],
    subsets: [
      "khmer",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Karantina",
    sane: "karantina",
    variants: [
      "0,300",
      "0,400",
      "0,700"
    ],
    subsets: [
      "hebrew",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Karla",
    sane: "karla",
    variants: [
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "1,200",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700",
      "1,800"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Karma",
    sane: "karma",
    variants: [
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    subsets: [
      "devanagari",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Katibeh",
    sane: "katibeh",
    variants: [
      "0,400"
    ],
    subsets: [
      "arabic",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "handwriting",
    name: "Kaushan Script",
    sane: "kaushan_script",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "handwriting",
    name: "Kavivanar",
    sane: "kavivanar",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "tamil"
    ]
  },
  {
    category: "display",
    name: "Kavoon",
    sane: "kavoon",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Kay Pho Du",
    sane: "kay_pho_du",
    variants: [
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    subsets: [
      "kayah-li",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Kdam Thmor Pro",
    sane: "kdam_thmor_pro",
    variants: [
      "0,400"
    ],
    subsets: [
      "khmer",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Keania One",
    sane: "keania_one",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Kelly Slab",
    sane: "kelly_slab",
    variants: [
      "0,400"
    ],
    subsets: [
      "cyrillic",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Kenia",
    sane: "kenia",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "sans-serif",
    name: "Khand",
    sane: "khand",
    variants: [
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    subsets: [
      "devanagari",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Khula",
    sane: "khula",
    variants: [
      "0,300",
      "0,400",
      "0,600",
      "0,700",
      "0,800"
    ],
    subsets: [
      "devanagari",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "handwriting",
    name: "Kings",
    sane: "kings",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "Kirang Haerang",
    sane: "kirang_haerang",
    variants: [
      "0,400"
    ],
    subsets: [
      "korean",
      "latin"
    ]
  },
  {
    category: "sans-serif",
    name: "Kite One",
    sane: "kite_one",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Kiwi Maru",
    sane: "kiwi_maru",
    variants: [
      "0,300",
      "0,400",
      "0,500"
    ],
    subsets: [
      "cyrillic",
      "japanese",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "handwriting",
    name: "Klee One",
    sane: "klee_one",
    variants: [
      "0,400",
      "0,600"
    ],
    subsets: [
      "cyrillic",
      "greek-ext",
      "japanese",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Knewave",
    sane: "knewave",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Kodchasan",
    sane: "kodchasan",
    variants: [
      "0,200",
      "1,200",
      "0,300",
      "1,300",
      "0,400",
      "1,400",
      "0,500",
      "1,500",
      "0,600",
      "1,600",
      "0,700",
      "1,700"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "thai",
      "vietnamese"
    ]
  },
  {
    category: "monospace",
    name: "Kode Mono",
    sane: "kode_mono",
    variants: [
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Koh Santepheap",
    sane: "koh_santepheap",
    variants: [
      "0,100",
      "0,300",
      "0,400",
      "0,700",
      "0,900"
    ],
    subsets: [
      "khmer",
      "latin"
    ]
  },
  {
    category: "sans-serif",
    name: "KoHo",
    sane: "koho",
    variants: [
      "0,200",
      "1,200",
      "0,300",
      "1,300",
      "0,400",
      "1,400",
      "0,500",
      "1,500",
      "0,600",
      "1,600",
      "0,700",
      "1,700"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "thai",
      "vietnamese"
    ]
  },
  {
    category: "handwriting",
    name: "Kolker Brush",
    sane: "kolker_brush",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "Konkhmer Sleokchher",
    sane: "konkhmer_sleokchher",
    variants: [
      "0,400"
    ],
    subsets: [
      "khmer",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Kosugi",
    sane: "kosugi",
    variants: [
      "0,400"
    ],
    subsets: [
      "cyrillic",
      "japanese",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Kosugi Maru",
    sane: "kosugi_maru",
    variants: [
      "0,400"
    ],
    subsets: [
      "cyrillic",
      "japanese",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Kotta One",
    sane: "kotta_one",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Koulen",
    sane: "koulen",
    variants: [
      "0,400"
    ],
    subsets: [
      "khmer",
      "latin"
    ]
  },
  {
    category: "display",
    name: "Kranky",
    sane: "kranky",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "serif",
    name: "Kreon",
    sane: "kreon",
    variants: [
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "handwriting",
    name: "Kristi",
    sane: "kristi",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "sans-serif",
    name: "Krona One",
    sane: "krona_one",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Krub",
    sane: "krub",
    variants: [
      "0,200",
      "1,200",
      "0,300",
      "1,300",
      "0,400",
      "1,400",
      "0,500",
      "1,500",
      "0,600",
      "1,600",
      "0,700",
      "1,700"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "thai",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Kufam",
    sane: "kufam",
    variants: [
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900",
      "1,400",
      "1,500",
      "1,600",
      "1,700",
      "1,800",
      "1,900"
    ],
    subsets: [
      "arabic",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Kulim Park",
    sane: "kulim_park",
    variants: [
      "0,200",
      "1,200",
      "0,300",
      "1,300",
      "0,400",
      "1,400",
      "0,600",
      "1,600",
      "0,700",
      "1,700"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Kumbh Sans",
    sane: "kumbh_sans",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "math",
      "symbols"
    ]
  },
  {
    category: "serif",
    name: "Kurale",
    sane: "kurale",
    variants: [
      "0,400"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "devanagari",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "handwriting",
    name: "La Belle Aurore",
    sane: "la_belle_aurore",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Labrada",
    sane: "labrada",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900",
      "1,100",
      "1,200",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700",
      "1,800",
      "1,900"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "Lacquer",
    sane: "lacquer",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "sans-serif",
    name: "Laila",
    sane: "laila",
    variants: [
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    subsets: [
      "devanagari",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "handwriting",
    name: "Lakki Reddy",
    sane: "lakki_reddy",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "telugu"
    ]
  },
  {
    category: "display",
    name: "Lalezar",
    sane: "lalezar",
    variants: [
      "0,400"
    ],
    subsets: [
      "arabic",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "Lancelot",
    sane: "lancelot",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Langar",
    sane: "langar",
    variants: [
      "0,400"
    ],
    subsets: [
      "gurmukhi",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Lateef",
    sane: "lateef",
    variants: [
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800"
    ],
    subsets: [
      "arabic",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Lato",
    sane: "lato",
    variants: [
      "0,100",
      "1,100",
      "0,300",
      "1,300",
      "0,400",
      "1,400",
      "0,700",
      "1,700",
      "0,900",
      "1,900"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "handwriting",
    name: "Lavishly Yours",
    sane: "lavishly_yours",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "League Gothic",
    sane: "league_gothic",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "handwriting",
    name: "League Script",
    sane: "league_script",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "sans-serif",
    name: "League Spartan",
    sane: "league_spartan",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "handwriting",
    name: "Leckerli One",
    sane: "leckerli_one",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "serif",
    name: "Ledger",
    sane: "ledger",
    variants: [
      "0,400"
    ],
    subsets: [
      "cyrillic",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "monospace",
    name: "Lekton",
    sane: "lekton",
    variants: [
      "0,400",
      "1,400",
      "0,700"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Lemon",
    sane: "lemon",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Lemonada",
    sane: "lemonada",
    variants: [
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    subsets: [
      "arabic",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Lexend",
    sane: "lexend",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Lexend Deca",
    sane: "lexend_deca",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Lexend Exa",
    sane: "lexend_exa",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Lexend Giga",
    sane: "lexend_giga",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Lexend Mega",
    sane: "lexend_mega",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Lexend Peta",
    sane: "lexend_peta",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Lexend Tera",
    sane: "lexend_tera",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Lexend Zetta",
    sane: "lexend_zetta",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "Libre Barcode 128",
    sane: "libre_barcode_128",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "display",
    name: "Libre Barcode 128 Text",
    sane: "libre_barcode_128_text",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "display",
    name: "Libre Barcode 39",
    sane: "libre_barcode_39",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "display",
    name: "Libre Barcode 39 Extended",
    sane: "libre_barcode_39_extended",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "display",
    name: "Libre Barcode 39 Extended Text",
    sane: "libre_barcode_39_extended_text",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "display",
    name: "Libre Barcode 39 Text",
    sane: "libre_barcode_39_text",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "display",
    name: "Libre Barcode EAN13 Text",
    sane: "libre_barcode_ean13_text",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "serif",
    name: "Libre Baskerville",
    sane: "libre_baskerville",
    variants: [
      "0,400",
      "1,400",
      "0,700"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Libre Bodoni",
    sane: "libre_bodoni",
    variants: [
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "1,400",
      "1,500",
      "1,600",
      "1,700"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "serif",
    name: "Libre Caslon Display",
    sane: "libre_caslon_display",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Libre Caslon Text",
    sane: "libre_caslon_text",
    variants: [
      "0,400",
      "1,400",
      "0,700"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Libre Franklin",
    sane: "libre_franklin",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900",
      "1,100",
      "1,200",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700",
      "1,800",
      "1,900"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "handwriting",
    name: "Licorice",
    sane: "licorice",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "Life Savers",
    sane: "life_savers",
    variants: [
      "0,400",
      "0,700",
      "0,800"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Lilita One",
    sane: "lilita_one",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Lily Script One",
    sane: "lily_script_one",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Limelight",
    sane: "limelight",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Linden Hill",
    sane: "linden_hill",
    variants: [
      "0,400",
      "1,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Linefont",
    sane: "linefont",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "serif",
    name: "Lisu Bosa",
    sane: "lisu_bosa",
    variants: [
      "0,200",
      "1,200",
      "0,300",
      "1,300",
      "0,400",
      "1,400",
      "0,500",
      "1,500",
      "0,600",
      "1,600",
      "0,700",
      "1,700",
      "0,800",
      "1,800",
      "0,900",
      "1,900"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "lisu"
    ]
  },
  {
    category: "sans-serif",
    name: "Liter",
    sane: "liter",
    variants: [
      "0,400"
    ],
    subsets: [
      "cyrillic",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Literata",
    sane: "literata",
    variants: [
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900",
      "1,200",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700",
      "1,800",
      "1,900"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "greek",
      "greek-ext",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "handwriting",
    name: "Liu Jian Mao Cao",
    sane: "liu_jian_mao_cao",
    variants: [
      "0,400"
    ],
    subsets: [
      "chinese-simplified",
      "latin"
    ]
  },
  {
    category: "sans-serif",
    name: "Livvic",
    sane: "livvic",
    variants: [
      "0,100",
      "1,100",
      "0,200",
      "1,200",
      "0,300",
      "1,300",
      "0,400",
      "1,400",
      "0,500",
      "1,500",
      "0,600",
      "1,600",
      "0,700",
      "1,700",
      "0,900",
      "1,900"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "Lobster",
    sane: "lobster",
    variants: [
      "0,400"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "Lobster Two",
    sane: "lobster_two",
    variants: [
      "0,400",
      "1,400",
      "0,700",
      "1,700"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "display",
    name: "Londrina Outline",
    sane: "londrina_outline",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "display",
    name: "Londrina Shadow",
    sane: "londrina_shadow",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "display",
    name: "Londrina Sketch",
    sane: "londrina_sketch",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "display",
    name: "Londrina Solid",
    sane: "londrina_solid",
    variants: [
      "0,100",
      "0,300",
      "0,400",
      "0,900"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Long Cang",
    sane: "long_cang",
    variants: [
      "0,400"
    ],
    subsets: [
      "chinese-simplified",
      "latin"
    ]
  },
  {
    category: "serif",
    name: "Lora",
    sane: "lora",
    variants: [
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "1,400",
      "1,500",
      "1,600",
      "1,700"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "latin",
      "latin-ext",
      "math",
      "symbols",
      "vietnamese"
    ]
  },
  {
    category: "handwriting",
    name: "Love Light",
    sane: "love_light",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "Love Ya Like A Sister",
    sane: "love_ya_like_a_sister",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "handwriting",
    name: "Loved by the King",
    sane: "loved_by_the_king",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "handwriting",
    name: "Lovers Quarrel",
    sane: "lovers_quarrel",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "Luckiest Guy",
    sane: "luckiest_guy",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "handwriting",
    name: "Lugrasimo",
    sane: "lugrasimo",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "handwriting",
    name: "Lumanosimo",
    sane: "lumanosimo",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Lunasima",
    sane: "lunasima",
    variants: [
      "0,400",
      "0,700"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "greek",
      "greek-ext",
      "hebrew",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "serif",
    name: "Lusitana",
    sane: "lusitana",
    variants: [
      "0,400",
      "0,700"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "serif",
    name: "Lustria",
    sane: "lustria",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "display",
    name: "Luxurious Roman",
    sane: "luxurious_roman",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "handwriting",
    name: "Luxurious Script",
    sane: "luxurious_script",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "monospace",
    name: "LXGW WenKai Mono TC",
    sane: "lxgw_wenkai_mono_tc",
    variants: [
      "0,300",
      "0,400",
      "0,700"
    ],
    subsets: [
      "chinese-hongkong",
      "cyrillic",
      "cyrillic-ext",
      "greek",
      "greek-ext",
      "latin",
      "latin-ext",
      "lisu",
      "vietnamese"
    ]
  },
  {
    category: "handwriting",
    name: "LXGW WenKai TC",
    sane: "lxgw_wenkai_tc",
    variants: [
      "0,300",
      "0,400",
      "0,700"
    ],
    subsets: [
      "chinese-hongkong",
      "cyrillic",
      "cyrillic-ext",
      "greek",
      "greek-ext",
      "latin",
      "latin-ext",
      "lisu",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "M PLUS 1",
    sane: "m_plus_1",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "japanese",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "monospace",
    name: "M PLUS 1 Code",
    sane: "m_plus_1_code",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    subsets: [
      "japanese",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "M PLUS 1p",
    sane: "m_plus_1p",
    variants: [
      "0,100",
      "0,300",
      "0,400",
      "0,500",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "greek",
      "greek-ext",
      "hebrew",
      "japanese",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "M PLUS 2",
    sane: "m_plus_2",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "japanese",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "M PLUS Code Latin",
    sane: "m_plus_code_latin",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "M PLUS Rounded 1c",
    sane: "m_plus_rounded_1c",
    variants: [
      "0,100",
      "0,300",
      "0,400",
      "0,500",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "greek",
      "greek-ext",
      "hebrew",
      "japanese",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "handwriting",
    name: "Ma Shan Zheng",
    sane: "ma_shan_zheng",
    variants: [
      "0,400"
    ],
    subsets: [
      "chinese-simplified",
      "latin"
    ]
  },
  {
    category: "display",
    name: "Macondo",
    sane: "macondo",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "display",
    name: "Macondo Swash Caps",
    sane: "macondo_swash_caps",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "sans-serif",
    name: "Mada",
    sane: "mada",
    variants: [
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "arabic",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Madimi One",
    sane: "madimi_one",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "math",
      "symbols"
    ]
  },
  {
    category: "sans-serif",
    name: "Magra",
    sane: "magra",
    variants: [
      "0,400",
      "0,700"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Maiden Orange",
    sane: "maiden_orange",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Maitree",
    sane: "maitree",
    variants: [
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "thai",
      "vietnamese"
    ]
  },
  {
    category: "monospace",
    name: "Major Mono Display",
    sane: "major_mono_display",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Mako",
    sane: "mako",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "handwriting",
    name: "Mali",
    sane: "mali",
    variants: [
      "0,200",
      "1,200",
      "0,300",
      "1,300",
      "0,400",
      "1,400",
      "0,500",
      "1,500",
      "0,600",
      "1,600",
      "0,700",
      "1,700"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "thai",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Mallanna",
    sane: "mallanna",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "telugu"
    ]
  },
  {
    category: "serif",
    name: "Maname",
    sane: "maname",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "sinhala",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Mandali",
    sane: "mandali",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "telugu"
    ]
  },
  {
    category: "sans-serif",
    name: "Manjari",
    sane: "manjari",
    variants: [
      "0,100",
      "0,400",
      "0,700"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "malayalam"
    ]
  },
  {
    category: "sans-serif",
    name: "Manrope",
    sane: "manrope",
    variants: [
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "greek",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "handwriting",
    name: "Mansalva",
    sane: "mansalva",
    variants: [
      "0,400"
    ],
    subsets: [
      "greek",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "serif",
    name: "Manuale",
    sane: "manuale",
    variants: [
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700",
      "1,800"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "serif",
    name: "Marcellus",
    sane: "marcellus",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Marcellus SC",
    sane: "marcellus_sc",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "handwriting",
    name: "Marck Script",
    sane: "marck_script",
    variants: [
      "0,400"
    ],
    subsets: [
      "cyrillic",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Margarine",
    sane: "margarine",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Marhey",
    sane: "marhey",
    variants: [
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    subsets: [
      "arabic",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Markazi Text",
    sane: "markazi_text",
    variants: [
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    subsets: [
      "arabic",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "serif",
    name: "Marko One",
    sane: "marko_one",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "sans-serif",
    name: "Marmelad",
    sane: "marmelad",
    variants: [
      "0,400"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "serif",
    name: "Martel",
    sane: "martel",
    variants: [
      "0,200",
      "0,300",
      "0,400",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "devanagari",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Martel Sans",
    sane: "martel_sans",
    variants: [
      "0,200",
      "0,300",
      "0,400",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "devanagari",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "monospace",
    name: "Martian Mono",
    sane: "martian_mono",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Marvel",
    sane: "marvel",
    variants: [
      "0,400",
      "1,400",
      "0,700",
      "1,700"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "serif",
    name: "Mate",
    sane: "mate",
    variants: [
      "0,400",
      "1,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Mate SC",
    sane: "mate_sc",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Matemasie",
    sane: "matemasie",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "monospace",
    name: "Material Icons",
    sane: "material_icons",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "monospace",
    name: "Material Icons Outlined",
    sane: "material_icons_outlined",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "monospace",
    name: "Material Icons Round",
    sane: "material_icons_round",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "monospace",
    name: "Material Icons Sharp",
    sane: "material_icons_sharp",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "monospace",
    name: "Material Icons Two Tone",
    sane: "material_icons_two_tone",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "monospace",
    name: "Material Symbols Outlined",
    sane: "material_symbols_outlined",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "monospace",
    name: "Material Symbols Rounded",
    sane: "material_symbols_rounded",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "monospace",
    name: "Material Symbols Sharp",
    sane: "material_symbols_sharp",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "sans-serif",
    name: "Maven Pro",
    sane: "maven_pro",
    variants: [
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "McLaren",
    sane: "mclaren",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "handwriting",
    name: "Mea Culpa",
    sane: "mea_culpa",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "handwriting",
    name: "Meddon",
    sane: "meddon",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "MedievalSharp",
    sane: "medievalsharp",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Medula One",
    sane: "medula_one",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "sans-serif",
    name: "Meera Inimai",
    sane: "meera_inimai",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "tamil"
    ]
  },
  {
    category: "display",
    name: "Megrim",
    sane: "megrim",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "handwriting",
    name: "Meie Script",
    sane: "meie_script",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "handwriting",
    name: "Meow Script",
    sane: "meow_script",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "handwriting",
    name: "Merienda",
    sane: "merienda",
    variants: [
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "serif",
    name: "Merriweather",
    sane: "merriweather",
    variants: [
      "0,300",
      "1,300",
      "0,400",
      "1,400",
      "0,700",
      "1,700",
      "0,900",
      "1,900"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Merriweather Sans",
    sane: "merriweather_sans",
    variants: [
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700",
      "1,800"
    ],
    subsets: [
      "cyrillic-ext",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "Metal",
    sane: "metal",
    variants: [
      "0,400"
    ],
    subsets: [
      "khmer",
      "latin"
    ]
  },
  {
    category: "display",
    name: "Metal Mania",
    sane: "metal_mania",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Metamorphous",
    sane: "metamorphous",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Metrophobic",
    sane: "metrophobic",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Michroma",
    sane: "michroma",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Micro 5",
    sane: "micro_5",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "math",
      "symbols"
    ]
  },
  {
    category: "display",
    name: "Micro 5 Charted",
    sane: "micro_5_charted",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "math",
      "symbols"
    ]
  },
  {
    category: "display",
    name: "Milonga",
    sane: "milonga",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Miltonian",
    sane: "miltonian",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "display",
    name: "Miltonian Tattoo",
    sane: "miltonian_tattoo",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "sans-serif",
    name: "Mina",
    sane: "mina",
    variants: [
      "0,400",
      "0,700"
    ],
    subsets: [
      "bengali",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Mingzat",
    sane: "mingzat",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "lepcha"
    ]
  },
  {
    category: "display",
    name: "Miniver",
    sane: "miniver",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "sans-serif",
    name: "Miriam Libre",
    sane: "miriam_libre",
    variants: [
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    subsets: [
      "hebrew",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Mirza",
    sane: "mirza",
    variants: [
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    subsets: [
      "arabic",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "handwriting",
    name: "Miss Fajardose",
    sane: "miss_fajardose",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Mitr",
    sane: "mitr",
    variants: [
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "thai",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Mochiy Pop One",
    sane: "mochiy_pop_one",
    variants: [
      "0,400"
    ],
    subsets: [
      "japanese",
      "latin"
    ]
  },
  {
    category: "sans-serif",
    name: "Mochiy Pop P One",
    sane: "mochiy_pop_p_one",
    variants: [
      "0,400"
    ],
    subsets: [
      "japanese",
      "latin"
    ]
  },
  {
    category: "display",
    name: "Modak",
    sane: "modak",
    variants: [
      "0,400"
    ],
    subsets: [
      "devanagari",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Modern Antiqua",
    sane: "modern_antiqua",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Moderustic",
    sane: "moderustic",
    variants: [
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "greek",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Mogra",
    sane: "mogra",
    variants: [
      "0,400"
    ],
    subsets: [
      "gujarati",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Mohave",
    sane: "mohave",
    variants: [
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Moirai One",
    sane: "moirai_one",
    variants: [
      "0,400"
    ],
    subsets: [
      "korean",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Molengo",
    sane: "molengo",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "handwriting",
    name: "Molle",
    sane: "molle",
    variants: [
      "1,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Mona Sans",
    sane: "mona_sans",
    variants: [
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900",
      "1,200",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700",
      "1,800",
      "1,900"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Monda",
    sane: "monda",
    variants: [
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "monospace",
    name: "Monofett",
    sane: "monofett",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Monomakh",
    sane: "monomakh",
    variants: [
      "0,400"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Monomaniac One",
    sane: "monomaniac_one",
    variants: [
      "0,400"
    ],
    subsets: [
      "japanese",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Monoton",
    sane: "monoton",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "handwriting",
    name: "Monsieur La Doulaise",
    sane: "monsieur_la_doulaise",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Montaga",
    sane: "montaga",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "serif",
    name: "Montagu Slab",
    sane: "montagu_slab",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "handwriting",
    name: "MonteCarlo",
    sane: "montecarlo",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "handwriting",
    name: "Montez",
    sane: "montez",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Montserrat",
    sane: "montserrat",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900",
      "1,100",
      "1,200",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700",
      "1,800",
      "1,900"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Montserrat Alternates",
    sane: "montserrat_alternates",
    variants: [
      "0,100",
      "1,100",
      "0,200",
      "1,200",
      "0,300",
      "1,300",
      "0,400",
      "1,400",
      "0,500",
      "1,500",
      "0,600",
      "1,600",
      "0,700",
      "1,700",
      "0,800",
      "1,800",
      "0,900",
      "1,900"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Montserrat Subrayada",
    sane: "montserrat_subrayada",
    variants: [
      "0,400",
      "0,700"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "sans-serif",
    name: "Montserrat Underline",
    sane: "montserrat_underline",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900",
      "1,100",
      "1,200",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700",
      "1,800",
      "1,900"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "Moo Lah Lah",
    sane: "moo_lah_lah",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Mooli",
    sane: "mooli",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "handwriting",
    name: "Moon Dance",
    sane: "moon_dance",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "Moul",
    sane: "moul",
    variants: [
      "0,400"
    ],
    subsets: [
      "khmer",
      "latin"
    ]
  },
  {
    category: "sans-serif",
    name: "Moulpali",
    sane: "moulpali",
    variants: [
      "0,400"
    ],
    subsets: [
      "khmer",
      "latin"
    ]
  },
  {
    category: "display",
    name: "Mountains of Christmas",
    sane: "mountains_of_christmas",
    variants: [
      "0,400",
      "0,700"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "sans-serif",
    name: "Mouse Memoirs",
    sane: "mouse_memoirs",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "handwriting",
    name: "Mr Bedfort",
    sane: "mr_bedfort",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "handwriting",
    name: "Mr Dafoe",
    sane: "mr_dafoe",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "handwriting",
    name: "Mr De Haviland",
    sane: "mr_de_haviland",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "handwriting",
    name: "Mrs Saint Delafield",
    sane: "mrs_saint_delafield",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "handwriting",
    name: "Mrs Sheppards",
    sane: "mrs_sheppards",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "handwriting",
    name: "Ms Madi",
    sane: "ms_madi",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Mukta",
    sane: "mukta",
    variants: [
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800"
    ],
    subsets: [
      "devanagari",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Mukta Mahee",
    sane: "mukta_mahee",
    variants: [
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800"
    ],
    subsets: [
      "gurmukhi",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Mukta Malar",
    sane: "mukta_malar",
    variants: [
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "tamil"
    ]
  },
  {
    category: "sans-serif",
    name: "Mukta Vaani",
    sane: "mukta_vaani",
    variants: [
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800"
    ],
    subsets: [
      "gujarati",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Mulish",
    sane: "mulish",
    variants: [
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900",
      "1,200",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700",
      "1,800",
      "1,900"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Murecho",
    sane: "murecho",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "greek",
      "japanese",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "MuseoModerno",
    sane: "museomoderno",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900",
      "1,100",
      "1,200",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700",
      "1,800",
      "1,900"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "handwriting",
    name: "My Soul",
    sane: "my_soul",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "handwriting",
    name: "Mynerve",
    sane: "mynerve",
    variants: [
      "0,400"
    ],
    subsets: [
      "greek",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "Mystery Quest",
    sane: "mystery_quest",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Nabla",
    sane: "nabla",
    variants: [
      "0,400"
    ],
    subsets: [
      "cyrillic-ext",
      "latin",
      "latin-ext",
      "math",
      "vietnamese"
    ]
  },
  {
    category: "serif",
    name: "Namdhinggo",
    sane: "namdhinggo",
    variants: [
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "limbu"
    ]
  },
  {
    category: "handwriting",
    name: "Nanum Brush Script",
    sane: "nanum_brush_script",
    variants: [
      "0,400"
    ],
    subsets: [
      "korean",
      "latin"
    ]
  },
  {
    category: "sans-serif",
    name: "Nanum Gothic",
    sane: "nanum_gothic",
    variants: [
      "0,400",
      "0,700",
      "0,800"
    ],
    subsets: [
      "korean",
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Nanum Gothic Coding",
    sane: "nanum_gothic_coding",
    variants: [
      "0,400",
      "0,700"
    ],
    subsets: [
      "korean",
      "latin"
    ]
  },
  {
    category: "serif",
    name: "Nanum Myeongjo",
    sane: "nanum_myeongjo",
    variants: [
      "0,400",
      "0,700",
      "0,800"
    ],
    subsets: [
      "korean",
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Nanum Pen Script",
    sane: "nanum_pen_script",
    variants: [
      "0,400"
    ],
    subsets: [
      "korean",
      "latin"
    ]
  },
  {
    category: "serif",
    name: "Narnoor",
    sane: "narnoor",
    variants: [
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800"
    ],
    subsets: [
      "gunjala-gondi",
      "latin",
      "latin-ext",
      "math",
      "symbols"
    ]
  },
  {
    category: "handwriting",
    name: "Neonderthaw",
    sane: "neonderthaw",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "handwriting",
    name: "Nerko One",
    sane: "nerko_one",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "handwriting",
    name: "Neucha",
    sane: "neucha",
    variants: [
      "0,400"
    ],
    subsets: [
      "cyrillic",
      "latin"
    ]
  },
  {
    category: "serif",
    name: "Neuton",
    sane: "neuton",
    variants: [
      "0,200",
      "0,300",
      "0,400",
      "1,400",
      "0,700",
      "0,800"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "New Amsterdam",
    sane: "new_amsterdam",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "New Rocker",
    sane: "new_rocker",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "New Tegomin",
    sane: "new_tegomin",
    variants: [
      "0,400"
    ],
    subsets: [
      "japanese",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "News Cycle",
    sane: "news_cycle",
    variants: [
      "0,400",
      "0,700"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Newsreader",
    sane: "newsreader",
    variants: [
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "1,200",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700",
      "1,800"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "handwriting",
    name: "Niconne",
    sane: "niconne",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Niramit",
    sane: "niramit",
    variants: [
      "0,200",
      "1,200",
      "0,300",
      "1,300",
      "0,400",
      "1,400",
      "0,500",
      "1,500",
      "0,600",
      "1,600",
      "0,700",
      "1,700"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "thai",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "Nixie One",
    sane: "nixie_one",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "sans-serif",
    name: "Nobile",
    sane: "nobile",
    variants: [
      "0,400",
      "1,400",
      "0,500",
      "1,500",
      "0,700",
      "1,700"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Nokora",
    sane: "nokora",
    variants: [
      "0,100",
      "0,300",
      "0,400",
      "0,700",
      "0,900"
    ],
    subsets: [
      "khmer",
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Norican",
    sane: "norican",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Nosifer",
    sane: "nosifer",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Notable",
    sane: "notable",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Nothing You Could Do",
    sane: "nothing_you_could_do",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "serif",
    name: "Noticia Text",
    sane: "noticia_text",
    variants: [
      "0,400",
      "1,400",
      "0,700",
      "1,700"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Kufi Arabic",
    sane: "noto_kufi_arabic",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "arabic",
      "latin",
      "latin-ext",
      "math",
      "symbols"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Music",
    sane: "noto_music",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "music"
    ]
  },
  {
    category: "serif",
    name: "Noto Naskh Arabic",
    sane: "noto_naskh_arabic",
    variants: [
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    subsets: [
      "arabic",
      "latin",
      "latin-ext",
      "math",
      "symbols"
    ]
  },
  {
    category: "serif",
    name: "Noto Nastaliq Urdu",
    sane: "noto_nastaliq_urdu",
    variants: [
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    subsets: [
      "arabic",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Noto Rashi Hebrew",
    sane: "noto_rashi_hebrew",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "greek-ext",
      "hebrew",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans",
    sane: "noto_sans",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900",
      "1,100",
      "1,200",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700",
      "1,800",
      "1,900"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "devanagari",
      "greek",
      "greek-ext",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Adlam",
    sane: "noto_sans_adlam",
    variants: [
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    subsets: [
      "adlam",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Adlam Unjoined",
    sane: "noto_sans_adlam_unjoined",
    variants: [
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    subsets: [
      "adlam",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Anatolian Hieroglyphs",
    sane: "noto_sans_anatolian_hieroglyphs",
    variants: [
      "0,400"
    ],
    subsets: [
      "anatolian-hieroglyphs",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Armenian",
    sane: "noto_sans_armenian",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "armenian",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Avestan",
    sane: "noto_sans_avestan",
    variants: [
      "0,400"
    ],
    subsets: [
      "avestan",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Balinese",
    sane: "noto_sans_balinese",
    variants: [
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    subsets: [
      "balinese",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Bamum",
    sane: "noto_sans_bamum",
    variants: [
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    subsets: [
      "bamum",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Bassa Vah",
    sane: "noto_sans_bassa_vah",
    variants: [
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    subsets: [
      "bassa-vah",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Batak",
    sane: "noto_sans_batak",
    variants: [
      "0,400"
    ],
    subsets: [
      "batak",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Bengali",
    sane: "noto_sans_bengali",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "bengali",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Bhaiksuki",
    sane: "noto_sans_bhaiksuki",
    variants: [
      "0,400"
    ],
    subsets: [
      "bhaiksuki",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Brahmi",
    sane: "noto_sans_brahmi",
    variants: [
      "0,400"
    ],
    subsets: [
      "brahmi",
      "latin",
      "latin-ext",
      "math",
      "symbols"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Buginese",
    sane: "noto_sans_buginese",
    variants: [
      "0,400"
    ],
    subsets: [
      "buginese",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Buhid",
    sane: "noto_sans_buhid",
    variants: [
      "0,400"
    ],
    subsets: [
      "buhid",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Canadian Aboriginal",
    sane: "noto_sans_canadian_aboriginal",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "canadian-aboriginal",
      "latin",
      "latin-ext",
      "math",
      "symbols"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Carian",
    sane: "noto_sans_carian",
    variants: [
      "0,400"
    ],
    subsets: [
      "carian",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Caucasian Albanian",
    sane: "noto_sans_caucasian_albanian",
    variants: [
      "0,400"
    ],
    subsets: [
      "caucasian-albanian",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Chakma",
    sane: "noto_sans_chakma",
    variants: [
      "0,400"
    ],
    subsets: [
      "chakma",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Cham",
    sane: "noto_sans_cham",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "cham",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Cherokee",
    sane: "noto_sans_cherokee",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "cherokee",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Chorasmian",
    sane: "noto_sans_chorasmian",
    variants: [
      "0,400"
    ],
    subsets: [
      "chorasmian",
      "latin",
      "latin-ext",
      "math",
      "symbols"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Coptic",
    sane: "noto_sans_coptic",
    variants: [
      "0,400"
    ],
    subsets: [
      "coptic",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Cuneiform",
    sane: "noto_sans_cuneiform",
    variants: [
      "0,400"
    ],
    subsets: [
      "cuneiform",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Cypriot",
    sane: "noto_sans_cypriot",
    variants: [
      "0,400"
    ],
    subsets: [
      "cypriot",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Cypro Minoan",
    sane: "noto_sans_cypro_minoan",
    variants: [
      "0,400"
    ],
    subsets: [
      "cypro-minoan",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Deseret",
    sane: "noto_sans_deseret",
    variants: [
      "0,400"
    ],
    subsets: [
      "deseret",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Devanagari",
    sane: "noto_sans_devanagari",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "devanagari",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Display",
    sane: "noto_sans_display",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900",
      "1,100",
      "1,200",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700",
      "1,800",
      "1,900"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "greek",
      "greek-ext",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Duployan",
    sane: "noto_sans_duployan",
    variants: [
      "0,400",
      "0,700"
    ],
    subsets: [
      "duployan",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Egyptian Hieroglyphs",
    sane: "noto_sans_egyptian_hieroglyphs",
    variants: [
      "0,400"
    ],
    subsets: [
      "egyptian-hieroglyphs",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Elbasan",
    sane: "noto_sans_elbasan",
    variants: [
      "0,400"
    ],
    subsets: [
      "elbasan",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Elymaic",
    sane: "noto_sans_elymaic",
    variants: [
      "0,400"
    ],
    subsets: [
      "elymaic",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Ethiopic",
    sane: "noto_sans_ethiopic",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "ethiopic",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Georgian",
    sane: "noto_sans_georgian",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "cyrillic-ext",
      "georgian",
      "greek-ext",
      "latin",
      "latin-ext",
      "math",
      "symbols"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Glagolitic",
    sane: "noto_sans_glagolitic",
    variants: [
      "0,400"
    ],
    subsets: [
      "cyrillic-ext",
      "glagolitic",
      "latin",
      "latin-ext",
      "math",
      "symbols"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Gothic",
    sane: "noto_sans_gothic",
    variants: [
      "0,400"
    ],
    subsets: [
      "gothic",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Grantha",
    sane: "noto_sans_grantha",
    variants: [
      "0,400"
    ],
    subsets: [
      "grantha",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Gujarati",
    sane: "noto_sans_gujarati",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "gujarati",
      "latin",
      "latin-ext",
      "math",
      "symbols"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Gunjala Gondi",
    sane: "noto_sans_gunjala_gondi",
    variants: [
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    subsets: [
      "gunjala-gondi",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Gurmukhi",
    sane: "noto_sans_gurmukhi",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "gurmukhi",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Hanifi Rohingya",
    sane: "noto_sans_hanifi_rohingya",
    variants: [
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    subsets: [
      "hanifi-rohingya",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Hanunoo",
    sane: "noto_sans_hanunoo",
    variants: [
      "0,400"
    ],
    subsets: [
      "hanunoo",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Hatran",
    sane: "noto_sans_hatran",
    variants: [
      "0,400"
    ],
    subsets: [
      "hatran",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Hebrew",
    sane: "noto_sans_hebrew",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "cyrillic-ext",
      "greek-ext",
      "hebrew",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans HK",
    sane: "noto_sans_hk",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "chinese-hongkong",
      "cyrillic",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Imperial Aramaic",
    sane: "noto_sans_imperial_aramaic",
    variants: [
      "0,400"
    ],
    subsets: [
      "imperial-aramaic",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Indic Siyaq Numbers",
    sane: "noto_sans_indic_siyaq_numbers",
    variants: [
      "0,400"
    ],
    subsets: [
      "indic-siyaq-numbers",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Inscriptional Pahlavi",
    sane: "noto_sans_inscriptional_pahlavi",
    variants: [
      "0,400"
    ],
    subsets: [
      "inscriptional-pahlavi",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Inscriptional Parthian",
    sane: "noto_sans_inscriptional_parthian",
    variants: [
      "0,400"
    ],
    subsets: [
      "inscriptional-parthian",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Javanese",
    sane: "noto_sans_javanese",
    variants: [
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    subsets: [
      "javanese",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans JP",
    sane: "noto_sans_jp",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "cyrillic",
      "japanese",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Kaithi",
    sane: "noto_sans_kaithi",
    variants: [
      "0,400"
    ],
    subsets: [
      "kaithi",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Kannada",
    sane: "noto_sans_kannada",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "kannada",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Kawi",
    sane: "noto_sans_kawi",
    variants: [
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    subsets: [
      "kawi",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Kayah Li",
    sane: "noto_sans_kayah_li",
    variants: [
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    subsets: [
      "kayah-li",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Kharoshthi",
    sane: "noto_sans_kharoshthi",
    variants: [
      "0,400"
    ],
    subsets: [
      "kharoshthi",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Khmer",
    sane: "noto_sans_khmer",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "khmer",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Khojki",
    sane: "noto_sans_khojki",
    variants: [
      "0,400"
    ],
    subsets: [
      "khojki",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Khudawadi",
    sane: "noto_sans_khudawadi",
    variants: [
      "0,400"
    ],
    subsets: [
      "khudawadi",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans KR",
    sane: "noto_sans_kr",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "cyrillic",
      "korean",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Lao",
    sane: "noto_sans_lao",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "lao",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Lao Looped",
    sane: "noto_sans_lao_looped",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "lao",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Lepcha",
    sane: "noto_sans_lepcha",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "lepcha"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Limbu",
    sane: "noto_sans_limbu",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "limbu"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Linear A",
    sane: "noto_sans_linear_a",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "linear-a"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Linear B",
    sane: "noto_sans_linear_b",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "linear-b"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Lisu",
    sane: "noto_sans_lisu",
    variants: [
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "lisu"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Lydian",
    sane: "noto_sans_lydian",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "lydian"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Mahajani",
    sane: "noto_sans_mahajani",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "mahajani"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Malayalam",
    sane: "noto_sans_malayalam",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "malayalam"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Mandaic",
    sane: "noto_sans_mandaic",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "mandaic"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Manichaean",
    sane: "noto_sans_manichaean",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "manichaean"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Marchen",
    sane: "noto_sans_marchen",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "marchen"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Masaram Gondi",
    sane: "noto_sans_masaram_gondi",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "masaram-gondi"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Mayan Numerals",
    sane: "noto_sans_mayan_numerals",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "mayan-numerals"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Medefaidrin",
    sane: "noto_sans_medefaidrin",
    variants: [
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "medefaidrin"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Meetei Mayek",
    sane: "noto_sans_meetei_mayek",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "meetei-mayek"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Mende Kikakui",
    sane: "noto_sans_mende_kikakui",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "mende-kikakui"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Meroitic",
    sane: "noto_sans_meroitic",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "meroitic",
      "meroitic-cursive",
      "meroitic-hieroglyphs"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Miao",
    sane: "noto_sans_miao",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "miao"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Modi",
    sane: "noto_sans_modi",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "modi"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Mongolian",
    sane: "noto_sans_mongolian",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "math",
      "mongolian",
      "symbols"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Mono",
    sane: "noto_sans_mono",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "greek",
      "greek-ext",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Mro",
    sane: "noto_sans_mro",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "mro"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Multani",
    sane: "noto_sans_multani",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "multani"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Nabataean",
    sane: "noto_sans_nabataean",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "nabataean"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Nag Mundari",
    sane: "noto_sans_nag_mundari",
    variants: [
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "nag-mundari"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Nandinagari",
    sane: "noto_sans_nandinagari",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "nandinagari"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans New Tai Lue",
    sane: "noto_sans_new_tai_lue",
    variants: [
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "new-tai-lue"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Newa",
    sane: "noto_sans_newa",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "newa"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans NKo",
    sane: "noto_sans_nko",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "nko"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans NKo Unjoined",
    sane: "noto_sans_nko_unjoined",
    variants: [
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "nko"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Nushu",
    sane: "noto_sans_nushu",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "nushu"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Ogham",
    sane: "noto_sans_ogham",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "ogham"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Ol Chiki",
    sane: "noto_sans_ol_chiki",
    variants: [
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "ol-chiki"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Old Hungarian",
    sane: "noto_sans_old_hungarian",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "old-hungarian"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Old Italic",
    sane: "noto_sans_old_italic",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "old-italic"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Old North Arabian",
    sane: "noto_sans_old_north_arabian",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "old-north-arabian"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Old Permic",
    sane: "noto_sans_old_permic",
    variants: [
      "0,400"
    ],
    subsets: [
      "cyrillic-ext",
      "latin",
      "latin-ext",
      "old-permic"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Old Persian",
    sane: "noto_sans_old_persian",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "old-persian"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Old Sogdian",
    sane: "noto_sans_old_sogdian",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "old-sogdian"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Old South Arabian",
    sane: "noto_sans_old_south_arabian",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "old-south-arabian"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Old Turkic",
    sane: "noto_sans_old_turkic",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "old-turkic"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Oriya",
    sane: "noto_sans_oriya",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "oriya"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Osage",
    sane: "noto_sans_osage",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "osage"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Osmanya",
    sane: "noto_sans_osmanya",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "osmanya"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Pahawh Hmong",
    sane: "noto_sans_pahawh_hmong",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "pahawh-hmong"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Palmyrene",
    sane: "noto_sans_palmyrene",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "palmyrene"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Pau Cin Hau",
    sane: "noto_sans_pau_cin_hau",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "pau-cin-hau"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans PhagsPa",
    sane: "noto_sans_phagspa",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "math",
      "phags-pa",
      "symbols"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Phoenician",
    sane: "noto_sans_phoenician",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "phoenician"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Psalter Pahlavi",
    sane: "noto_sans_psalter_pahlavi",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "psalter-pahlavi"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Rejang",
    sane: "noto_sans_rejang",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "rejang"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Runic",
    sane: "noto_sans_runic",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "runic"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Samaritan",
    sane: "noto_sans_samaritan",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "samaritan"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Saurashtra",
    sane: "noto_sans_saurashtra",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "saurashtra"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans SC",
    sane: "noto_sans_sc",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "chinese-simplified",
      "cyrillic",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Sharada",
    sane: "noto_sans_sharada",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "sharada"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Shavian",
    sane: "noto_sans_shavian",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "shavian"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Siddham",
    sane: "noto_sans_siddham",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "siddham"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans SignWriting",
    sane: "noto_sans_signwriting",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "signwriting"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Sinhala",
    sane: "noto_sans_sinhala",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "sinhala"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Sogdian",
    sane: "noto_sans_sogdian",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "sogdian"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Sora Sompeng",
    sane: "noto_sans_sora_sompeng",
    variants: [
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "sora-sompeng"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Soyombo",
    sane: "noto_sans_soyombo",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "soyombo"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Sundanese",
    sane: "noto_sans_sundanese",
    variants: [
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "sundanese"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Syloti Nagri",
    sane: "noto_sans_syloti_nagri",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "syloti-nagri"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Symbols",
    sane: "noto_sans_symbols",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "symbols"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Symbols 2",
    sane: "noto_sans_symbols_2",
    variants: [
      "0,400"
    ],
    subsets: [
      "braille",
      "latin",
      "latin-ext",
      "math",
      "mayan-numerals",
      "symbols"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Syriac",
    sane: "noto_sans_syriac",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "syriac"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Syriac Eastern",
    sane: "noto_sans_syriac_eastern",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "syriac"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Tagalog",
    sane: "noto_sans_tagalog",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "tagalog"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Tagbanwa",
    sane: "noto_sans_tagbanwa",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "tagbanwa"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Tai Le",
    sane: "noto_sans_tai_le",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "tai-le"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Tai Tham",
    sane: "noto_sans_tai_tham",
    variants: [
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "tai-tham"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Tai Viet",
    sane: "noto_sans_tai_viet",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "tai-viet"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Takri",
    sane: "noto_sans_takri",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "takri"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Tamil",
    sane: "noto_sans_tamil",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "tamil"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Tamil Supplement",
    sane: "noto_sans_tamil_supplement",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "tamil-supplement"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Tangsa",
    sane: "noto_sans_tangsa",
    variants: [
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "tangsa"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans TC",
    sane: "noto_sans_tc",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "chinese-traditional",
      "cyrillic",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Telugu",
    sane: "noto_sans_telugu",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "telugu"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Thaana",
    sane: "noto_sans_thaana",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "thaana"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Thai",
    sane: "noto_sans_thai",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "thai"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Thai Looped",
    sane: "noto_sans_thai_looped",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "thai"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Tifinagh",
    sane: "noto_sans_tifinagh",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "tifinagh"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Tirhuta",
    sane: "noto_sans_tirhuta",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "tirhuta"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Ugaritic",
    sane: "noto_sans_ugaritic",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "ugaritic"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Vai",
    sane: "noto_sans_vai",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vai"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Vithkuqi",
    sane: "noto_sans_vithkuqi",
    variants: [
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vithkuqi"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Wancho",
    sane: "noto_sans_wancho",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "wancho"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Warang Citi",
    sane: "noto_sans_warang_citi",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "warang-citi"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Yi",
    sane: "noto_sans_yi",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "yi"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Sans Zanabazar Square",
    sane: "noto_sans_zanabazar_square",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "zanabazar-square"
    ]
  },
  {
    category: "serif",
    name: "Noto Serif",
    sane: "noto_serif",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900",
      "1,100",
      "1,200",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700",
      "1,800",
      "1,900"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "greek",
      "greek-ext",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "serif",
    name: "Noto Serif Ahom",
    sane: "noto_serif_ahom",
    variants: [
      "0,400"
    ],
    subsets: [
      "ahom",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Noto Serif Armenian",
    sane: "noto_serif_armenian",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "armenian",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Noto Serif Balinese",
    sane: "noto_serif_balinese",
    variants: [
      "0,400"
    ],
    subsets: [
      "balinese",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Noto Serif Bengali",
    sane: "noto_serif_bengali",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "bengali",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Noto Serif Devanagari",
    sane: "noto_serif_devanagari",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "devanagari",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Noto Serif Display",
    sane: "noto_serif_display",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900",
      "1,100",
      "1,200",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700",
      "1,800",
      "1,900"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "greek",
      "greek-ext",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "serif",
    name: "Noto Serif Dogra",
    sane: "noto_serif_dogra",
    variants: [
      "0,400"
    ],
    subsets: [
      "dogra",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Noto Serif Ethiopic",
    sane: "noto_serif_ethiopic",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "ethiopic",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Noto Serif Georgian",
    sane: "noto_serif_georgian",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "georgian",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Noto Serif Grantha",
    sane: "noto_serif_grantha",
    variants: [
      "0,400"
    ],
    subsets: [
      "grantha",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Noto Serif Gujarati",
    sane: "noto_serif_gujarati",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "gujarati",
      "latin",
      "latin-ext",
      "math",
      "symbols"
    ]
  },
  {
    category: "serif",
    name: "Noto Serif Gurmukhi",
    sane: "noto_serif_gurmukhi",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "gurmukhi",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Noto Serif Hebrew",
    sane: "noto_serif_hebrew",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "hebrew",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Noto Serif Hentaigana",
    sane: "noto_serif_hentaigana",
    variants: [
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "kana-extended",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Noto Serif HK",
    sane: "noto_serif_hk",
    variants: [
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "chinese-hongkong",
      "cyrillic",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "serif",
    name: "Noto Serif JP",
    sane: "noto_serif_jp",
    variants: [
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "cyrillic",
      "japanese",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "serif",
    name: "Noto Serif Kannada",
    sane: "noto_serif_kannada",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "kannada",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Noto Serif Khitan Small Script",
    sane: "noto_serif_khitan_small_script",
    variants: [
      "0,400"
    ],
    subsets: [
      "khitan-small-script",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Noto Serif Khmer",
    sane: "noto_serif_khmer",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "khmer",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Noto Serif Khojki",
    sane: "noto_serif_khojki",
    variants: [
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    subsets: [
      "khojki",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Noto Serif KR",
    sane: "noto_serif_kr",
    variants: [
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "cyrillic",
      "korean",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "serif",
    name: "Noto Serif Lao",
    sane: "noto_serif_lao",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "lao",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Noto Serif Makasar",
    sane: "noto_serif_makasar",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "makasar"
    ]
  },
  {
    category: "serif",
    name: "Noto Serif Malayalam",
    sane: "noto_serif_malayalam",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "malayalam"
    ]
  },
  {
    category: "serif",
    name: "Noto Serif NP Hmong",
    sane: "noto_serif_np_hmong",
    variants: [
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    subsets: [
      "latin",
      "nyiakeng-puachue-hmong"
    ]
  },
  {
    category: "serif",
    name: "Noto Serif Old Uyghur",
    sane: "noto_serif_old_uyghur",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "old-uyghur"
    ]
  },
  {
    category: "serif",
    name: "Noto Serif Oriya",
    sane: "noto_serif_oriya",
    variants: [
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "oriya"
    ]
  },
  {
    category: "serif",
    name: "Noto Serif Ottoman Siyaq",
    sane: "noto_serif_ottoman_siyaq",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "ottoman-siyaq-numbers"
    ]
  },
  {
    category: "serif",
    name: "Noto Serif SC",
    sane: "noto_serif_sc",
    variants: [
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "chinese-simplified",
      "cyrillic",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "serif",
    name: "Noto Serif Sinhala",
    sane: "noto_serif_sinhala",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "sinhala"
    ]
  },
  {
    category: "serif",
    name: "Noto Serif Tamil",
    sane: "noto_serif_tamil",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900",
      "1,100",
      "1,200",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700",
      "1,800",
      "1,900"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "tamil"
    ]
  },
  {
    category: "serif",
    name: "Noto Serif Tangut",
    sane: "noto_serif_tangut",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "tangut"
    ]
  },
  {
    category: "serif",
    name: "Noto Serif TC",
    sane: "noto_serif_tc",
    variants: [
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "chinese-traditional",
      "cyrillic",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "serif",
    name: "Noto Serif Telugu",
    sane: "noto_serif_telugu",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "telugu"
    ]
  },
  {
    category: "serif",
    name: "Noto Serif Thai",
    sane: "noto_serif_thai",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "thai"
    ]
  },
  {
    category: "serif",
    name: "Noto Serif Tibetan",
    sane: "noto_serif_tibetan",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "tibetan"
    ]
  },
  {
    category: "serif",
    name: "Noto Serif Todhri",
    sane: "noto_serif_todhri",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "todhri"
    ]
  },
  {
    category: "serif",
    name: "Noto Serif Toto",
    sane: "noto_serif_toto",
    variants: [
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "toto"
    ]
  },
  {
    category: "serif",
    name: "Noto Serif Vithkuqi",
    sane: "noto_serif_vithkuqi",
    variants: [
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vithkuqi"
    ]
  },
  {
    category: "serif",
    name: "Noto Serif Yezidi",
    sane: "noto_serif_yezidi",
    variants: [
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "yezidi"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Traditional Nushu",
    sane: "noto_traditional_nushu",
    variants: [
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "nushu"
    ]
  },
  {
    category: "sans-serif",
    name: "Noto Znamenny Musical Notation",
    sane: "noto_znamenny_musical_notation",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "math",
      "symbols",
      "znamenny"
    ]
  },
  {
    category: "display",
    name: "Nova Cut",
    sane: "nova_cut",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Nova Flat",
    sane: "nova_flat",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "monospace",
    name: "Nova Mono",
    sane: "nova_mono",
    variants: [
      "0,400"
    ],
    subsets: [
      "greek",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Nova Oval",
    sane: "nova_oval",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Nova Round",
    sane: "nova_round",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Nova Script",
    sane: "nova_script",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Nova Slim",
    sane: "nova_slim",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Nova Square",
    sane: "nova_square",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "NTR",
    sane: "ntr",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "telugu"
    ]
  },
  {
    category: "sans-serif",
    name: "Numans",
    sane: "numans",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "sans-serif",
    name: "Nunito",
    sane: "nunito",
    variants: [
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900",
      "1,200",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700",
      "1,800",
      "1,900"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Nunito Sans",
    sane: "nunito_sans",
    variants: [
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900",
      "1,200",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700",
      "1,800",
      "1,900"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Nuosu SIL",
    sane: "nuosu_sil",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "yi"
    ]
  },
  {
    category: "display",
    name: "Odibee Sans",
    sane: "odibee_sans",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "serif",
    name: "Odor Mean Chey",
    sane: "odor_mean_chey",
    variants: [
      "0,400"
    ],
    subsets: [
      "khmer",
      "latin"
    ]
  },
  {
    category: "display",
    name: "Offside",
    sane: "offside",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Oi",
    sane: "oi",
    variants: [
      "0,400"
    ],
    subsets: [
      "arabic",
      "cyrillic",
      "cyrillic-ext",
      "greek",
      "latin",
      "latin-ext",
      "tamil",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Ojuju",
    sane: "ojuju",
    variants: [
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "math",
      "symbols",
      "vietnamese"
    ]
  },
  {
    category: "serif",
    name: "Old Standard TT",
    sane: "old_standard_tt",
    variants: [
      "0,400",
      "1,400",
      "0,700"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "Oldenburg",
    sane: "oldenburg",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "handwriting",
    name: "Ole",
    sane: "ole",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "Oleo Script",
    sane: "oleo_script",
    variants: [
      "0,400",
      "0,700"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Oleo Script Swash Caps",
    sane: "oleo_script_swash_caps",
    variants: [
      "0,400",
      "0,700"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Onest",
    sane: "onest",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "handwriting",
    name: "Oooh Baby",
    sane: "oooh_baby",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Open Sans",
    sane: "open_sans",
    variants: [
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700",
      "1,800"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "greek",
      "greek-ext",
      "hebrew",
      "latin",
      "latin-ext",
      "math",
      "symbols",
      "vietnamese"
    ]
  },
  {
    category: "serif",
    name: "Oranienbaum",
    sane: "oranienbaum",
    variants: [
      "0,400"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Orbit",
    sane: "orbit",
    variants: [
      "0,400"
    ],
    subsets: [
      "korean",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Orbitron",
    sane: "orbitron",
    variants: [
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "display",
    name: "Oregano",
    sane: "oregano",
    variants: [
      "0,400",
      "1,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Orelega One",
    sane: "orelega_one",
    variants: [
      "0,400"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Orienta",
    sane: "orienta",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Original Surfer",
    sane: "original_surfer",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Oswald",
    sane: "oswald",
    variants: [
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Outfit",
    sane: "outfit",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "handwriting",
    name: "Over the Rainbow",
    sane: "over_the_rainbow",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Overlock",
    sane: "overlock",
    variants: [
      "0,400",
      "1,400",
      "0,700",
      "1,700",
      "0,900",
      "1,900"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Overlock SC",
    sane: "overlock_sc",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Overpass",
    sane: "overpass",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900",
      "1,100",
      "1,200",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700",
      "1,800",
      "1,900"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "monospace",
    name: "Overpass Mono",
    sane: "overpass_mono",
    variants: [
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "serif",
    name: "Ovo",
    sane: "ovo",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "display",
    name: "Oxanium",
    sane: "oxanium",
    variants: [
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Oxygen",
    sane: "oxygen",
    variants: [
      "0,300",
      "0,400",
      "0,700"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "monospace",
    name: "Oxygen Mono",
    sane: "oxygen_mono",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "handwriting",
    name: "Pacifico",
    sane: "pacifico",
    variants: [
      "0,400"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Padauk",
    sane: "padauk",
    variants: [
      "0,400",
      "0,700"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "myanmar"
    ]
  },
  {
    category: "serif",
    name: "Padyakke Expanded One",
    sane: "padyakke_expanded_one",
    variants: [
      "0,400"
    ],
    subsets: [
      "kannada",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Palanquin",
    sane: "palanquin",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    subsets: [
      "devanagari",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Palanquin Dark",
    sane: "palanquin_dark",
    variants: [
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    subsets: [
      "devanagari",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Palette Mosaic",
    sane: "palette_mosaic",
    variants: [
      "0,400"
    ],
    subsets: [
      "japanese",
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Pangolin",
    sane: "pangolin",
    variants: [
      "0,400"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "Paprika",
    sane: "paprika",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "handwriting",
    name: "Parisienne",
    sane: "parisienne",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Parkinsans",
    sane: "parkinsans",
    variants: [
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Passero One",
    sane: "passero_one",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Passion One",
    sane: "passion_one",
    variants: [
      "0,400",
      "0,700",
      "0,900"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "handwriting",
    name: "Passions Conflict",
    sane: "passions_conflict",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Pathway Extreme",
    sane: "pathway_extreme",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900",
      "1,100",
      "1,200",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700",
      "1,800",
      "1,900"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Pathway Gothic One",
    sane: "pathway_gothic_one",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "handwriting",
    name: "Patrick Hand",
    sane: "patrick_hand",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "handwriting",
    name: "Patrick Hand SC",
    sane: "patrick_hand_sc",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Pattaya",
    sane: "pattaya",
    variants: [
      "0,400"
    ],
    subsets: [
      "cyrillic",
      "latin",
      "latin-ext",
      "thai",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "Patua One",
    sane: "patua_one",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "sans-serif",
    name: "Pavanam",
    sane: "pavanam",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "tamil"
    ]
  },
  {
    category: "sans-serif",
    name: "Paytone One",
    sane: "paytone_one",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "serif",
    name: "Peddana",
    sane: "peddana",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "telugu"
    ]
  },
  {
    category: "serif",
    name: "Peralta",
    sane: "peralta",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "handwriting",
    name: "Permanent Marker",
    sane: "permanent_marker",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Petemoss",
    sane: "petemoss",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "handwriting",
    name: "Petit Formal Script",
    sane: "petit_formal_script",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Petrona",
    sane: "petrona",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900",
      "1,100",
      "1,200",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700",
      "1,800",
      "1,900"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Philosopher",
    sane: "philosopher",
    variants: [
      "0,400",
      "1,400",
      "0,700",
      "1,700"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "Phudu",
    sane: "phudu",
    variants: [
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "cyrillic-ext",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "serif",
    name: "Piazzolla",
    sane: "piazzolla",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900",
      "1,100",
      "1,200",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700",
      "1,800",
      "1,900"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "greek",
      "greek-ext",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "Piedra",
    sane: "piedra",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "handwriting",
    name: "Pinyon Script",
    sane: "pinyon_script",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "Pirata One",
    sane: "pirata_one",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Pixelify Sans",
    sane: "pixelify_sans",
    variants: [
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    subsets: [
      "cyrillic",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Plaster",
    sane: "plaster",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Platypi",
    sane: "platypi",
    variants: [
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700",
      "1,800"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Play",
    sane: "play",
    variants: [
      "0,400",
      "0,700"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "greek",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "Playball",
    sane: "playball",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "serif",
    name: "Playfair",
    sane: "playfair",
    variants: [
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700",
      "1,800",
      "1,900"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "serif",
    name: "Playfair Display",
    sane: "playfair_display",
    variants: [
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900",
      "1,400",
      "1,500",
      "1,600",
      "1,700",
      "1,800",
      "1,900"
    ],
    subsets: [
      "cyrillic",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "serif",
    name: "Playfair Display SC",
    sane: "playfair_display_sc",
    variants: [
      "0,400",
      "1,400",
      "0,700",
      "1,700",
      "0,900",
      "1,900"
    ],
    subsets: [
      "cyrillic",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "handwriting",
    name: "Playpen Sans",
    sane: "playpen_sans",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800"
    ],
    subsets: [
      "emoji",
      "latin",
      "latin-ext",
      "math",
      "vietnamese"
    ]
  },
  {
    category: "handwriting",
    name: "Playwrite AR",
    sane: "playwrite_ar",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Playwrite AR Guides",
    sane: "playwrite_ar_guides",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Playwrite AT",
    sane: "playwrite_at",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "1,100",
      "1,200",
      "1,300",
      "1,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Playwrite AT Guides",
    sane: "playwrite_at_guides",
    variants: [
      "0,400",
      "1,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Playwrite AU NSW",
    sane: "playwrite_au_nsw",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Playwrite AU NSW Guides",
    sane: "playwrite_au_nsw_guides",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Playwrite AU QLD",
    sane: "playwrite_au_qld",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Playwrite AU QLD Guides",
    sane: "playwrite_au_qld_guides",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Playwrite AU SA",
    sane: "playwrite_au_sa",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Playwrite AU SA Guides",
    sane: "playwrite_au_sa_guides",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Playwrite AU TAS",
    sane: "playwrite_au_tas",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Playwrite AU TAS Guides",
    sane: "playwrite_au_tas_guides",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Playwrite AU VIC",
    sane: "playwrite_au_vic",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Playwrite AU VIC Guides",
    sane: "playwrite_au_vic_guides",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Playwrite BE VLG",
    sane: "playwrite_be_vlg",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Playwrite BE VLG Guides",
    sane: "playwrite_be_vlg_guides",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Playwrite BE WAL",
    sane: "playwrite_be_wal",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Playwrite BE WAL Guides",
    sane: "playwrite_be_wal_guides",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Playwrite BR",
    sane: "playwrite_br",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Playwrite BR Guides",
    sane: "playwrite_br_guides",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Playwrite CA",
    sane: "playwrite_ca",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Playwrite CA Guides",
    sane: "playwrite_ca_guides",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Playwrite CL",
    sane: "playwrite_cl",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Playwrite CL Guides",
    sane: "playwrite_cl_guides",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Playwrite CO",
    sane: "playwrite_co",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Playwrite CO Guides",
    sane: "playwrite_co_guides",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Playwrite CU",
    sane: "playwrite_cu",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Playwrite CU Guides",
    sane: "playwrite_cu_guides",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Playwrite CZ",
    sane: "playwrite_cz",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Playwrite CZ Guides",
    sane: "playwrite_cz_guides",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Playwrite DE Grund",
    sane: "playwrite_de_grund",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Playwrite DE Grund Guides",
    sane: "playwrite_de_grund_guides",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Playwrite DE LA",
    sane: "playwrite_de_la",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Playwrite DE LA Guides",
    sane: "playwrite_de_la_guides",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Playwrite DE SAS",
    sane: "playwrite_de_sas",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Playwrite DE SAS Guides",
    sane: "playwrite_de_sas_guides",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Playwrite DE VA",
    sane: "playwrite_de_va",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Playwrite DE VA Guides",
    sane: "playwrite_de_va_guides",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Playwrite DK Loopet",
    sane: "playwrite_dk_loopet",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Playwrite DK Loopet Guides",
    sane: "playwrite_dk_loopet_guides",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Playwrite DK Uloopet",
    sane: "playwrite_dk_uloopet",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Playwrite DK Uloopet Guides",
    sane: "playwrite_dk_uloopet_guides",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Playwrite ES",
    sane: "playwrite_es",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Playwrite ES Deco",
    sane: "playwrite_es_deco",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Playwrite ES Deco Guides",
    sane: "playwrite_es_deco_guides",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Playwrite ES Guides",
    sane: "playwrite_es_guides",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Playwrite FR Moderne",
    sane: "playwrite_fr_moderne",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Playwrite FR Moderne Guides",
    sane: "playwrite_fr_moderne_guides",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Playwrite FR Trad",
    sane: "playwrite_fr_trad",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Playwrite FR Trad Guides",
    sane: "playwrite_fr_trad_guides",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Playwrite GB J",
    sane: "playwrite_gb_j",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "1,100",
      "1,200",
      "1,300",
      "1,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Playwrite GB J Guides",
    sane: "playwrite_gb_j_guides",
    variants: [
      "0,400",
      "1,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Playwrite GB S",
    sane: "playwrite_gb_s",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "1,100",
      "1,200",
      "1,300",
      "1,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Playwrite GB S Guides",
    sane: "playwrite_gb_s_guides",
    variants: [
      "0,400",
      "1,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Playwrite HR",
    sane: "playwrite_hr",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Playwrite HR Guides",
    sane: "playwrite_hr_guides",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Playwrite HR Lijeva",
    sane: "playwrite_hr_lijeva",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Playwrite HR Lijeva Guides",
    sane: "playwrite_hr_lijeva_guides",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Playwrite HU",
    sane: "playwrite_hu",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Playwrite HU Guides",
    sane: "playwrite_hu_guides",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Playwrite ID",
    sane: "playwrite_id",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Playwrite ID Guides",
    sane: "playwrite_id_guides",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Playwrite IE",
    sane: "playwrite_ie",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Playwrite IE Guides",
    sane: "playwrite_ie_guides",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Playwrite IN",
    sane: "playwrite_in",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Playwrite IN Guides",
    sane: "playwrite_in_guides",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Playwrite IS",
    sane: "playwrite_is",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Playwrite IS Guides",
    sane: "playwrite_is_guides",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Playwrite IT Moderna",
    sane: "playwrite_it_moderna",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Playwrite IT Moderna Guides",
    sane: "playwrite_it_moderna_guides",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Playwrite IT Trad",
    sane: "playwrite_it_trad",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Playwrite IT Trad Guides",
    sane: "playwrite_it_trad_guides",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Playwrite MX",
    sane: "playwrite_mx",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Playwrite MX Guides",
    sane: "playwrite_mx_guides",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Playwrite NG Modern",
    sane: "playwrite_ng_modern",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Playwrite NG Modern Guides",
    sane: "playwrite_ng_modern_guides",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Playwrite NL",
    sane: "playwrite_nl",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Playwrite NL Guides",
    sane: "playwrite_nl_guides",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Playwrite NO",
    sane: "playwrite_no",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Playwrite NO Guides",
    sane: "playwrite_no_guides",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Playwrite NZ",
    sane: "playwrite_nz",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Playwrite NZ Guides",
    sane: "playwrite_nz_guides",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Playwrite PE",
    sane: "playwrite_pe",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Playwrite PE Guides",
    sane: "playwrite_pe_guides",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Playwrite PL",
    sane: "playwrite_pl",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Playwrite PL Guides",
    sane: "playwrite_pl_guides",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Playwrite PT",
    sane: "playwrite_pt",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Playwrite PT Guides",
    sane: "playwrite_pt_guides",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Playwrite RO",
    sane: "playwrite_ro",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Playwrite RO Guides",
    sane: "playwrite_ro_guides",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Playwrite SK",
    sane: "playwrite_sk",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Playwrite SK Guides",
    sane: "playwrite_sk_guides",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Playwrite TZ",
    sane: "playwrite_tz",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Playwrite TZ Guides",
    sane: "playwrite_tz_guides",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Playwrite US Modern",
    sane: "playwrite_us_modern",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Playwrite US Modern Guides",
    sane: "playwrite_us_modern_guides",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Playwrite US Trad",
    sane: "playwrite_us_trad",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Playwrite US Trad Guides",
    sane: "playwrite_us_trad_guides",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Playwrite VN",
    sane: "playwrite_vn",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Playwrite VN Guides",
    sane: "playwrite_vn_guides",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Playwrite ZA",
    sane: "playwrite_za",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Playwrite ZA Guides",
    sane: "playwrite_za_guides",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "sans-serif",
    name: "Plus Jakarta Sans",
    sane: "plus_jakarta_sans",
    variants: [
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "1,200",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700",
      "1,800"
    ],
    subsets: [
      "cyrillic-ext",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "Pochaevsk",
    sane: "pochaevsk",
    variants: [
      "0,400"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "latin"
    ]
  },
  {
    category: "serif",
    name: "Podkova",
    sane: "podkova",
    variants: [
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "Poetsen One",
    sane: "poetsen_one",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Poiret One",
    sane: "poiret_one",
    variants: [
      "0,400"
    ],
    subsets: [
      "cyrillic",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Poller One",
    sane: "poller_one",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "serif",
    name: "Poltawski Nowy",
    sane: "poltawski_nowy",
    variants: [
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "1,400",
      "1,500",
      "1,600",
      "1,700"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "serif",
    name: "Poly",
    sane: "poly",
    variants: [
      "0,400",
      "1,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Pompiere",
    sane: "pompiere",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "display",
    name: "Ponnala",
    sane: "ponnala",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "telugu"
    ]
  },
  {
    category: "sans-serif",
    name: "Pontano Sans",
    sane: "pontano_sans",
    variants: [
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Poor Story",
    sane: "poor_story",
    variants: [
      "0,400"
    ],
    subsets: [
      "korean",
      "latin"
    ]
  },
  {
    category: "sans-serif",
    name: "Poppins",
    sane: "poppins",
    variants: [
      "0,100",
      "1,100",
      "0,200",
      "1,200",
      "0,300",
      "1,300",
      "0,400",
      "1,400",
      "0,500",
      "1,500",
      "0,600",
      "1,600",
      "0,700",
      "1,700",
      "0,800",
      "1,800",
      "0,900",
      "1,900"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Port Lligat Sans",
    sane: "port_lligat_sans",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "serif",
    name: "Port Lligat Slab",
    sane: "port_lligat_slab",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "display",
    name: "Potta One",
    sane: "potta_one",
    variants: [
      "0,400"
    ],
    subsets: [
      "japanese",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Pragati Narrow",
    sane: "pragati_narrow",
    variants: [
      "0,400",
      "0,700"
    ],
    subsets: [
      "devanagari",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "handwriting",
    name: "Praise",
    sane: "praise",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "serif",
    name: "Prata",
    sane: "prata",
    variants: [
      "0,400"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "latin",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Preahvihear",
    sane: "preahvihear",
    variants: [
      "0,400"
    ],
    subsets: [
      "khmer",
      "latin"
    ]
  },
  {
    category: "display",
    name: "Press Start 2P",
    sane: "press_start_2p",
    variants: [
      "0,400"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "greek",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Pridi",
    sane: "pridi",
    variants: [
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "thai",
      "vietnamese"
    ]
  },
  {
    category: "handwriting",
    name: "Princess Sofia",
    sane: "princess_sofia",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Prociono",
    sane: "prociono",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "sans-serif",
    name: "Prompt",
    sane: "prompt",
    variants: [
      "0,100",
      "1,100",
      "0,200",
      "1,200",
      "0,300",
      "1,300",
      "0,400",
      "1,400",
      "0,500",
      "1,500",
      "0,600",
      "1,600",
      "0,700",
      "1,700",
      "0,800",
      "1,800",
      "0,900",
      "1,900"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "thai",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "Prosto One",
    sane: "prosto_one",
    variants: [
      "0,400"
    ],
    subsets: [
      "cyrillic",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Protest Guerrilla",
    sane: "protest_guerrilla",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "math",
      "symbols",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "Protest Revolution",
    sane: "protest_revolution",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "math",
      "symbols",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "Protest Riot",
    sane: "protest_riot",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "math",
      "symbols",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "Protest Strike",
    sane: "protest_strike",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "math",
      "symbols",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Proza Libre",
    sane: "proza_libre",
    variants: [
      "0,400",
      "1,400",
      "0,500",
      "1,500",
      "0,600",
      "1,600",
      "0,700",
      "1,700",
      "0,800",
      "1,800"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "monospace",
    name: "PT Mono",
    sane: "pt_mono",
    variants: [
      "0,400"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "PT Sans",
    sane: "pt_sans",
    variants: [
      "0,400",
      "1,400",
      "0,700",
      "1,700"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "PT Sans Caption",
    sane: "pt_sans_caption",
    variants: [
      "0,400",
      "0,700"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "PT Sans Narrow",
    sane: "pt_sans_narrow",
    variants: [
      "0,400",
      "0,700"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "PT Serif",
    sane: "pt_serif",
    variants: [
      "0,400",
      "1,400",
      "0,700",
      "1,700"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "PT Serif Caption",
    sane: "pt_serif_caption",
    variants: [
      "0,400",
      "1,400"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Public Sans",
    sane: "public_sans",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900",
      "1,100",
      "1,200",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700",
      "1,800",
      "1,900"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "handwriting",
    name: "Puppies Play",
    sane: "puppies_play",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Puritan",
    sane: "puritan",
    variants: [
      "0,400",
      "1,400",
      "0,700",
      "1,700"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "display",
    name: "Purple Purse",
    sane: "purple_purse",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Qahiri",
    sane: "qahiri",
    variants: [
      "0,400"
    ],
    subsets: [
      "arabic",
      "latin"
    ]
  },
  {
    category: "serif",
    name: "Quando",
    sane: "quando",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Quantico",
    sane: "quantico",
    variants: [
      "0,400",
      "1,400",
      "0,700",
      "1,700"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "serif",
    name: "Quattrocento",
    sane: "quattrocento",
    variants: [
      "0,400",
      "0,700"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Quattrocento Sans",
    sane: "quattrocento_sans",
    variants: [
      "0,400",
      "1,400",
      "0,700",
      "1,700"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Questrial",
    sane: "questrial",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Quicksand",
    sane: "quicksand",
    variants: [
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "handwriting",
    name: "Quintessential",
    sane: "quintessential",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "handwriting",
    name: "Qwigley",
    sane: "qwigley",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "handwriting",
    name: "Qwitcher Grypen",
    sane: "qwitcher_grypen",
    variants: [
      "0,400",
      "0,700"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "Racing Sans One",
    sane: "racing_sans_one",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Radio Canada",
    sane: "radio_canada",
    variants: [
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700"
    ],
    subsets: [
      "canadian-aboriginal",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Radio Canada Big",
    sane: "radio_canada_big",
    variants: [
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "1,400",
      "1,500",
      "1,600",
      "1,700"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Radley",
    sane: "radley",
    variants: [
      "0,400",
      "1,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Rajdhani",
    sane: "rajdhani",
    variants: [
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    subsets: [
      "devanagari",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Rakkas",
    sane: "rakkas",
    variants: [
      "0,400"
    ],
    subsets: [
      "arabic",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Raleway",
    sane: "raleway",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900",
      "1,100",
      "1,200",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700",
      "1,800",
      "1,900"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "Raleway Dots",
    sane: "raleway_dots",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Ramabhadra",
    sane: "ramabhadra",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "telugu"
    ]
  },
  {
    category: "serif",
    name: "Ramaraja",
    sane: "ramaraja",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "telugu"
    ]
  },
  {
    category: "sans-serif",
    name: "Rambla",
    sane: "rambla",
    variants: [
      "0,400",
      "1,400",
      "0,700",
      "1,700"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Rammetto One",
    sane: "rammetto_one",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Rampart One",
    sane: "rampart_one",
    variants: [
      "0,400"
    ],
    subsets: [
      "cyrillic",
      "japanese",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Ranchers",
    sane: "ranchers",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "handwriting",
    name: "Rancho",
    sane: "rancho",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "display",
    name: "Ranga",
    sane: "ranga",
    variants: [
      "0,400",
      "0,700"
    ],
    subsets: [
      "devanagari",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Rasa",
    sane: "rasa",
    variants: [
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700"
    ],
    subsets: [
      "gujarati",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Rationale",
    sane: "rationale",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "display",
    name: "Ravi Prakash",
    sane: "ravi_prakash",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "telugu"
    ]
  },
  {
    category: "sans-serif",
    name: "Readex Pro",
    sane: "readex_pro",
    variants: [
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    subsets: [
      "arabic",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Recursive",
    sane: "recursive",
    variants: [
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "cyrillic-ext",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Red Hat Display",
    sane: "red_hat_display",
    variants: [
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700",
      "1,800",
      "1,900"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "monospace",
    name: "Red Hat Mono",
    sane: "red_hat_mono",
    variants: [
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Red Hat Text",
    sane: "red_hat_text",
    variants: [
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Red Rose",
    sane: "red_rose",
    variants: [
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "Redacted",
    sane: "redacted",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Redacted Script",
    sane: "redacted_script",
    variants: [
      "0,300",
      "0,400",
      "0,700"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "monospace",
    name: "Reddit Mono",
    sane: "reddit_mono",
    variants: [
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Reddit Sans",
    sane: "reddit_sans",
    variants: [
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900",
      "1,200",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700",
      "1,800",
      "1,900"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Reddit Sans Condensed",
    sane: "reddit_sans_condensed",
    variants: [
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "handwriting",
    name: "Redressed",
    sane: "redressed",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Reem Kufi",
    sane: "reem_kufi",
    variants: [
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    subsets: [
      "arabic",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Reem Kufi Fun",
    sane: "reem_kufi_fun",
    variants: [
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    subsets: [
      "arabic",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Reem Kufi Ink",
    sane: "reem_kufi_ink",
    variants: [
      "0,400"
    ],
    subsets: [
      "arabic",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "handwriting",
    name: "Reenie Beanie",
    sane: "reenie_beanie",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "display",
    name: "Reggae One",
    sane: "reggae_one",
    variants: [
      "0,400"
    ],
    subsets: [
      "cyrillic",
      "japanese",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "REM",
    sane: "rem",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900",
      "1,100",
      "1,200",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700",
      "1,800",
      "1,900"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Rethink Sans",
    sane: "rethink_sans",
    variants: [
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "1,400",
      "1,500",
      "1,600",
      "1,700",
      "1,800"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Revalia",
    sane: "revalia",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Rhodium Libre",
    sane: "rhodium_libre",
    variants: [
      "0,400"
    ],
    subsets: [
      "devanagari",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Ribeye",
    sane: "ribeye",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Ribeye Marrow",
    sane: "ribeye_marrow",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Righteous",
    sane: "righteous",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Risque",
    sane: "risque",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Road Rage",
    sane: "road_rage",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Roboto",
    sane: "roboto",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900",
      "1,100",
      "1,200",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700",
      "1,800",
      "1,900"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "greek",
      "greek-ext",
      "latin",
      "latin-ext",
      "math",
      "symbols",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Roboto Condensed",
    sane: "roboto_condensed",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900",
      "1,100",
      "1,200",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700",
      "1,800",
      "1,900"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "greek",
      "greek-ext",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Roboto Flex",
    sane: "roboto_flex",
    variants: [
      "0,400"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "greek",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "monospace",
    name: "Roboto Mono",
    sane: "roboto_mono",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "1,100",
      "1,200",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "greek",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "serif",
    name: "Roboto Serif",
    sane: "roboto_serif",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900",
      "1,100",
      "1,200",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700",
      "1,800",
      "1,900"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "serif",
    name: "Roboto Slab",
    sane: "roboto_slab",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "greek",
      "greek-ext",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "handwriting",
    name: "Rochester",
    sane: "rochester",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "display",
    name: "Rock 3D",
    sane: "rock_3d",
    variants: [
      "0,400"
    ],
    subsets: [
      "japanese",
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Rock Salt",
    sane: "rock_salt",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "sans-serif",
    name: "RocknRoll One",
    sane: "rocknroll_one",
    variants: [
      "0,400"
    ],
    subsets: [
      "japanese",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Rokkitt",
    sane: "rokkitt",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900",
      "1,100",
      "1,200",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700",
      "1,800",
      "1,900"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "handwriting",
    name: "Romanesco",
    sane: "romanesco",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Ropa Sans",
    sane: "ropa_sans",
    variants: [
      "0,400",
      "1,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Rosario",
    sane: "rosario",
    variants: [
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "serif",
    name: "Rosarivo",
    sane: "rosarivo",
    variants: [
      "0,400",
      "1,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "handwriting",
    name: "Rouge Script",
    sane: "rouge_script",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "display",
    name: "Rowdies",
    sane: "rowdies",
    variants: [
      "0,300",
      "0,400",
      "0,700"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "serif",
    name: "Rozha One",
    sane: "rozha_one",
    variants: [
      "0,400"
    ],
    subsets: [
      "devanagari",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Rubik",
    sane: "rubik",
    variants: [
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700",
      "1,800",
      "1,900"
    ],
    subsets: [
      "arabic",
      "cyrillic",
      "cyrillic-ext",
      "hebrew",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Rubik 80s Fade",
    sane: "rubik_80s_fade",
    variants: [
      "0,400"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "hebrew",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Rubik Beastly",
    sane: "rubik_beastly",
    variants: [
      "0,400"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "hebrew",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Rubik Broken Fax",
    sane: "rubik_broken_fax",
    variants: [
      "0,400"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "hebrew",
      "latin",
      "latin-ext",
      "math",
      "symbols"
    ]
  },
  {
    category: "display",
    name: "Rubik Bubbles",
    sane: "rubik_bubbles",
    variants: [
      "0,400"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "hebrew",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Rubik Burned",
    sane: "rubik_burned",
    variants: [
      "0,400"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "hebrew",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Rubik Dirt",
    sane: "rubik_dirt",
    variants: [
      "0,400"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "hebrew",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Rubik Distressed",
    sane: "rubik_distressed",
    variants: [
      "0,400"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "hebrew",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Rubik Doodle Shadow",
    sane: "rubik_doodle_shadow",
    variants: [
      "0,400"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "hebrew",
      "latin",
      "latin-ext",
      "math",
      "symbols"
    ]
  },
  {
    category: "display",
    name: "Rubik Doodle Triangles",
    sane: "rubik_doodle_triangles",
    variants: [
      "0,400"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "hebrew",
      "latin",
      "latin-ext",
      "math",
      "symbols"
    ]
  },
  {
    category: "display",
    name: "Rubik Gemstones",
    sane: "rubik_gemstones",
    variants: [
      "0,400"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "hebrew",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Rubik Glitch",
    sane: "rubik_glitch",
    variants: [
      "0,400"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "hebrew",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Rubik Glitch Pop",
    sane: "rubik_glitch_pop",
    variants: [
      "0,400"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "hebrew",
      "latin",
      "latin-ext",
      "math",
      "symbols"
    ]
  },
  {
    category: "display",
    name: "Rubik Iso",
    sane: "rubik_iso",
    variants: [
      "0,400"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "hebrew",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Rubik Lines",
    sane: "rubik_lines",
    variants: [
      "0,400"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "hebrew",
      "latin",
      "latin-ext",
      "math",
      "symbols"
    ]
  },
  {
    category: "display",
    name: "Rubik Maps",
    sane: "rubik_maps",
    variants: [
      "0,400"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "hebrew",
      "latin",
      "latin-ext",
      "math",
      "symbols"
    ]
  },
  {
    category: "display",
    name: "Rubik Marker Hatch",
    sane: "rubik_marker_hatch",
    variants: [
      "0,400"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "hebrew",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Rubik Maze",
    sane: "rubik_maze",
    variants: [
      "0,400"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "hebrew",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Rubik Microbe",
    sane: "rubik_microbe",
    variants: [
      "0,400"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "hebrew",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Rubik Mono One",
    sane: "rubik_mono_one",
    variants: [
      "0,400"
    ],
    subsets: [
      "cyrillic",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Rubik Moonrocks",
    sane: "rubik_moonrocks",
    variants: [
      "0,400"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "hebrew",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Rubik Pixels",
    sane: "rubik_pixels",
    variants: [
      "0,400"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "hebrew",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Rubik Puddles",
    sane: "rubik_puddles",
    variants: [
      "0,400"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "hebrew",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Rubik Scribble",
    sane: "rubik_scribble",
    variants: [
      "0,400"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "hebrew",
      "latin",
      "latin-ext",
      "math",
      "symbols"
    ]
  },
  {
    category: "display",
    name: "Rubik Spray Paint",
    sane: "rubik_spray_paint",
    variants: [
      "0,400"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "hebrew",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Rubik Storm",
    sane: "rubik_storm",
    variants: [
      "0,400"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "hebrew",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Rubik Vinyl",
    sane: "rubik_vinyl",
    variants: [
      "0,400"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "hebrew",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Rubik Wet Paint",
    sane: "rubik_wet_paint",
    variants: [
      "0,400"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "hebrew",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Ruda",
    sane: "ruda",
    variants: [
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "cyrillic",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "serif",
    name: "Rufina",
    sane: "rufina",
    variants: [
      "0,400",
      "0,700"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "handwriting",
    name: "Ruge Boogie",
    sane: "ruge_boogie",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Ruluko",
    sane: "ruluko",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Rum Raisin",
    sane: "rum_raisin",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Ruslan Display",
    sane: "ruslan_display",
    variants: [
      "0,400"
    ],
    subsets: [
      "cyrillic",
      "latin",
      "latin-ext",
      "math",
      "symbols"
    ]
  },
  {
    category: "sans-serif",
    name: "Russo One",
    sane: "russo_one",
    variants: [
      "0,400"
    ],
    subsets: [
      "cyrillic",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "handwriting",
    name: "Ruthie",
    sane: "ruthie",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "serif",
    name: "Ruwudu",
    sane: "ruwudu",
    variants: [
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    subsets: [
      "arabic",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Rye",
    sane: "rye",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "handwriting",
    name: "Sacramento",
    sane: "sacramento",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Sahitya",
    sane: "sahitya",
    variants: [
      "0,400",
      "0,700"
    ],
    subsets: [
      "devanagari",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Sail",
    sane: "sail",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Saira",
    sane: "saira",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900",
      "1,100",
      "1,200",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700",
      "1,800",
      "1,900"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Saira Condensed",
    sane: "saira_condensed",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Saira Extra Condensed",
    sane: "saira_extra_condensed",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Saira Semi Condensed",
    sane: "saira_semi_condensed",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "Saira Stencil One",
    sane: "saira_stencil_one",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "Salsa",
    sane: "salsa",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "serif",
    name: "Sanchez",
    sane: "sanchez",
    variants: [
      "0,400",
      "1,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Sancreek",
    sane: "sancreek",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Sankofa Display",
    sane: "sankofa_display",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Sansita",
    sane: "sansita",
    variants: [
      "0,400",
      "1,400",
      "0,700",
      "1,700",
      "0,800",
      "1,800",
      "0,900",
      "1,900"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Sansita Swashed",
    sane: "sansita_swashed",
    variants: [
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Sarabun",
    sane: "sarabun",
    variants: [
      "0,100",
      "1,100",
      "0,200",
      "1,200",
      "0,300",
      "1,300",
      "0,400",
      "1,400",
      "0,500",
      "1,500",
      "0,600",
      "1,600",
      "0,700",
      "1,700",
      "0,800",
      "1,800"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "thai",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Sarala",
    sane: "sarala",
    variants: [
      "0,400",
      "0,700"
    ],
    subsets: [
      "devanagari",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Sarina",
    sane: "sarina",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Sarpanch",
    sane: "sarpanch",
    variants: [
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "devanagari",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "handwriting",
    name: "Sassy Frass",
    sane: "sassy_frass",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "handwriting",
    name: "Satisfy",
    sane: "satisfy",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "sans-serif",
    name: "Sawarabi Gothic",
    sane: "sawarabi_gothic",
    variants: [
      "0,400"
    ],
    subsets: [
      "cyrillic",
      "japanese",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "serif",
    name: "Sawarabi Mincho",
    sane: "sawarabi_mincho",
    variants: [
      "0,400"
    ],
    subsets: [
      "japanese",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Scada",
    sane: "scada",
    variants: [
      "0,400",
      "1,400",
      "0,700",
      "1,700"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Scheherazade New",
    sane: "scheherazade_new",
    variants: [
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    subsets: [
      "arabic",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Schibsted Grotesk",
    sane: "schibsted_grotesk",
    variants: [
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900",
      "1,400",
      "1,500",
      "1,600",
      "1,700",
      "1,800",
      "1,900"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "handwriting",
    name: "Schoolbell",
    sane: "schoolbell",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "serif",
    name: "Scope One",
    sane: "scope_one",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Seaweed Script",
    sane: "seaweed_script",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Secular One",
    sane: "secular_one",
    variants: [
      "0,400"
    ],
    subsets: [
      "hebrew",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Sedan",
    sane: "sedan",
    variants: [
      "0,400",
      "1,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Sedan SC",
    sane: "sedan_sc",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "handwriting",
    name: "Sedgwick Ave",
    sane: "sedgwick_ave",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "handwriting",
    name: "Sedgwick Ave Display",
    sane: "sedgwick_ave_display",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Sen",
    sane: "sen",
    variants: [
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "handwriting",
    name: "Send Flowers",
    sane: "send_flowers",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "Sevillana",
    sane: "sevillana",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Seymour One",
    sane: "seymour_one",
    variants: [
      "0,400"
    ],
    subsets: [
      "cyrillic",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "handwriting",
    name: "Shadows Into Light",
    sane: "shadows_into_light",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "handwriting",
    name: "Shadows Into Light Two",
    sane: "shadows_into_light_two",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Shafarik",
    sane: "shafarik",
    variants: [
      "0,400"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "glagolitic",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "handwriting",
    name: "Shalimar",
    sane: "shalimar",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "Shantell Sans",
    sane: "shantell_sans",
    variants: [
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700",
      "1,800"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Shanti",
    sane: "shanti",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Share",
    sane: "share",
    variants: [
      "0,400",
      "1,400",
      "0,700",
      "1,700"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Share Tech",
    sane: "share_tech",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "monospace",
    name: "Share Tech Mono",
    sane: "share_tech_mono",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "sans-serif",
    name: "Shippori Antique",
    sane: "shippori_antique",
    variants: [
      "0,400"
    ],
    subsets: [
      "japanese",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Shippori Antique B1",
    sane: "shippori_antique_b1",
    variants: [
      "0,400"
    ],
    subsets: [
      "japanese",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Shippori Mincho",
    sane: "shippori_mincho",
    variants: [
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800"
    ],
    subsets: [
      "japanese",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Shippori Mincho B1",
    sane: "shippori_mincho_b1",
    variants: [
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800"
    ],
    subsets: [
      "japanese",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Shizuru",
    sane: "shizuru",
    variants: [
      "0,400"
    ],
    subsets: [
      "japanese",
      "latin"
    ]
  },
  {
    category: "display",
    name: "Shojumaru",
    sane: "shojumaru",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "handwriting",
    name: "Short Stack",
    sane: "short_stack",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "display",
    name: "Shrikhand",
    sane: "shrikhand",
    variants: [
      "0,400"
    ],
    subsets: [
      "gujarati",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Sigmar",
    sane: "sigmar",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "Sigmar One",
    sane: "sigmar_one",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Signika",
    sane: "signika",
    variants: [
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Signika Negative",
    sane: "signika_negative",
    variants: [
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "Silkscreen",
    sane: "silkscreen",
    variants: [
      "0,400",
      "0,700"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Simonetta",
    sane: "simonetta",
    variants: [
      "0,400",
      "1,400",
      "0,900",
      "1,900"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Sintony",
    sane: "sintony",
    variants: [
      "0,400",
      "0,700"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Sirin Stencil",
    sane: "sirin_stencil",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "sans-serif",
    name: "Six Caps",
    sane: "six_caps",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "monospace",
    name: "Sixtyfour",
    sane: "sixtyfour",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "math",
      "symbols"
    ]
  },
  {
    category: "monospace",
    name: "Sixtyfour Convergence",
    sane: "sixtyfour_convergence",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "math",
      "symbols"
    ]
  },
  {
    category: "display",
    name: "Skranji",
    sane: "skranji",
    variants: [
      "0,400",
      "0,700"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Slabo 13px",
    sane: "slabo_13px",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Slabo 27px",
    sane: "slabo_27px",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Slackey",
    sane: "slackey",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Slackside One",
    sane: "slackside_one",
    variants: [
      "0,400"
    ],
    subsets: [
      "japanese",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Smokum",
    sane: "smokum",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "handwriting",
    name: "Smooch",
    sane: "smooch",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Smooch Sans",
    sane: "smooch_sans",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "Smythe",
    sane: "smythe",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "display",
    name: "Sniglet",
    sane: "sniglet",
    variants: [
      "0,400",
      "0,800"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Snippet",
    sane: "snippet",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "display",
    name: "Snowburst One",
    sane: "snowburst_one",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Sofadi One",
    sane: "sofadi_one",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Sofia",
    sane: "sofia",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "sans-serif",
    name: "Sofia Sans",
    sane: "sofia_sans",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900",
      "1,100",
      "1,200",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700",
      "1,800",
      "1,900"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "greek",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Sofia Sans Condensed",
    sane: "sofia_sans_condensed",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900",
      "1,100",
      "1,200",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700",
      "1,800",
      "1,900"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "greek",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Sofia Sans Extra Condensed",
    sane: "sofia_sans_extra_condensed",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900",
      "1,100",
      "1,200",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700",
      "1,800",
      "1,900"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "greek",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Sofia Sans Semi Condensed",
    sane: "sofia_sans_semi_condensed",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900",
      "1,100",
      "1,200",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700",
      "1,800",
      "1,900"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "greek",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "handwriting",
    name: "Solitreo",
    sane: "solitreo",
    variants: [
      "0,400"
    ],
    subsets: [
      "hebrew",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Solway",
    sane: "solway",
    variants: [
      "0,300",
      "0,400",
      "0,500",
      "0,700",
      "0,800"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "monospace",
    name: "Sometype Mono",
    sane: "sometype_mono",
    variants: [
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "1,400",
      "1,500",
      "1,600",
      "1,700"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Sono",
    sane: "sono",
    variants: [
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "Sonsie One",
    sane: "sonsie_one",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Sora",
    sane: "sora",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Sorts Mill Goudy",
    sane: "sorts_mill_goudy",
    variants: [
      "0,400",
      "1,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Sour Gummy",
    sane: "sour_gummy",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900",
      "1,100",
      "1,200",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700",
      "1,800",
      "1,900"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "monospace",
    name: "Source Code Pro",
    sane: "source_code_pro",
    variants: [
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900",
      "1,200",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700",
      "1,800",
      "1,900"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "greek",
      "greek-ext",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Source Sans 3",
    sane: "source_sans_3",
    variants: [
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900",
      "1,200",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700",
      "1,800",
      "1,900"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "greek",
      "greek-ext",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "serif",
    name: "Source Serif 4",
    sane: "source_serif_4",
    variants: [
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900",
      "1,200",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700",
      "1,800",
      "1,900"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "greek",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Space Grotesk",
    sane: "space_grotesk",
    variants: [
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "monospace",
    name: "Space Mono",
    sane: "space_mono",
    variants: [
      "0,400",
      "1,400",
      "0,700",
      "1,700"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "Special Elite",
    sane: "special_elite",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Spectral",
    sane: "spectral",
    variants: [
      "0,200",
      "1,200",
      "0,300",
      "1,300",
      "0,400",
      "1,400",
      "0,500",
      "1,500",
      "0,600",
      "1,600",
      "0,700",
      "1,700",
      "0,800",
      "1,800"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "serif",
    name: "Spectral SC",
    sane: "spectral_sc",
    variants: [
      "0,200",
      "1,200",
      "0,300",
      "1,300",
      "0,400",
      "1,400",
      "0,500",
      "1,500",
      "0,600",
      "1,600",
      "0,700",
      "1,700",
      "0,800",
      "1,800"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "Spicy Rice",
    sane: "spicy_rice",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Spinnaker",
    sane: "spinnaker",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Spirax",
    sane: "spirax",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Splash",
    sane: "splash",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Spline Sans",
    sane: "spline_sans",
    variants: [
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "monospace",
    name: "Spline Sans Mono",
    sane: "spline_sans_mono",
    variants: [
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Squada One",
    sane: "squada_one",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Square Peg",
    sane: "square_peg",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "serif",
    name: "Sree Krushnadevaraya",
    sane: "sree_krushnadevaraya",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "telugu"
    ]
  },
  {
    category: "handwriting",
    name: "Sriracha",
    sane: "sriracha",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "thai",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "Srisakdi",
    sane: "srisakdi",
    variants: [
      "0,400",
      "0,700"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "thai",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "Staatliches",
    sane: "staatliches",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "handwriting",
    name: "Stalemate",
    sane: "stalemate",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Stalinist One",
    sane: "stalinist_one",
    variants: [
      "0,400"
    ],
    subsets: [
      "cyrillic",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Stardos Stencil",
    sane: "stardos_stencil",
    variants: [
      "0,400",
      "0,700"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "sans-serif",
    name: "Stick",
    sane: "stick",
    variants: [
      "0,400"
    ],
    subsets: [
      "cyrillic",
      "japanese",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Stick No Bills",
    sane: "stick_no_bills",
    variants: [
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "sinhala"
    ]
  },
  {
    category: "serif",
    name: "Stint Ultra Condensed",
    sane: "stint_ultra_condensed",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Stint Ultra Expanded",
    sane: "stint_ultra_expanded",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "STIX Two Text",
    sane: "stix_two_text",
    variants: [
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "1,400",
      "1,500",
      "1,600",
      "1,700"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "greek",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "serif",
    name: "Stoke",
    sane: "stoke",
    variants: [
      "0,300",
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Strait",
    sane: "strait",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "handwriting",
    name: "Style Script",
    sane: "style_script",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "handwriting",
    name: "Sue Ellen Francisco",
    sane: "sue_ellen_francisco",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "serif",
    name: "Suez One",
    sane: "suez_one",
    variants: [
      "0,400"
    ],
    subsets: [
      "hebrew",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Sulphur Point",
    sane: "sulphur_point",
    variants: [
      "0,300",
      "0,400",
      "0,700"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Sumana",
    sane: "sumana",
    variants: [
      "0,400",
      "0,700"
    ],
    subsets: [
      "devanagari",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Sunflower",
    sane: "sunflower",
    variants: [
      "0,300",
      "0,500",
      "0,700"
    ],
    subsets: [
      "korean",
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Sunshiney",
    sane: "sunshiney",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "display",
    name: "Supermercado One",
    sane: "supermercado_one",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Sura",
    sane: "sura",
    variants: [
      "0,400",
      "0,700"
    ],
    subsets: [
      "devanagari",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Suranna",
    sane: "suranna",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "telugu"
    ]
  },
  {
    category: "serif",
    name: "Suravaram",
    sane: "suravaram",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "telugu"
    ]
  },
  {
    category: "sans-serif",
    name: "SUSE",
    sane: "suse",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Suwannaphum",
    sane: "suwannaphum",
    variants: [
      "0,100",
      "0,300",
      "0,400",
      "0,700",
      "0,900"
    ],
    subsets: [
      "khmer",
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Swanky and Moo Moo",
    sane: "swanky_and_moo_moo",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Syncopate",
    sane: "syncopate",
    variants: [
      "0,400",
      "0,700"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Syne",
    sane: "syne",
    variants: [
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800"
    ],
    subsets: [
      "greek",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "monospace",
    name: "Syne Mono",
    sane: "syne_mono",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Syne Tactile",
    sane: "syne_tactile",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Tac One",
    sane: "tac_one",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "math",
      "symbols",
      "vietnamese"
    ]
  },
  {
    category: "serif",
    name: "Tai Heritage Pro",
    sane: "tai_heritage_pro",
    variants: [
      "0,400",
      "0,700"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "tai-viet",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Tajawal",
    sane: "tajawal",
    variants: [
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "arabic",
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Tangerine",
    sane: "tangerine",
    variants: [
      "0,400",
      "0,700"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Tapestry",
    sane: "tapestry",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "Taprom",
    sane: "taprom",
    variants: [
      "0,400"
    ],
    subsets: [
      "khmer",
      "latin"
    ]
  },
  {
    category: "sans-serif",
    name: "Tauri",
    sane: "tauri",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Taviraj",
    sane: "taviraj",
    variants: [
      "0,100",
      "1,100",
      "0,200",
      "1,200",
      "0,300",
      "1,300",
      "0,400",
      "1,400",
      "0,500",
      "1,500",
      "0,600",
      "1,600",
      "0,700",
      "1,700",
      "0,800",
      "1,800",
      "0,900",
      "1,900"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "thai",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Teachers",
    sane: "teachers",
    variants: [
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "1,400",
      "1,500",
      "1,600",
      "1,700",
      "1,800"
    ],
    subsets: [
      "greek-ext",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Teko",
    sane: "teko",
    variants: [
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    subsets: [
      "devanagari",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Tektur",
    sane: "tektur",
    variants: [
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "greek",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Telex",
    sane: "telex",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Tenali Ramakrishna",
    sane: "tenali_ramakrishna",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "telugu"
    ]
  },
  {
    category: "sans-serif",
    name: "Tenor Sans",
    sane: "tenor_sans",
    variants: [
      "0,400"
    ],
    subsets: [
      "cyrillic",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Text Me One",
    sane: "text_me_one",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Texturina",
    sane: "texturina",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900",
      "1,100",
      "1,200",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700",
      "1,800",
      "1,900"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Thasadith",
    sane: "thasadith",
    variants: [
      "0,400",
      "1,400",
      "0,700",
      "1,700"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "thai",
      "vietnamese"
    ]
  },
  {
    category: "handwriting",
    name: "The Girl Next Door",
    sane: "the_girl_next_door",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "handwriting",
    name: "The Nautigal",
    sane: "the_nautigal",
    variants: [
      "0,400",
      "0,700"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "serif",
    name: "Tienne",
    sane: "tienne",
    variants: [
      "0,400",
      "0,700",
      "0,900"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "display",
    name: "Tillana",
    sane: "tillana",
    variants: [
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800"
    ],
    subsets: [
      "devanagari",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Tilt Neon",
    sane: "tilt_neon",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "Tilt Prism",
    sane: "tilt_prism",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "Tilt Warp",
    sane: "tilt_warp",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Timmana",
    sane: "timmana",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "telugu"
    ]
  },
  {
    category: "serif",
    name: "Tinos",
    sane: "tinos",
    variants: [
      "0,400",
      "1,400",
      "0,700",
      "1,700"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "greek",
      "greek-ext",
      "hebrew",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Tiny5",
    sane: "tiny5",
    variants: [
      "0,400"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "greek",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Tiro Bangla",
    sane: "tiro_bangla",
    variants: [
      "0,400",
      "1,400"
    ],
    subsets: [
      "bengali",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Tiro Devanagari Hindi",
    sane: "tiro_devanagari_hindi",
    variants: [
      "0,400",
      "1,400"
    ],
    subsets: [
      "devanagari",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Tiro Devanagari Marathi",
    sane: "tiro_devanagari_marathi",
    variants: [
      "0,400",
      "1,400"
    ],
    subsets: [
      "devanagari",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Tiro Devanagari Sanskrit",
    sane: "tiro_devanagari_sanskrit",
    variants: [
      "0,400",
      "1,400"
    ],
    subsets: [
      "devanagari",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Tiro Gurmukhi",
    sane: "tiro_gurmukhi",
    variants: [
      "0,400",
      "1,400"
    ],
    subsets: [
      "gurmukhi",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Tiro Kannada",
    sane: "tiro_kannada",
    variants: [
      "0,400",
      "1,400"
    ],
    subsets: [
      "kannada",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Tiro Tamil",
    sane: "tiro_tamil",
    variants: [
      "0,400",
      "1,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "tamil"
    ]
  },
  {
    category: "serif",
    name: "Tiro Telugu",
    sane: "tiro_telugu",
    variants: [
      "0,400",
      "1,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "telugu"
    ]
  },
  {
    category: "display",
    name: "Titan One",
    sane: "titan_one",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Titillium Web",
    sane: "titillium_web",
    variants: [
      "0,200",
      "1,200",
      "0,300",
      "1,300",
      "0,400",
      "1,400",
      "0,600",
      "1,600",
      "0,700",
      "1,700",
      "0,900"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Tomorrow",
    sane: "tomorrow",
    variants: [
      "0,100",
      "1,100",
      "0,200",
      "1,200",
      "0,300",
      "1,300",
      "0,400",
      "1,400",
      "0,500",
      "1,500",
      "0,600",
      "1,600",
      "0,700",
      "1,700",
      "0,800",
      "1,800",
      "0,900",
      "1,900"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Tourney",
    sane: "tourney",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900",
      "1,100",
      "1,200",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700",
      "1,800",
      "1,900"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "Trade Winds",
    sane: "trade_winds",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "display",
    name: "Train One",
    sane: "train_one",
    variants: [
      "0,400"
    ],
    subsets: [
      "cyrillic",
      "japanese",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Triodion",
    sane: "triodion",
    variants: [
      "0,400"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "latin"
    ]
  },
  {
    category: "serif",
    name: "Trirong",
    sane: "trirong",
    variants: [
      "0,100",
      "1,100",
      "0,200",
      "1,200",
      "0,300",
      "1,300",
      "0,400",
      "1,400",
      "0,500",
      "1,500",
      "0,600",
      "1,600",
      "0,700",
      "1,700",
      "0,800",
      "1,800",
      "0,900",
      "1,900"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "thai",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Trispace",
    sane: "trispace",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "serif",
    name: "Trocchi",
    sane: "trocchi",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Trochut",
    sane: "trochut",
    variants: [
      "0,400",
      "1,400",
      "0,700"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "sans-serif",
    name: "Truculenta",
    sane: "truculenta",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "serif",
    name: "Trykker",
    sane: "trykker",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Tsukimi Rounded",
    sane: "tsukimi_rounded",
    variants: [
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    subsets: [
      "japanese",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Tulpen One",
    sane: "tulpen_one",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "display",
    name: "Turret Road",
    sane: "turret_road",
    variants: [
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,700",
      "0,800"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "handwriting",
    name: "Twinkle Star",
    sane: "twinkle_star",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Ubuntu",
    sane: "ubuntu",
    variants: [
      "0,300",
      "1,300",
      "0,400",
      "1,400",
      "0,500",
      "1,500",
      "0,700",
      "1,700"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "greek",
      "greek-ext",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Ubuntu Condensed",
    sane: "ubuntu_condensed",
    variants: [
      "0,400"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "greek",
      "greek-ext",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "monospace",
    name: "Ubuntu Mono",
    sane: "ubuntu_mono",
    variants: [
      "0,400",
      "1,400",
      "0,700",
      "1,700"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "greek",
      "greek-ext",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Ubuntu Sans",
    sane: "ubuntu_sans",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "1,100",
      "1,200",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700",
      "1,800"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "greek",
      "greek-ext",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "monospace",
    name: "Ubuntu Sans Mono",
    sane: "ubuntu_sans_mono",
    variants: [
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "1,400",
      "1,500",
      "1,600",
      "1,700"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "greek",
      "greek-ext",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Uchen",
    sane: "uchen",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "tibetan"
    ]
  },
  {
    category: "serif",
    name: "Ultra",
    sane: "ultra",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Unbounded",
    sane: "unbounded",
    variants: [
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "Uncial Antiqua",
    sane: "uncial_antiqua",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Underdog",
    sane: "underdog",
    variants: [
      "0,400"
    ],
    subsets: [
      "cyrillic",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Unica One",
    sane: "unica_one",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "UnifrakturCook",
    sane: "unifrakturcook",
    variants: [
      "0,700"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "display",
    name: "UnifrakturMaguntia",
    sane: "unifrakturmaguntia",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "display",
    name: "Unkempt",
    sane: "unkempt",
    variants: [
      "0,400",
      "0,700"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "display",
    name: "Unlock",
    sane: "unlock",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Unna",
    sane: "unna",
    variants: [
      "0,400",
      "1,400",
      "0,700",
      "1,700"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "handwriting",
    name: "Updock",
    sane: "updock",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Urbanist",
    sane: "urbanist",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900",
      "1,100",
      "1,200",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700",
      "1,800",
      "1,900"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Vampiro One",
    sane: "vampiro_one",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Varela",
    sane: "varela",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Varela Round",
    sane: "varela_round",
    variants: [
      "0,400"
    ],
    subsets: [
      "hebrew",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Varta",
    sane: "varta",
    variants: [
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "serif",
    name: "Vast Shadow",
    sane: "vast_shadow",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "sans-serif",
    name: "Vazirmatn",
    sane: "vazirmatn",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "arabic",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Vesper Libre",
    sane: "vesper_libre",
    variants: [
      "0,400",
      "0,500",
      "0,700",
      "0,900"
    ],
    subsets: [
      "devanagari",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Viaoda Libre",
    sane: "viaoda_libre",
    variants: [
      "0,400"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "Vibes",
    sane: "vibes",
    variants: [
      "0,400"
    ],
    subsets: [
      "arabic",
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Vibur",
    sane: "vibur",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "monospace",
    name: "Victor Mono",
    sane: "victor_mono",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "1,100",
      "1,200",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "greek",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "serif",
    name: "Vidaloka",
    sane: "vidaloka",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "sans-serif",
    name: "Viga",
    sane: "viga",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Vina Sans",
    sane: "vina_sans",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Voces",
    sane: "voces",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Volkhov",
    sane: "volkhov",
    variants: [
      "0,400",
      "1,400",
      "0,700",
      "1,700"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "serif",
    name: "Vollkorn",
    sane: "vollkorn",
    variants: [
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900",
      "1,400",
      "1,500",
      "1,600",
      "1,700",
      "1,800",
      "1,900"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "greek",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "serif",
    name: "Vollkorn SC",
    sane: "vollkorn_sc",
    variants: [
      "0,400",
      "0,600",
      "0,700",
      "0,900"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Voltaire",
    sane: "voltaire",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "monospace",
    name: "VT323",
    sane: "vt323",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "handwriting",
    name: "Vujahday Script",
    sane: "vujahday_script",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "handwriting",
    name: "Waiting for the Sunrise",
    sane: "waiting_for_the_sunrise",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Wallpoet",
    sane: "wallpoet",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "handwriting",
    name: "Walter Turncoat",
    sane: "walter_turncoat",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "display",
    name: "Warnes",
    sane: "warnes",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "handwriting",
    name: "Water Brush",
    sane: "water_brush",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "handwriting",
    name: "Waterfall",
    sane: "waterfall",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "display",
    name: "Wavefont",
    sane: "wavefont",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "serif",
    name: "Wellfleet",
    sane: "wellfleet",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Wendy One",
    sane: "wendy_one",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "handwriting",
    name: "Whisper",
    sane: "whisper",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "handwriting",
    name: "WindSong",
    sane: "windsong",
    variants: [
      "0,400",
      "0,500"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Wire One",
    sane: "wire_one",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin"
    ]
  },
  {
    category: "serif",
    name: "Wittgenstein",
    sane: "wittgenstein",
    variants: [
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900",
      "1,400",
      "1,500",
      "1,600",
      "1,700",
      "1,800",
      "1,900"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Wix Madefor Display",
    sane: "wix_madefor_display",
    variants: [
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Wix Madefor Text",
    sane: "wix_madefor_text",
    variants: [
      "0,400",
      "1,400",
      "0,500",
      "1,500",
      "0,600",
      "1,600",
      "0,700",
      "1,700",
      "0,800",
      "1,800"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Work Sans",
    sane: "work_sans",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900",
      "1,100",
      "1,200",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700",
      "1,800",
      "1,900"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "monospace",
    name: "Workbench",
    sane: "workbench",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "math",
      "symbols"
    ]
  },
  {
    category: "monospace",
    name: "Xanh Mono",
    sane: "xanh_mono",
    variants: [
      "0,400",
      "1,400"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Yaldevi",
    sane: "yaldevi",
    variants: [
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "sinhala"
    ]
  },
  {
    category: "sans-serif",
    name: "Yanone Kaffeesatz",
    sane: "yanone_kaffeesatz",
    variants: [
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "latin",
      "latin-ext",
      "math",
      "symbols",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Yantramanav",
    sane: "yantramanav",
    variants: [
      "0,100",
      "0,300",
      "0,400",
      "0,500",
      "0,700",
      "0,900"
    ],
    subsets: [
      "devanagari",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Yarndings 12",
    sane: "yarndings_12",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "math",
      "symbols"
    ]
  },
  {
    category: "display",
    name: "Yarndings 12 Charted",
    sane: "yarndings_12_charted",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "math",
      "symbols"
    ]
  },
  {
    category: "display",
    name: "Yarndings 20",
    sane: "yarndings_20",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "math",
      "symbols"
    ]
  },
  {
    category: "display",
    name: "Yarndings 20 Charted",
    sane: "yarndings_20_charted",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "math",
      "symbols"
    ]
  },
  {
    category: "display",
    name: "Yatra One",
    sane: "yatra_one",
    variants: [
      "0,400"
    ],
    subsets: [
      "devanagari",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "handwriting",
    name: "Yellowtail",
    sane: "yellowtail",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Yeon Sung",
    sane: "yeon_sung",
    variants: [
      "0,400"
    ],
    subsets: [
      "korean",
      "latin"
    ]
  },
  {
    category: "display",
    name: "Yeseva One",
    sane: "yeseva_one",
    variants: [
      "0,400"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "handwriting",
    name: "Yesteryear",
    sane: "yesteryear",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "handwriting",
    name: "Yomogi",
    sane: "yomogi",
    variants: [
      "0,400"
    ],
    subsets: [
      "cyrillic",
      "japanese",
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "serif",
    name: "Young Serif",
    sane: "young_serif",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Yrsa",
    sane: "yrsa",
    variants: [
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700"
    ],
    subsets: [
      "latin",
      "latin-ext",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Ysabeau",
    sane: "ysabeau",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900",
      "1,100",
      "1,200",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700",
      "1,800",
      "1,900"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "greek",
      "latin",
      "latin-ext",
      "math",
      "symbols",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Ysabeau Infant",
    sane: "ysabeau_infant",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900",
      "1,100",
      "1,200",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700",
      "1,800",
      "1,900"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "greek",
      "latin",
      "latin-ext",
      "math",
      "symbols",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Ysabeau Office",
    sane: "ysabeau_office",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900",
      "1,100",
      "1,200",
      "1,300",
      "1,400",
      "1,500",
      "1,600",
      "1,700",
      "1,800",
      "1,900"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "greek",
      "latin",
      "latin-ext",
      "math",
      "symbols",
      "vietnamese"
    ]
  },
  {
    category: "sans-serif",
    name: "Ysabeau SC",
    sane: "ysabeau_sc",
    variants: [
      "0,100",
      "0,200",
      "0,300",
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "cyrillic",
      "cyrillic-ext",
      "greek",
      "latin",
      "latin-ext",
      "math",
      "symbols",
      "vietnamese"
    ]
  },
  {
    category: "serif",
    name: "Yuji Boku",
    sane: "yuji_boku",
    variants: [
      "0,400"
    ],
    subsets: [
      "cyrillic",
      "japanese",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "handwriting",
    name: "Yuji Hentaigana Akari",
    sane: "yuji_hentaigana_akari",
    variants: [
      "0,400"
    ],
    subsets: [
      "japanese",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "handwriting",
    name: "Yuji Hentaigana Akebono",
    sane: "yuji_hentaigana_akebono",
    variants: [
      "0,400"
    ],
    subsets: [
      "japanese",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Yuji Mai",
    sane: "yuji_mai",
    variants: [
      "0,400"
    ],
    subsets: [
      "cyrillic",
      "japanese",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Yuji Syuku",
    sane: "yuji_syuku",
    variants: [
      "0,400"
    ],
    subsets: [
      "cyrillic",
      "japanese",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Yusei Magic",
    sane: "yusei_magic",
    variants: [
      "0,400"
    ],
    subsets: [
      "japanese",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Zain",
    sane: "zain",
    variants: [
      "0,200",
      "0,300",
      "1,300",
      "0,400",
      "1,400",
      "0,700",
      "0,800",
      "0,900"
    ],
    subsets: [
      "arabic",
      "latin"
    ]
  },
  {
    category: "sans-serif",
    name: "ZCOOL KuaiLe",
    sane: "zcool_kuaile",
    variants: [
      "0,400"
    ],
    subsets: [
      "chinese-simplified",
      "latin"
    ]
  },
  {
    category: "sans-serif",
    name: "ZCOOL QingKe HuangYou",
    sane: "zcool_qingke_huangyou",
    variants: [
      "0,400"
    ],
    subsets: [
      "chinese-simplified",
      "latin"
    ]
  },
  {
    category: "sans-serif",
    name: "ZCOOL XiaoWei",
    sane: "zcool_xiaowei",
    variants: [
      "0,400"
    ],
    subsets: [
      "chinese-simplified",
      "latin"
    ]
  },
  {
    category: "serif",
    name: "Zen Antique",
    sane: "zen_antique",
    variants: [
      "0,400"
    ],
    subsets: [
      "cyrillic",
      "greek",
      "japanese",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Zen Antique Soft",
    sane: "zen_antique_soft",
    variants: [
      "0,400"
    ],
    subsets: [
      "cyrillic",
      "greek",
      "japanese",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Zen Dots",
    sane: "zen_dots",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Zen Kaku Gothic Antique",
    sane: "zen_kaku_gothic_antique",
    variants: [
      "0,300",
      "0,400",
      "0,500",
      "0,700",
      "0,900"
    ],
    subsets: [
      "cyrillic",
      "japanese",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Zen Kaku Gothic New",
    sane: "zen_kaku_gothic_new",
    variants: [
      "0,300",
      "0,400",
      "0,500",
      "0,700",
      "0,900"
    ],
    subsets: [
      "cyrillic",
      "japanese",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Zen Kurenaido",
    sane: "zen_kurenaido",
    variants: [
      "0,400"
    ],
    subsets: [
      "cyrillic",
      "greek",
      "japanese",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Zen Loop",
    sane: "zen_loop",
    variants: [
      "0,400",
      "1,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "sans-serif",
    name: "Zen Maru Gothic",
    sane: "zen_maru_gothic",
    variants: [
      "0,300",
      "0,400",
      "0,500",
      "0,700",
      "0,900"
    ],
    subsets: [
      "cyrillic",
      "greek",
      "japanese",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Zen Old Mincho",
    sane: "zen_old_mincho",
    variants: [
      "0,400",
      "0,500",
      "0,600",
      "0,700",
      "0,900"
    ],
    subsets: [
      "cyrillic",
      "greek",
      "japanese",
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "display",
    name: "Zen Tokyo Zoo",
    sane: "zen_tokyo_zoo",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "handwriting",
    name: "Zeyada",
    sane: "zeyada",
    variants: [
      "0,400"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "handwriting",
    name: "Zhi Mang Xing",
    sane: "zhi_mang_xing",
    variants: [
      "0,400"
    ],
    subsets: [
      "chinese-simplified",
      "latin"
    ]
  },
  {
    category: "serif",
    name: "Zilla Slab",
    sane: "zilla_slab",
    variants: [
      "0,300",
      "1,300",
      "0,400",
      "1,400",
      "0,500",
      "1,500",
      "0,600",
      "1,600",
      "0,700",
      "1,700"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  },
  {
    category: "serif",
    name: "Zilla Slab Highlight",
    sane: "zilla_slab_highlight",
    variants: [
      "0,400",
      "0,700"
    ],
    subsets: [
      "latin",
      "latin-ext"
    ]
  }
];

// src/lib/fontChecker.ts
function checkLoaded(_0) {
  return __async(this, arguments, function* ({
    fontFamily,
    fontStyle,
    fontWeight,
    timeout = 500
  }) {
    const start = (/* @__PURE__ */ new Date()).getTime();
    let timeoutId;
    return new Promise(function(resolve, reject) {
      if (document == null ? void 0 : document.fonts) {
        const checker = new Promise(function(resolve2, reject2) {
          const check = function() {
            const now = (/* @__PURE__ */ new Date()).getTime();
            if (now - start >= timeout) {
              reject2(new Error(`Font not loaded within ${timeout} ms`));
            } else {
              const loaded = document.fonts.check(`${fontStyle != null ? fontStyle : ""} ${fontWeight != null ? fontWeight : ""} 0 ${fontFamily}`);
              if (loaded) {
                resolve2(true);
              } else {
                setTimeout(check, 25);
              }
            }
          };
          check();
        });
        const timer = new Promise(function(resolve2, reject2) {
          timeoutId = setTimeout(() => reject2(new Error(`Font not loaded within ${timeout} ms`)), timeout);
        });
        Promise.race([timer, checker]).then((value) => {
          clearTimeout(timeoutId);
          resolve(value);
        }, reject);
      } else {
        reject(new Error("Fonts API not supported by client"));
      }
    });
  });
}

// src/lib/util.ts
function sanify(fontName) {
  return fontName.replace(/\s+/g, "_").replace(/[^a-zA-Z0-9-_]/g, "").toLowerCase();
}

// src/components/FontPicker.tsx
import { Fragment as Fragment2, jsx as jsx2, jsxs } from "react/jsx-runtime";
var FontPreviews2 = lazy(() => Promise.resolve().then(() => (init_FontPreviews(), FontPreviews_exports)));
function toString(v) {
  if (typeof v === "string") {
    return v;
  }
  return (v.italic ? "1" : "0") + "," + v.weight;
}
var defaultFont = {
  category: "sans-serif",
  name: "Open Sans",
  sane: "open_sans",
  cased: "open sans",
  variants: [
    "0,300",
    "0,400",
    "0,500",
    "0,600",
    "0,700",
    "0,800",
    "1,300",
    "1,400",
    "1,500",
    "1,600",
    "1,700",
    "1,800"
  ]
};
function FontPicker(_a) {
  var _b = _a, {
    defaultValue = "Open Sans",
    noMatches = "No matches",
    autoLoad = false,
    loaderOnly = false,
    loadAllVariants = false,
    loadFonts = "",
    googleFonts = "all",
    fontCategories = "all",
    localFonts = [],
    mode = "combo",
    fontVariants,
    value,
    fontsLoaded,
    fontsLoadedTimeout,
    loading = /* @__PURE__ */ jsx2("div", { children: "Font previews loading ..." }),
    inputId
  } = _b, rest = __objRest(_b, [
    "defaultValue",
    "noMatches",
    "autoLoad",
    "loaderOnly",
    "loadAllVariants",
    "loadFonts",
    "googleFonts",
    "fontCategories",
    "localFonts",
    "mode",
    "fontVariants",
    "value",
    "fontsLoaded",
    "fontsLoadedTimeout",
    "loading",
    "inputId"
  ]);
  var _a2, _b2, _c;
  const [focused, setFocused] = useState(false);
  const [selectedFontIndex, setSelectedFontIndex] = useState(-1);
  const [currentFontIndex, setCurrentFontIndex] = useState(-1);
  const prevLoadFontsRef = useRef([]);
  const inputRef = useRef(null);
  const popoutRef = useRef(null);
  const previewRef = useRef(null);
  const handleLoadFont = () => {
    if (typeof loadFonts === "string") {
      if (loadFonts !== "") {
        const fontNames = loadFonts.trim().split(",");
        fontNames == null ? void 0 : fontNames.forEach((fontName) => {
          if (!prevLoadFontsRef.current.includes(fontName)) {
            prevLoadFontsRef.current.push(fontName);
            loadFontByName(fontName);
          }
        });
      }
    } else {
      loadFonts.forEach((font) => {
        const fontName = typeof font === "string" ? font : font == null ? void 0 : font.fontName;
        if (!fontName) {
          return;
        }
        if (!prevLoadFontsRef.current.includes(fontName)) {
          prevLoadFontsRef.current.push(fontName);
          if (typeof font === "object" && font.variants) {
            loadFontByName(
              fontName,
              font.variants.map((v) => toString(v))
            );
          } else {
            loadFontByName(fontName);
          }
        }
      });
    }
  };
  const loadFontsFontNames = useMemo(() => {
    const names = [];
    if (loadFonts) {
      if (typeof loadFonts === "string") {
        names.push(loadFonts);
      } else {
        loadFonts == null ? void 0 : loadFonts.forEach((font) => {
          const fontName = typeof font === "string" ? font : font == null ? void 0 : font.fontName;
          if (!fontName) {
            return;
          }
          names.push(fontName);
        });
      }
    }
    return names;
  }, [loadFonts]);
  const fontPickerOptionsRef = useRef(null);
  const saveOptionsRef = (key) => (node) => {
    const map = getOptionsRef();
    if (node) {
      map.set(key, node);
    } else {
      map.delete(key);
    }
  };
  const getOptionsRef = () => {
    if (!fontPickerOptionsRef.current) {
      fontPickerOptionsRef.current = /* @__PURE__ */ new Map();
    }
    return fontPickerOptionsRef.current;
  };
  const outerClasses = () => {
    const ret = ["fontpicker"];
    return ret;
  };
  const popoutClasses = () => {
    const ret = ["fontpicker__popout"];
    if (focused) {
      ret.push("fontpicker__active");
    }
    return [...ret];
  };
  const previewClasses = () => {
    const ret = ["fontpicker__preview"];
    ret.push("font-preview-" + current.sane);
    return [...ret];
  };
  const allGoogleFonts = useMemo(() => {
    const ifonts = [];
    fontInfo_default.forEach((info) => {
      const font = __spreadProps(__spreadValues({}, info), { cased: info.name.toLowerCase() });
      ifonts.push(font);
    });
    return [...ifonts];
  }, []);
  const fonts = useMemo(() => {
    var _a3;
    let activeFonts;
    if (googleFonts === "all") {
      activeFonts = [...allGoogleFonts];
    } else if (typeof googleFonts === "string") {
      const fontNames = googleFonts.trim().split(",").map((v) => v.toLowerCase());
      activeFonts = [...allGoogleFonts.filter((a) => fontNames.includes(a.cased))];
    } else if (typeof googleFonts === "function") {
      activeFonts = [...allGoogleFonts.filter(googleFonts)];
    } else {
      const fontNames = (_a3 = googleFonts == null ? void 0 : googleFonts.map((v) => {
        if (typeof v === "string") {
          return v.toLowerCase();
        } else {
          return v.cased;
        }
      })) != null ? _a3 : [];
      activeFonts = [...allGoogleFonts.filter((a) => fontNames.includes(a.cased))];
    }
    localFonts.forEach((font) => {
      activeFonts.push({
        category: font.category,
        name: font.name,
        cased: font.name.toLowerCase(),
        sane: sanify(font.name),
        variants: font.variants.map((v) => toString(v)),
        isLocal: true
      });
    });
    let activeFontsInCategory;
    if (fontCategories === "all") {
      activeFontsInCategory = [...activeFonts];
    } else if (typeof fontCategories === "string") {
      const newFontCategories = fontCategories.trim().split(",").map((v) => v.trim().toLowerCase());
      activeFontsInCategory = [...allGoogleFonts.filter((a) => newFontCategories.includes(a.category))];
    } else {
      const newFontCategories = fontCategories.map((v) => v.toLowerCase());
      activeFontsInCategory = [...allGoogleFonts.filter((a) => newFontCategories.includes(a.category))];
    }
    return [...activeFontsInCategory];
  }, [googleFonts, allGoogleFonts, localFonts, fontCategories]);
  const saneDefaultValue = useMemo(() => {
    const search = defaultValue.toLowerCase().trim();
    if (!fonts || (fonts == null ? void 0 : fonts.length) <= 0) {
      return defaultValue;
    }
    if (fonts.some((a) => a.cased === search)) {
      return defaultValue;
    }
    return fonts[0].name;
  }, [fonts, defaultValue]);
  const [typedSearch, setTypedSearch] = useState(saneDefaultValue);
  const [searchContent, setSearchContent] = useState(saneDefaultValue);
  const matchingFonts = useMemo(() => {
    const search = typedSearch.toLowerCase().trim();
    return fonts.filter((a) => a.cased.includes(search));
  }, [typedSearch, fonts]);
  const cancelBlur = (e) => {
    e.preventDefault();
  };
  const searchChanged = (e) => {
    var _a3, _b3;
    if ((_a3 = popoutRef == null ? void 0 : popoutRef.current) == null ? void 0 : _a3.scrollTop) {
      popoutRef.current.scrollTop = 0;
    }
    const newValue = (_b3 = e.currentTarget) == null ? void 0 : _b3.value;
    setSelectedFontIndex(-1);
    const isLonger = typedSearch.length < (newValue == null ? void 0 : newValue.length);
    setTypedSearch(newValue);
    if (!isLonger) {
      setSearchContent(newValue);
      return;
    }
    const cased = newValue.toLowerCase();
    const matches = fonts.filter((a) => a.cased.startsWith(cased));
    if (matches == null ? void 0 : matches.length) {
      const firstMatch = matches[0].name;
      if (e.currentTarget) {
        e.currentTarget.value = firstMatch;
      }
      setInputSelection(e.currentTarget, newValue.length, firstMatch.length);
      setSearchContent(firstMatch);
    } else {
      setSearchContent(newValue);
    }
  };
  const setInputSelection = (input, startPos, endPos) => {
    if (input.setSelectionRange) {
      input.setSelectionRange(startPos, endPos);
    }
  };
  const onKeyDown = (e) => {
    if (e.key && e.key === "Enter") {
      const cased = searchContent.toLowerCase();
      const preciseMatches = fonts.filter((a) => a.cased === cased);
      if (selectedFontIndex > -1) {
        setCurrent(matchingFonts[selectedFontIndex]);
      } else if (preciseMatches.length === 1) {
        setCurrent(preciseMatches[0]);
      } else if (matchingFonts.length > 0) {
        setCurrent(matchingFonts[0]);
      } else {
        setCurrent(current);
      }
    } else if (e.key && e.key === "ArrowDown") {
      e.preventDefault();
      if (selectedFontIndex < matchingFonts.length - 1) {
        setSearchContent(typedSearch);
        const prevSelectedFontIndex = selectedFontIndex;
        setSelectedFontIndex((prev) => prev + 1);
        showSelectedFont("key", prevSelectedFontIndex + 1);
      }
    } else if (e.key && e.key === "ArrowUp") {
      e.preventDefault();
      if (selectedFontIndex > 0) {
        setSearchContent(typedSearch);
        const prevSelectedFontIndex = selectedFontIndex;
        setSelectedFontIndex((prev) => prev - 1);
        showSelectedFont("key", prevSelectedFontIndex - 1);
      }
    } else if (e.key && e.key === "Escape") {
      hide();
    }
  };
  const onKeyDownList = (e) => {
    if (e.key && e.key === "Enter") {
      if (selectedFontIndex > -1) {
        setCurrent(fonts[selectedFontIndex]);
      } else {
        setCurrent(current);
      }
    } else if (e.key && e.key === "ArrowDown") {
      e.preventDefault();
      if (selectedFontIndex < fonts.length - 1) {
        setSelectedFontIndex((prev) => prev + 1);
      }
    } else if (e.key && e.key === "ArrowUp") {
      e.preventDefault();
      if (selectedFontIndex > 0) {
        setSelectedFontIndex((prev) => prev - 1);
      }
    }
  };
  const showSelectedFont = (why = "key", index = selectedFontIndex) => {
    var _a3;
    const popout = popoutRef == null ? void 0 : popoutRef.current;
    if (popout && index >= 0) {
      const selectedFont = matchingFonts[index];
      if (selectedFont) {
        const fontPreviewElement = popout.querySelector(".font-preview-" + selectedFont.sane);
        const fontOptionElement = fontPreviewElement == null ? void 0 : fontPreviewElement.parentElement;
        if (fontOptionElement && fontOptionElement instanceof HTMLElement) {
          const fontTop = fontOptionElement.offsetTop;
          const fontBottom = fontTop + fontOptionElement.offsetHeight;
          const popTop = popout.scrollTop;
          const popBottom = popTop + popout.clientHeight;
          if (why === "opening" || fontTop <= popTop) {
            popout.scrollTop = fontTop;
            fontOptionElement.classList.add("selected");
            const optionRef = (_a3 = getOptionsRef()) == null ? void 0 : _a3.get(selectedFont.sane);
            optionRef == null ? void 0 : optionRef.classList.add("selected");
          } else if (fontBottom >= popBottom) {
            popout.scrollTop = fontBottom - popout.clientHeight - 1;
          }
        }
      }
    }
  };
  const onFocus = () => {
    var _a3;
    (_a3 = inputRef == null ? void 0 : inputRef.current) == null ? void 0 : _a3.select();
    setTypedSearch("");
    show();
  };
  const onClick = (font) => {
    setCurrent(font);
    hide();
  };
  const show = () => {
    if (!focused) {
      setFocused(true);
      setTimeout(() => {
        let newSelectedFontIndex = selectedFontIndex;
        for (const [i, font] of matchingFonts.entries()) {
          if (font.name === current.name) {
            newSelectedFontIndex = i;
            setSelectedFontIndex(i);
            break;
          }
        }
        setSearchContent(current.name);
        showSelectedFont("opening", newSelectedFontIndex);
      }, 1);
    }
  };
  const hide = () => {
    var _a3;
    (_a3 = inputRef == null ? void 0 : inputRef.current) == null ? void 0 : _a3.blur();
    setFocused(false);
  };
  const getFontByName = useCallback(
    (name) => {
      let found = null;
      fonts.forEach((font) => {
        if (font.name === name.trim()) {
          found = font;
        }
      });
      return found;
    },
    [fonts]
  );
  const setCurrent = (font) => {
    var _a3;
    setCurrentState(font);
    setTypedSearch(font.name);
    setSearchContent(font.name);
    (_a3 = inputRef == null ? void 0 : inputRef.current) == null ? void 0 : _a3.blur();
    autoLoadFont(font);
    emitFontVariants(font);
    emitValue(font);
    setCurrentFontIndex(fontIndex(font));
  };
  const fontIndex = useCallback(
    (font) => {
      var _a3, _b3;
      let idx;
      if (mode === "list") {
        idx = (_a3 = fonts == null ? void 0 : fonts.findIndex((f) => f.name === font.name)) != null ? _a3 : -1;
      } else {
        idx = (_b3 = matchingFonts == null ? void 0 : matchingFonts.findIndex((f) => f.name === font.name)) != null ? _b3 : -1;
      }
      if (idx < 0) {
        idx = 0;
      }
      return idx;
    },
    [fonts, matchingFonts, mode]
  );
  const emitFontVariants = useCallback(
    (font) => {
      if ((font == null ? void 0 : font.name) && (font == null ? void 0 : font.variants)) {
        fontVariants == null ? void 0 : fontVariants({
          fontName: font.name,
          variants: font.variants
        });
      }
    },
    [fontVariants]
  );
  const emitValue = useCallback(
    (font) => {
      if (font == null ? void 0 : font.name) {
        value == null ? void 0 : value(font.name);
      }
    },
    [value]
  );
  const emitFontLoaded = useCallback(
    (isLoaded) => {
      fontsLoaded == null ? void 0 : fontsLoaded(isLoaded);
    },
    [fontsLoaded]
  );
  const loadFontFromObject = useCallback(
    (font, variants = []) => {
      if (font == null ? void 0 : font.isLocal) {
        return;
      }
      if ((variants == null ? void 0 : variants.length) > 0) {
        variants = font.variants.filter((v) => variants.includes(v));
      } else if (loadAllVariants) {
        variants = font.variants;
      } else {
        variants = getFourVariants(font.variants.map((v) => toString(v)));
      }
      let cssId = "google-font-" + font.sane;
      const cssIdAll = cssId + "-all";
      if (variants.length === font.variants.length) {
        cssId = cssIdAll;
      } else {
        cssId += "-" + variants.sort().join("-").replaceAll("1,", "i").replaceAll("0,", "");
      }
      const existing = document.getElementById(cssId);
      const existingAll = document.getElementById(cssIdAll);
      if (!existing && !existingAll && (font == null ? void 0 : font.name) && (variants == null ? void 0 : variants.length) > 0) {
        const link = document.createElement("link");
        link.rel = "stylesheet";
        link.id = cssId;
        link.href = "https://fonts.googleapis.com/css2?family=" + font.name + ":ital,wght@" + variants.sort().join(";") + "&display=swap";
        link.setAttribute("data-testid", cssId);
        document.head.appendChild(link);
      }
    },
    [loadAllVariants]
  );
  const autoLoadFont = useCallback(
    (font) => {
      if (autoLoad) {
        loadFontFromObject(font);
      }
    },
    [autoLoad, loadFontFromObject]
  );
  const loadFontByName = (font, variants = []) => {
    if (font === "") {
      return;
    }
    let loaded = font;
    if (typeof font === "string") {
      loaded = getFontByName(font);
    }
    if (loaded === null || typeof loaded !== "object" || typeof loaded.sane !== "string") {
      console.error("Unknown font", font);
    } else if (loaded.variants.length < 1) {
      console.error("No valid variants of font", variants);
    } else {
      loadFontFromObject(loaded, variants);
    }
  };
  const getFourVariants = (variants) => {
    const regularWeights = variants.filter((v) => v.substring(0, 2) === "0,").map((v) => parseInt(v.substring(2))).sort((a, b) => a - b);
    const italicWeights = variants.filter((v) => v.substring(0, 2) === "1,").map((v) => parseInt(v.substring(2))).sort((a, b) => a - b);
    const fourFonts = {};
    fourFonts.regular = regularWeights.sort((a, b) => Math.abs(399 - a) - Math.abs(399 - b)).shift();
    fourFonts.bold = regularWeights.filter((v) => v > (fourFonts.regular || 0)).sort((a, b) => Math.abs(700 - a) - Math.abs(700 - b)).shift();
    fourFonts.italic = italicWeights.sort((a, b) => Math.abs(399 - a) - Math.abs(399 - b)).shift();
    fourFonts.boldItalic = italicWeights.filter((v) => v > (fourFonts.italic || 0)).sort((a, b) => Math.abs(700 - a) - Math.abs(700 - b)).shift();
    const fourVariants = [];
    if (fourFonts.regular) {
      fourVariants.push("0," + fourFonts.regular);
    }
    if (fourFonts.bold) {
      fourVariants.push("0," + fourFonts.bold);
    }
    if (fourFonts.italic) {
      fourVariants.push("1," + fourFonts.italic);
    }
    if (fourFonts.boldItalic) {
      fourVariants.push("1," + fourFonts.boldItalic);
    }
    return fourVariants;
  };
  const defaultCurrent = getFontByName(saneDefaultValue) || defaultFont;
  const [current, setCurrentState] = useState(defaultCurrent);
  handleLoadFont();
  useEffect(() => {
    setCurrent(defaultCurrent);
  }, [defaultCurrent]);
  useEffect(() => {
    function callCheckLoaded(fontNames) {
      return __async(this, null, function* () {
        try {
          const promises = fontNames == null ? void 0 : fontNames.map((font) => __async(this, null, function* () {
            try {
              const fontLoaded = yield checkLoaded({
                fontFamily: font,
                timeout: fontsLoadedTimeout
              });
              return fontLoaded;
            } catch (e) {
              return false;
            }
          }));
          const results = yield Promise.all(promises);
          const allLoaded = !results.some((res) => !res);
          emitFontLoaded(allLoaded);
        } catch (e) {
          console.error(`Exception thrown checking if font families loaded`);
          console.error(e);
          emitFontLoaded(false);
        }
      });
    }
    const fontsToCheck = [.../* @__PURE__ */ new Set([current.name, ...loadFontsFontNames])];
    if (fontsLoaded) {
      callCheckLoaded(fontsToCheck);
    }
  }, [autoLoad, loadFonts, current.name, emitFontLoaded, fontsLoaded, loadFontsFontNames, fontsLoadedTimeout]);
  const renderFontOption = (font, i) => {
    return /* @__PURE__ */ jsx2(
      "div",
      {
        ref: saveOptionsRef(font.sane),
        className: "fontpicker__option" + (i === selectedFontIndex ? " selected" : "") + (i === currentFontIndex ? " current" : ""),
        onMouseDown: () => onClick(font),
        onMouseMove: () => {
          setSelectedFontIndex(i);
        },
        role: "option",
        children: /* @__PURE__ */ jsx2("div", { className: "font-preview-" + font.sane })
      },
      font.sane + i
    );
  };
  return /* @__PURE__ */ jsx2(Fragment2, { children: !loaderOnly && /* @__PURE__ */ jsx2("div", __spreadProps(__spreadValues({ className: (_a2 = outerClasses()) == null ? void 0 : _a2.join(" ") }, rest), { children: /* @__PURE__ */ jsxs(Suspense, { fallback: /* @__PURE__ */ jsx2(Fragment2, { children: loading }), children: [
    /* @__PURE__ */ jsx2(FontPreviews2, {}),
    mode === "list" ? /* @__PURE__ */ jsx2(
      "div",
      {
        className: "fontpicker__listbox",
        role: "listbox",
        tabIndex: 0,
        onKeyDown: onKeyDownList,
        children: fonts.map((font, i) => renderFontOption(font, i))
      }
    ) : /* @__PURE__ */ jsxs(Fragment2, { children: [
      /* @__PURE__ */ jsx2("div", { ref: previewRef, className: (_b2 = previewClasses()) == null ? void 0 : _b2.join(" ") }),
      /* @__PURE__ */ jsx2(
        "input",
        {
          id: inputId,
          className: "fontpicker__search",
          ref: inputRef,
          type: "text",
          onInput: searchChanged,
          onFocus,
          onBlur: hide,
          onKeyDown,
          value: searchContent
        }
      ),
      /* @__PURE__ */ jsxs(
        "div",
        {
          ref: popoutRef,
          tabIndex: -1,
          className: (_c = popoutClasses()) == null ? void 0 : _c.join(" "),
          onMouseDown: cancelBlur,
          role: "listbox",
          children: [
            matchingFonts.map((font, i) => renderFontOption(font, i)),
            matchingFonts.length === 0 && /* @__PURE__ */ jsx2("div", { className: "fontpicker__nomatches", children: noMatches })
          ]
        }
      )
    ] })
  ] }) })) });
}
export {
  FontPicker as default,
  toString
};
//# sourceMappingURL=index.mjs.map